/* eslint-disable */
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  jsonb: any;
  numeric: any;
  timestamptz: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'attachment';
  blob?: Maybe<Scalars['String']>;
  caseReportId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  casesByFeedcurveattachmentid: Array<Case>;
  /** An aggregate relationship */
  casesByFeedcurveattachmentid_aggregate: Case_Aggregate;
  /** An array relationship */
  casesByFlowsheetattachmentid: Array<Case>;
  /** An aggregate relationship */
  casesByFlowsheetattachmentid_aggregate: Case_Aggregate;
  /** An array relationship */
  casesByPowerdrawattachmentid: Array<Case>;
  /** An aggregate relationship */
  casesByPowerdrawattachmentid_aggregate: Case_Aggregate;
  /** An array relationship */
  casesByPressureattachmentid: Array<Case>;
  /** An aggregate relationship */
  casesByPressureattachmentid_aggregate: Case_Aggregate;
  /** An array relationship */
  casesByThroughputattachmentid: Array<Case>;
  /** An aggregate relationship */
  casesByThroughputattachmentid_aggregate: Case_Aggregate;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Int']>;
  container?: Maybe<Scalars['String']>;
  feedCurveId?: Maybe<Scalars['Int']>;
  flowsheetId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id: Scalars['Int'];
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  originalname?: Maybe<Scalars['String']>;
  pistonPressureId?: Maybe<Scalars['Int']>;
  powerDrawId?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['numeric']>;
  throughputId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Attachment */
export type AttachmentCasesByFeedcurveattachmentidArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByFeedcurveattachmentid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByFlowsheetattachmentidArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByFlowsheetattachmentid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByPowerdrawattachmentidArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByPowerdrawattachmentid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByPressureattachmentidArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByPressureattachmentid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByThroughputattachmentidArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Attachment */
export type AttachmentCasesByThroughputattachmentid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** aggregated selection of "attachment" */
export type Attachment_Aggregate = {
  __typename?: 'attachment_aggregate';
  aggregate?: Maybe<Attachment_Aggregate_Fields>;
  nodes: Array<Attachment>;
};

export type Attachment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Attachment_Aggregate_Bool_Exp_Count>;
};

export type Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attachment" */
export type Attachment_Aggregate_Fields = {
  __typename?: 'attachment_aggregate_fields';
  avg?: Maybe<Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Attachment_Max_Fields>;
  min?: Maybe<Attachment_Min_Fields>;
  stddev?: Maybe<Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Attachment_Sum_Fields>;
  var_pop?: Maybe<Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Attachment_Var_Samp_Fields>;
  variance?: Maybe<Attachment_Variance_Fields>;
};

/** aggregate fields of "attachment" */
export type Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "attachment" */
export type Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Attachment_Max_Order_By>;
  min?: InputMaybe<Attachment_Min_Order_By>;
  stddev?: InputMaybe<Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attachment" */
export type Attachment_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Attachment_Avg_Fields = {
  __typename?: 'attachment_avg_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "attachment" */
export type Attachment_Avg_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attachment". All fields are combined with a logical 'AND'. */
export type Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Attachment_Bool_Exp>>;
  _not?: InputMaybe<Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Attachment_Bool_Exp>>;
  blob?: InputMaybe<String_Comparison_Exp>;
  caseReportId?: InputMaybe<Int_Comparison_Exp>;
  casesByFeedcurveattachmentid?: InputMaybe<Case_Bool_Exp>;
  casesByFeedcurveattachmentid_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  casesByFlowsheetattachmentid?: InputMaybe<Case_Bool_Exp>;
  casesByFlowsheetattachmentid_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  casesByPowerdrawattachmentid?: InputMaybe<Case_Bool_Exp>;
  casesByPowerdrawattachmentid_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  casesByPressureattachmentid?: InputMaybe<Case_Bool_Exp>;
  casesByPressureattachmentid_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  casesByThroughputattachmentid?: InputMaybe<Case_Bool_Exp>;
  casesByThroughputattachmentid_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  concaveNewSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  concaveSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  container?: InputMaybe<String_Comparison_Exp>;
  feedCurveId?: InputMaybe<Int_Comparison_Exp>;
  flowsheetId?: InputMaybe<Int_Comparison_Exp>;
  followUpId?: InputMaybe<Int_Comparison_Exp>;
  generalNewSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  generalSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mantleNewSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  mantleSolutionAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  mimetype?: InputMaybe<String_Comparison_Exp>;
  originalname?: InputMaybe<String_Comparison_Exp>;
  pistonPressureId?: InputMaybe<Int_Comparison_Exp>;
  powerDrawId?: InputMaybe<Int_Comparison_Exp>;
  size?: InputMaybe<Numeric_Comparison_Exp>;
  throughputId?: InputMaybe<Int_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "attachment" */
export enum Attachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttachmentPkey = 'attachment_pkey',
}

/** input type for incrementing numeric columns in table "attachment" */
export type Attachment_Inc_Input = {
  caseReportId?: InputMaybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  feedCurveId?: InputMaybe<Scalars['Int']>;
  flowsheetId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  generalSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  pistonPressureId?: InputMaybe<Scalars['Int']>;
  powerDrawId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['numeric']>;
  throughputId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "attachment" */
export type Attachment_Insert_Input = {
  blob?: InputMaybe<Scalars['String']>;
  caseReportId?: InputMaybe<Scalars['Int']>;
  casesByFeedcurveattachmentid?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  casesByFlowsheetattachmentid?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  casesByPowerdrawattachmentid?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  casesByPressureattachmentid?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  casesByThroughputattachmentid?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  concaveNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  container?: InputMaybe<Scalars['String']>;
  feedCurveId?: InputMaybe<Scalars['Int']>;
  flowsheetId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  generalSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mimetype?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  pistonPressureId?: InputMaybe<Scalars['Int']>;
  powerDrawId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['numeric']>;
  throughputId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Attachment_Max_Fields = {
  __typename?: 'attachment_max_fields';
  blob?: Maybe<Scalars['String']>;
  caseReportId?: Maybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Int']>;
  container?: Maybe<Scalars['String']>;
  feedCurveId?: Maybe<Scalars['Int']>;
  flowsheetId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  originalname?: Maybe<Scalars['String']>;
  pistonPressureId?: Maybe<Scalars['Int']>;
  powerDrawId?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['numeric']>;
  throughputId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "attachment" */
export type Attachment_Max_Order_By = {
  blob?: InputMaybe<Order_By>;
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  container?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
  originalname?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Attachment_Min_Fields = {
  __typename?: 'attachment_min_fields';
  blob?: Maybe<Scalars['String']>;
  caseReportId?: Maybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Int']>;
  container?: Maybe<Scalars['String']>;
  feedCurveId?: Maybe<Scalars['Int']>;
  flowsheetId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  originalname?: Maybe<Scalars['String']>;
  pistonPressureId?: Maybe<Scalars['Int']>;
  powerDrawId?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['numeric']>;
  throughputId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "attachment" */
export type Attachment_Min_Order_By = {
  blob?: InputMaybe<Order_By>;
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  container?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
  originalname?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attachment" */
export type Attachment_Mutation_Response = {
  __typename?: 'attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Attachment>;
};

/** input type for inserting object relation for remote table "attachment" */
export type Attachment_Obj_Rel_Insert_Input = {
  data: Attachment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};

/** on_conflict condition type for table "attachment" */
export type Attachment_On_Conflict = {
  constraint: Attachment_Constraint;
  update_columns?: Array<Attachment_Update_Column>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "attachment". */
export type Attachment_Order_By = {
  blob?: InputMaybe<Order_By>;
  caseReportId?: InputMaybe<Order_By>;
  casesByFeedcurveattachmentid_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  casesByFlowsheetattachmentid_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  casesByPowerdrawattachmentid_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  casesByPressureattachmentid_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  casesByThroughputattachmentid_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  container?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
  originalname?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attachment */
export type Attachment_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "attachment" */
export enum Attachment_Select_Column {
  /** column name */
  Blob = 'blob',
  /** column name */
  CaseReportId = 'caseReportId',
  /** column name */
  ConcaveNewSolutionAttachmentId = 'concaveNewSolutionAttachmentId',
  /** column name */
  ConcaveSolutionAttachmentId = 'concaveSolutionAttachmentId',
  /** column name */
  Container = 'container',
  /** column name */
  FeedCurveId = 'feedCurveId',
  /** column name */
  FlowsheetId = 'flowsheetId',
  /** column name */
  FollowUpId = 'followUpId',
  /** column name */
  GeneralNewSolutionAttachmentId = 'generalNewSolutionAttachmentId',
  /** column name */
  GeneralSolutionAttachmentId = 'generalSolutionAttachmentId',
  /** column name */
  Id = 'id',
  /** column name */
  MantleNewSolutionAttachmentId = 'mantleNewSolutionAttachmentId',
  /** column name */
  MantleSolutionAttachmentId = 'mantleSolutionAttachmentId',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Originalname = 'originalname',
  /** column name */
  PistonPressureId = 'pistonPressureId',
  /** column name */
  PowerDrawId = 'powerDrawId',
  /** column name */
  Size = 'size',
  /** column name */
  ThroughputId = 'throughputId',
  /** column name */
  Url = 'url',
}

/** input type for updating data in table "attachment" */
export type Attachment_Set_Input = {
  blob?: InputMaybe<Scalars['String']>;
  caseReportId?: InputMaybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  container?: InputMaybe<Scalars['String']>;
  feedCurveId?: InputMaybe<Scalars['Int']>;
  flowsheetId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  generalSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mimetype?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  pistonPressureId?: InputMaybe<Scalars['Int']>;
  powerDrawId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['numeric']>;
  throughputId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Attachment_Stddev_Fields = {
  __typename?: 'attachment_stddev_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "attachment" */
export type Attachment_Stddev_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Attachment_Stddev_Pop_Fields = {
  __typename?: 'attachment_stddev_pop_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "attachment" */
export type Attachment_Stddev_Pop_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Attachment_Stddev_Samp_Fields = {
  __typename?: 'attachment_stddev_samp_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "attachment" */
export type Attachment_Stddev_Samp_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attachment" */
export type Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attachment_Stream_Cursor_Value_Input = {
  blob?: InputMaybe<Scalars['String']>;
  caseReportId?: InputMaybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  container?: InputMaybe<Scalars['String']>;
  feedCurveId?: InputMaybe<Scalars['Int']>;
  flowsheetId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  generalSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: InputMaybe<Scalars['Int']>;
  mimetype?: InputMaybe<Scalars['String']>;
  originalname?: InputMaybe<Scalars['String']>;
  pistonPressureId?: InputMaybe<Scalars['Int']>;
  powerDrawId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['numeric']>;
  throughputId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Attachment_Sum_Fields = {
  __typename?: 'attachment_sum_fields';
  caseReportId?: Maybe<Scalars['Int']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Int']>;
  feedCurveId?: Maybe<Scalars['Int']>;
  flowsheetId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Int']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Int']>;
  pistonPressureId?: Maybe<Scalars['Int']>;
  powerDrawId?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['numeric']>;
  throughputId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "attachment" */
export type Attachment_Sum_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** update columns of table "attachment" */
export enum Attachment_Update_Column {
  /** column name */
  Blob = 'blob',
  /** column name */
  CaseReportId = 'caseReportId',
  /** column name */
  ConcaveNewSolutionAttachmentId = 'concaveNewSolutionAttachmentId',
  /** column name */
  ConcaveSolutionAttachmentId = 'concaveSolutionAttachmentId',
  /** column name */
  Container = 'container',
  /** column name */
  FeedCurveId = 'feedCurveId',
  /** column name */
  FlowsheetId = 'flowsheetId',
  /** column name */
  FollowUpId = 'followUpId',
  /** column name */
  GeneralNewSolutionAttachmentId = 'generalNewSolutionAttachmentId',
  /** column name */
  GeneralSolutionAttachmentId = 'generalSolutionAttachmentId',
  /** column name */
  Id = 'id',
  /** column name */
  MantleNewSolutionAttachmentId = 'mantleNewSolutionAttachmentId',
  /** column name */
  MantleSolutionAttachmentId = 'mantleSolutionAttachmentId',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Originalname = 'originalname',
  /** column name */
  PistonPressureId = 'pistonPressureId',
  /** column name */
  PowerDrawId = 'powerDrawId',
  /** column name */
  Size = 'size',
  /** column name */
  ThroughputId = 'throughputId',
  /** column name */
  Url = 'url',
}

export type Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Attachment_Var_Pop_Fields = {
  __typename?: 'attachment_var_pop_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "attachment" */
export type Attachment_Var_Pop_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Attachment_Var_Samp_Fields = {
  __typename?: 'attachment_var_samp_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "attachment" */
export type Attachment_Var_Samp_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Attachment_Variance_Fields = {
  __typename?: 'attachment_variance_fields';
  caseReportId?: Maybe<Scalars['Float']>;
  concaveNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  concaveSolutionAttachmentId?: Maybe<Scalars['Float']>;
  feedCurveId?: Maybe<Scalars['Float']>;
  flowsheetId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  generalNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  generalSolutionAttachmentId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  mantleNewSolutionAttachmentId?: Maybe<Scalars['Float']>;
  mantleSolutionAttachmentId?: Maybe<Scalars['Float']>;
  pistonPressureId?: Maybe<Scalars['Float']>;
  powerDrawId?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  throughputId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "attachment" */
export type Attachment_Variance_Order_By = {
  caseReportId?: InputMaybe<Order_By>;
  concaveNewSolutionAttachmentId?: InputMaybe<Order_By>;
  concaveSolutionAttachmentId?: InputMaybe<Order_By>;
  feedCurveId?: InputMaybe<Order_By>;
  flowsheetId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachmentId?: InputMaybe<Order_By>;
  generalSolutionAttachmentId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  mantleNewSolutionAttachmentId?: InputMaybe<Order_By>;
  mantleSolutionAttachmentId?: InputMaybe<Order_By>;
  pistonPressureId?: InputMaybe<Order_By>;
  powerDrawId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  throughputId?: InputMaybe<Order_By>;
};

/** Case */
export type Case = {
  __typename?: 'case';
  additionalAttachmentInformation?: Maybe<Scalars['String']>;
  additionalBasicInformation?: Maybe<Scalars['String']>;
  additionalChamberInformation?: Maybe<Scalars['String']>;
  additionalCrusherInformation?: Maybe<Scalars['String']>;
  additionalFeedInformation?: Maybe<Scalars['String']>;
  annualCrushingLineCapacity?: Maybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Int']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Int']>;
  /** An array relationship */
  caseReportAttachments: Array<Attachment>;
  /** An aggregate relationship */
  caseReportAttachments_aggregate: Attachment_Aggregate;
  /** An object relationship */
  caseStatus?: Maybe<CaseStatus>;
  chokeFeed?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  concaveNewSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  concaveNewSolutionAttachments_aggregate: Attachment_Aggregate;
  /** An array relationship */
  concaveSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  concaveSolutionAttachments_aggregate: Attachment_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** Crusher additional information */
  crusherAdditionalInfo?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: Maybe<Scalars['String']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['numeric']>;
  crusherForceOverload?: Maybe<Scalars['Boolean']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: Maybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['numeric']>;
  crusherRatedPower?: Maybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: Maybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: Maybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer?: Maybe<Customer>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Int']>;
  dueDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  expert?: Maybe<User>;
  expertConfirmed: Scalars['Boolean'];
  expertId?: Maybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  feedCurveAttachment?: Maybe<Attachment>;
  feedCurveAttachmentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  feedCurveAttachments: Array<Attachment>;
  /** An aggregate relationship */
  feedCurveAttachments_aggregate: Attachment_Aggregate;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Int']>;
  feedMaxSize?: Maybe<Scalars['Int']>;
  feedMethod?: Maybe<Scalars['String']>;
  feedMinSize?: Maybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['numeric']>;
  /** Crusher on/off */
  feedOn?: Maybe<Scalars['Boolean']>;
  feedOreType?: Maybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: Maybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  flowsheetAttachment?: Maybe<Attachment>;
  flowsheetAttachmentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  flowsheetAttachments: Array<Attachment>;
  /** An aggregate relationship */
  flowsheetAttachments_aggregate: Attachment_Aggregate;
  /** An object relationship */
  followUp?: Maybe<FollowUp>;
  followUpId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  generalNewSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  generalNewSolutionAttachments_aggregate: Attachment_Aggregate;
  /** An array relationship */
  generalSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  generalSolutionAttachments_aggregate: Attachment_Aggregate;
  /** An object relationship */
  grinding?: Maybe<Grinding>;
  grindingId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id: Scalars['Int'];
  improvementTargets?: Maybe<Scalars['jsonb']>;
  improvementTargetsAdditionalInfo?: Maybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: Maybe<Scalars['String']>;
  improvementTargetsOtherInfo?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  lastEditedBy?: Maybe<User>;
  lastEditedByUserId?: Maybe<Scalars['String']>;
  /** An array relationship */
  mantleNewSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  mantleNewSolutionAttachments_aggregate: Attachment_Aggregate;
  /** An array relationship */
  mantleSolutionAttachments: Array<Attachment>;
  /** An aggregate relationship */
  mantleSolutionAttachments_aggregate: Attachment_Aggregate;
  metric?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  miningProducts: Array<MiningProduct>;
  /** An aggregate relationship */
  miningProducts_aggregate: MiningProduct_Aggregate;
  /** Name of the case */
  name?: Maybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['numeric']>;
  ownerUserId?: Maybe<Scalars['String']>;
  /** An array relationship */
  partSets: Array<PartSet>;
  /** An aggregate relationship */
  partSets_aggregate: PartSet_Aggregate;
  phase?: Maybe<Scalars['String']>;
  /** An object relationship */
  pistonPressureAttachment?: Maybe<Attachment>;
  pistonPressureAttachmentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  pistonPressureAttachments: Array<Attachment>;
  /** An aggregate relationship */
  pistonPressureAttachments_aggregate: Attachment_Aggregate;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  powerDrawAttachment?: Maybe<Attachment>;
  powerDrawAttachmentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  powerDrawAttachments: Array<Attachment>;
  /** An aggregate relationship */
  powerDrawAttachments_aggregate: Attachment_Aggregate;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  /** Ringbounce */
  ringbounce?: Maybe<Scalars['Boolean']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: Maybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: Maybe<Scalars['String']>;
  salesforceOpportunityNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  settings?: Maybe<Settings>;
  settingsId?: Maybe<Scalars['Int']>;
  status?: Maybe<CaseStatus_Enum>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: Maybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Int']>;
  /** An object relationship */
  throughputAttachment?: Maybe<Attachment>;
  throughputAttachmentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  throughputAttachments: Array<Attachment>;
  /** An aggregate relationship */
  throughputAttachments_aggregate: Attachment_Aggregate;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** Case */
export type CaseCaseReportAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseCaseReportAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseConcaveNewSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseConcaveNewSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseConcaveSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseConcaveSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseFeedCurveAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseFeedCurveAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseFlowsheetAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseFlowsheetAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseGeneralNewSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseGeneralNewSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseGeneralSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseGeneralSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseImprovementTargetsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Case */
export type CaseImprovementTargetsOtherInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Case */
export type CaseMantleNewSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseMantleNewSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseMantleSolutionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseMantleSolutionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseMiningProductsArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

/** Case */
export type CaseMiningProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

/** Case */
export type CasePartSetsArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

/** Case */
export type CasePartSets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

/** Case */
export type CasePistonPressureAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CasePistonPressureAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CasePowerDrawAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CasePowerDrawAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseThroughputAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Case */
export type CaseThroughputAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** columns and relationships of "caseStatus" */
export type CaseStatus = {
  __typename?: 'caseStatus';
  name: Scalars['String'];
};

/** aggregated selection of "caseStatus" */
export type CaseStatus_Aggregate = {
  __typename?: 'caseStatus_aggregate';
  aggregate?: Maybe<CaseStatus_Aggregate_Fields>;
  nodes: Array<CaseStatus>;
};

/** aggregate fields of "caseStatus" */
export type CaseStatus_Aggregate_Fields = {
  __typename?: 'caseStatus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CaseStatus_Max_Fields>;
  min?: Maybe<CaseStatus_Min_Fields>;
};

/** aggregate fields of "caseStatus" */
export type CaseStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CaseStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "caseStatus". All fields are combined with a logical 'AND'. */
export type CaseStatus_Bool_Exp = {
  _and?: InputMaybe<Array<CaseStatus_Bool_Exp>>;
  _not?: InputMaybe<CaseStatus_Bool_Exp>;
  _or?: InputMaybe<Array<CaseStatus_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "caseStatus" */
export enum CaseStatus_Constraint {
  /** unique or primary key constraint on columns "name" */
  CaseStatusPkey = 'caseStatus_pkey',
}

export enum CaseStatus_Enum {
  Analysis = 'analysis',
  Closed = 'closed',
  DataCollection = 'dataCollection',
  FollowUp = 'followUp',
  MarketReview = 'marketReview',
  ValueStudy = 'valueStudy',
}

/** Boolean expression to compare columns of type "caseStatus_enum". All fields are combined with logical 'AND'. */
export type CaseStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<CaseStatus_Enum>;
  _in?: InputMaybe<Array<CaseStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CaseStatus_Enum>;
  _nin?: InputMaybe<Array<CaseStatus_Enum>>;
};

/** input type for inserting data into table "caseStatus" */
export type CaseStatus_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CaseStatus_Max_Fields = {
  __typename?: 'caseStatus_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CaseStatus_Min_Fields = {
  __typename?: 'caseStatus_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "caseStatus" */
export type CaseStatus_Mutation_Response = {
  __typename?: 'caseStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CaseStatus>;
};

/** input type for inserting object relation for remote table "caseStatus" */
export type CaseStatus_Obj_Rel_Insert_Input = {
  data: CaseStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CaseStatus_On_Conflict>;
};

/** on_conflict condition type for table "caseStatus" */
export type CaseStatus_On_Conflict = {
  constraint: CaseStatus_Constraint;
  update_columns?: Array<CaseStatus_Update_Column>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "caseStatus". */
export type CaseStatus_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: caseStatus */
export type CaseStatus_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "caseStatus" */
export enum CaseStatus_Select_Column {
  /** column name */
  Name = 'name',
}

/** input type for updating data in table "caseStatus" */
export type CaseStatus_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "caseStatus" */
export type CaseStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CaseStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CaseStatus_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "caseStatus" */
export enum CaseStatus_Update_Column {
  /** column name */
  Name = 'name',
}

export type CaseStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CaseStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: CaseStatus_Bool_Exp;
};

/** aggregated selection of "case" */
export type Case_Aggregate = {
  __typename?: 'case_aggregate';
  aggregate?: Maybe<Case_Aggregate_Fields>;
  nodes: Array<Case>;
};

export type Case_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Case_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Case_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Case_Aggregate_Bool_Exp_Count>;
};

export type Case_Aggregate_Bool_Exp_Bool_And = {
  arguments: Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case" */
export type Case_Aggregate_Fields = {
  __typename?: 'case_aggregate_fields';
  avg?: Maybe<Case_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Case_Max_Fields>;
  min?: Maybe<Case_Min_Fields>;
  stddev?: Maybe<Case_Stddev_Fields>;
  stddev_pop?: Maybe<Case_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Case_Stddev_Samp_Fields>;
  sum?: Maybe<Case_Sum_Fields>;
  var_pop?: Maybe<Case_Var_Pop_Fields>;
  var_samp?: Maybe<Case_Var_Samp_Fields>;
  variance?: Maybe<Case_Variance_Fields>;
};

/** aggregate fields of "case" */
export type Case_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "case" */
export type Case_Aggregate_Order_By = {
  avg?: InputMaybe<Case_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Max_Order_By>;
  min?: InputMaybe<Case_Min_Order_By>;
  stddev?: InputMaybe<Case_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Case_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Case_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Case_Sum_Order_By>;
  var_pop?: InputMaybe<Case_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Case_Var_Samp_Order_By>;
  variance?: InputMaybe<Case_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Case_Append_Input = {
  improvementTargets?: InputMaybe<Scalars['jsonb']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "case" */
export type Case_Arr_Rel_Insert_Input = {
  data: Array<Case_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** aggregate avg on columns */
export type Case_Avg_Fields = {
  __typename?: 'case_avg_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "case" */
export type Case_Avg_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "case". All fields are combined with a logical 'AND'. */
export type Case_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Bool_Exp>>;
  _not?: InputMaybe<Case_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Bool_Exp>>;
  additionalAttachmentInformation?: InputMaybe<String_Comparison_Exp>;
  additionalBasicInformation?: InputMaybe<String_Comparison_Exp>;
  additionalChamberInformation?: InputMaybe<String_Comparison_Exp>;
  additionalCrusherInformation?: InputMaybe<String_Comparison_Exp>;
  additionalFeedInformation?: InputMaybe<String_Comparison_Exp>;
  annualCrushingLineCapacity?: InputMaybe<Numeric_Comparison_Exp>;
  annualWearConsumptionMachine?: InputMaybe<Int_Comparison_Exp>;
  annualWearConsumptionProcess?: InputMaybe<Int_Comparison_Exp>;
  caseReportAttachments?: InputMaybe<Attachment_Bool_Exp>;
  caseReportAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  caseStatus?: InputMaybe<CaseStatus_Bool_Exp>;
  chokeFeed?: InputMaybe<Boolean_Comparison_Exp>;
  concaveNewSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  concaveNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  concaveSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  concaveSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  crusherAdditionalInfo?: InputMaybe<String_Comparison_Exp>;
  crusherCavityMaterial?: InputMaybe<String_Comparison_Exp>;
  crusherCavityType?: InputMaybe<String_Comparison_Exp>;
  crusherCounterShaftSpeed?: InputMaybe<Numeric_Comparison_Exp>;
  crusherCss?: InputMaybe<Numeric_Comparison_Exp>;
  crusherForceOverload?: InputMaybe<Boolean_Comparison_Exp>;
  crusherGrading?: InputMaybe<Int_Comparison_Exp>;
  crusherLifetimeConcave?: InputMaybe<Int_Comparison_Exp>;
  crusherLifetimeMantle?: InputMaybe<Int_Comparison_Exp>;
  crusherModel?: InputMaybe<String_Comparison_Exp>;
  crusherOss?: InputMaybe<Numeric_Comparison_Exp>;
  crusherRatedPower?: InputMaybe<Numeric_Comparison_Exp>;
  crusherSerialNumber?: InputMaybe<String_Comparison_Exp>;
  crusherSpeed?: InputMaybe<Numeric_Comparison_Exp>;
  crusherStroke?: InputMaybe<Numeric_Comparison_Exp>;
  crusherThroughput?: InputMaybe<Int_Comparison_Exp>;
  crusherType?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  customerId?: InputMaybe<Int_Comparison_Exp>;
  dueDate?: InputMaybe<Date_Comparison_Exp>;
  expert?: InputMaybe<User_Bool_Exp>;
  expertConfirmed?: InputMaybe<Boolean_Comparison_Exp>;
  expertId?: InputMaybe<Int_Comparison_Exp>;
  feedAbrasiveness?: InputMaybe<Numeric_Comparison_Exp>;
  feedCrushabilityPercent?: InputMaybe<Numeric_Comparison_Exp>;
  feedCurveAttachment?: InputMaybe<Attachment_Bool_Exp>;
  feedCurveAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  feedCurveAttachments?: InputMaybe<Attachment_Bool_Exp>;
  feedCurveAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  feedGradingMaxSize?: InputMaybe<Int_Comparison_Exp>;
  feedGradingMinSize?: InputMaybe<Int_Comparison_Exp>;
  feedMaxSize?: InputMaybe<Int_Comparison_Exp>;
  feedMethod?: InputMaybe<String_Comparison_Exp>;
  feedMinSize?: InputMaybe<Int_Comparison_Exp>;
  feedMoisturePercent?: InputMaybe<Numeric_Comparison_Exp>;
  feedOn?: InputMaybe<Boolean_Comparison_Exp>;
  feedOreType?: InputMaybe<String_Comparison_Exp>;
  feedRockTestId?: InputMaybe<String_Comparison_Exp>;
  feedSolidDensity?: InputMaybe<Numeric_Comparison_Exp>;
  flowsheetAttachment?: InputMaybe<Attachment_Bool_Exp>;
  flowsheetAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  flowsheetAttachments?: InputMaybe<Attachment_Bool_Exp>;
  flowsheetAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  followUp?: InputMaybe<FollowUp_Bool_Exp>;
  followUpId?: InputMaybe<Int_Comparison_Exp>;
  generalNewSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  generalNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  generalSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  generalSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  grinding?: InputMaybe<Grinding_Bool_Exp>;
  grindingId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  improvementTargets?: InputMaybe<Jsonb_Comparison_Exp>;
  improvementTargetsAdditionalInfo?: InputMaybe<String_Comparison_Exp>;
  improvementTargetsCrusherDuty?: InputMaybe<String_Comparison_Exp>;
  improvementTargetsOtherInfo?: InputMaybe<Jsonb_Comparison_Exp>;
  lastEditedBy?: InputMaybe<User_Bool_Exp>;
  lastEditedByUserId?: InputMaybe<String_Comparison_Exp>;
  mantleNewSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  mantleNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  mantleSolutionAttachments?: InputMaybe<Attachment_Bool_Exp>;
  mantleSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  metric?: InputMaybe<Boolean_Comparison_Exp>;
  miningProducts?: InputMaybe<MiningProduct_Bool_Exp>;
  miningProducts_aggregate?: InputMaybe<MiningProduct_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfCrushers?: InputMaybe<Int_Comparison_Exp>;
  operatingDaysPerYear?: InputMaybe<Numeric_Comparison_Exp>;
  operatingHoursPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  operatingHoursPerYear?: InputMaybe<Int_Comparison_Exp>;
  operatingProfit?: InputMaybe<Numeric_Comparison_Exp>;
  ownerUserId?: InputMaybe<String_Comparison_Exp>;
  partSets?: InputMaybe<PartSet_Bool_Exp>;
  partSets_aggregate?: InputMaybe<PartSet_Aggregate_Bool_Exp>;
  phase?: InputMaybe<String_Comparison_Exp>;
  pistonPressureAttachment?: InputMaybe<Attachment_Bool_Exp>;
  pistonPressureAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  pistonPressureAttachments?: InputMaybe<Attachment_Bool_Exp>;
  pistonPressureAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  pistonPressureAvg?: InputMaybe<Numeric_Comparison_Exp>;
  pistonPressurePeak?: InputMaybe<Numeric_Comparison_Exp>;
  powerDrawAttachment?: InputMaybe<Attachment_Bool_Exp>;
  powerDrawAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  powerDrawAttachments?: InputMaybe<Attachment_Bool_Exp>;
  powerDrawAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  powerDrawAvg?: InputMaybe<Numeric_Comparison_Exp>;
  powerDrawPeak?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  ringbounce?: InputMaybe<Boolean_Comparison_Exp>;
  ringbounceAdditionalInfo?: InputMaybe<String_Comparison_Exp>;
  rockType?: InputMaybe<String_Comparison_Exp>;
  salesforceOpportunityNumber?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Settings_Bool_Exp>;
  settingsId?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<CaseStatus_Enum_Comparison_Exp>;
  targetMax?: InputMaybe<Int_Comparison_Exp>;
  targetMin?: InputMaybe<Int_Comparison_Exp>;
  targetOther?: InputMaybe<String_Comparison_Exp>;
  targetThroughput?: InputMaybe<Int_Comparison_Exp>;
  throughputAttachment?: InputMaybe<Attachment_Bool_Exp>;
  throughputAttachmentId?: InputMaybe<Int_Comparison_Exp>;
  throughputAttachments?: InputMaybe<Attachment_Bool_Exp>;
  throughputAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  throughputAvg?: InputMaybe<Numeric_Comparison_Exp>;
  throughputPeak?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "case" */
export enum Case_Constraint {
  /** unique or primary key constraint on columns "id" */
  CasePkey = 'case_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Case_Delete_At_Path_Input = {
  improvementTargets?: InputMaybe<Array<Scalars['String']>>;
  improvementTargetsOtherInfo?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Case_Delete_Elem_Input = {
  improvementTargets?: InputMaybe<Scalars['Int']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Case_Delete_Key_Input = {
  improvementTargets?: InputMaybe<Scalars['String']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "case" */
export type Case_Inc_Input = {
  annualCrushingLineCapacity?: InputMaybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: InputMaybe<Scalars['Int']>;
  annualWearConsumptionProcess?: InputMaybe<Scalars['Int']>;
  crusherCounterShaftSpeed?: InputMaybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Scalars['numeric']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Scalars['Int']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Scalars['numeric']>;
  crusherRatedPower?: InputMaybe<Scalars['numeric']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Scalars['Int']>;
  /** The customerId of an object */
  customerId?: InputMaybe<Scalars['Int']>;
  expertId?: InputMaybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Scalars['numeric']>;
  feedCurveAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Scalars['Int']>;
  feedMaxSize?: InputMaybe<Scalars['Int']>;
  feedMinSize?: InputMaybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Scalars['numeric']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Scalars['numeric']>;
  flowsheetAttachmentId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  grindingId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Scalars['numeric']>;
  pistonPressureAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Scalars['numeric']>;
  powerDrawAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Scalars['numeric']>;
  settingsId?: InputMaybe<Scalars['Int']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Scalars['Int']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Scalars['Int']>;
  throughputAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "case" */
export type Case_Insert_Input = {
  additionalAttachmentInformation?: InputMaybe<Scalars['String']>;
  additionalBasicInformation?: InputMaybe<Scalars['String']>;
  additionalChamberInformation?: InputMaybe<Scalars['String']>;
  additionalCrusherInformation?: InputMaybe<Scalars['String']>;
  additionalFeedInformation?: InputMaybe<Scalars['String']>;
  annualCrushingLineCapacity?: InputMaybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: InputMaybe<Scalars['Int']>;
  annualWearConsumptionProcess?: InputMaybe<Scalars['Int']>;
  caseReportAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  caseStatus?: InputMaybe<CaseStatus_Obj_Rel_Insert_Input>;
  chokeFeed?: InputMaybe<Scalars['Boolean']>;
  concaveNewSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  concaveSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Crusher additional information */
  crusherAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: InputMaybe<Scalars['String']>;
  crusherCounterShaftSpeed?: InputMaybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Scalars['numeric']>;
  crusherForceOverload?: InputMaybe<Scalars['Boolean']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: InputMaybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Scalars['numeric']>;
  crusherRatedPower?: InputMaybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: InputMaybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: InputMaybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  /** The customerId of an object */
  customerId?: InputMaybe<Scalars['Int']>;
  dueDate?: InputMaybe<Scalars['date']>;
  expert?: InputMaybe<User_Obj_Rel_Insert_Input>;
  expertConfirmed?: InputMaybe<Scalars['Boolean']>;
  expertId?: InputMaybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Scalars['numeric']>;
  feedCurveAttachment?: InputMaybe<Attachment_Obj_Rel_Insert_Input>;
  feedCurveAttachmentId?: InputMaybe<Scalars['Int']>;
  feedCurveAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Scalars['Int']>;
  feedMaxSize?: InputMaybe<Scalars['Int']>;
  feedMethod?: InputMaybe<Scalars['String']>;
  feedMinSize?: InputMaybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Scalars['numeric']>;
  /** Crusher on/off */
  feedOn?: InputMaybe<Scalars['Boolean']>;
  feedOreType?: InputMaybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: InputMaybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Scalars['numeric']>;
  flowsheetAttachment?: InputMaybe<Attachment_Obj_Rel_Insert_Input>;
  flowsheetAttachmentId?: InputMaybe<Scalars['Int']>;
  flowsheetAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  followUp?: InputMaybe<FollowUp_Obj_Rel_Insert_Input>;
  followUpId?: InputMaybe<Scalars['Int']>;
  generalNewSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  generalSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  grinding?: InputMaybe<Grinding_Obj_Rel_Insert_Input>;
  grindingId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  improvementTargets?: InputMaybe<Scalars['jsonb']>;
  improvementTargetsAdditionalInfo?: InputMaybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: InputMaybe<Scalars['String']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['jsonb']>;
  lastEditedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  lastEditedByUserId?: InputMaybe<Scalars['String']>;
  mantleNewSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  mantleSolutionAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  metric?: InputMaybe<Scalars['Boolean']>;
  miningProducts?: InputMaybe<MiningProduct_Arr_Rel_Insert_Input>;
  /** Name of the case */
  name?: InputMaybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Scalars['numeric']>;
  ownerUserId?: InputMaybe<Scalars['String']>;
  partSets?: InputMaybe<PartSet_Arr_Rel_Insert_Input>;
  phase?: InputMaybe<Scalars['String']>;
  pistonPressureAttachment?: InputMaybe<Attachment_Obj_Rel_Insert_Input>;
  pistonPressureAttachmentId?: InputMaybe<Scalars['Int']>;
  pistonPressureAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Scalars['numeric']>;
  powerDrawAttachment?: InputMaybe<Attachment_Obj_Rel_Insert_Input>;
  powerDrawAttachmentId?: InputMaybe<Scalars['Int']>;
  powerDrawAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Scalars['String']>;
  /** Ringbounce */
  ringbounce?: InputMaybe<Scalars['Boolean']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: InputMaybe<Scalars['String']>;
  salesforceOpportunityNumber?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Settings_Obj_Rel_Insert_Input>;
  settingsId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CaseStatus_Enum>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: InputMaybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Scalars['Int']>;
  throughputAttachment?: InputMaybe<Attachment_Obj_Rel_Insert_Input>;
  throughputAttachmentId?: InputMaybe<Scalars['Int']>;
  throughputAttachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Case_Max_Fields = {
  __typename?: 'case_max_fields';
  additionalAttachmentInformation?: Maybe<Scalars['String']>;
  additionalBasicInformation?: Maybe<Scalars['String']>;
  additionalChamberInformation?: Maybe<Scalars['String']>;
  additionalCrusherInformation?: Maybe<Scalars['String']>;
  additionalFeedInformation?: Maybe<Scalars['String']>;
  annualCrushingLineCapacity?: Maybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Int']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Crusher additional information */
  crusherAdditionalInfo?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: Maybe<Scalars['String']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['numeric']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: Maybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['numeric']>;
  crusherRatedPower?: Maybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: Maybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: Maybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: Maybe<Scalars['String']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Int']>;
  dueDate?: Maybe<Scalars['date']>;
  expertId?: Maybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['numeric']>;
  feedCurveAttachmentId?: Maybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Int']>;
  feedMaxSize?: Maybe<Scalars['Int']>;
  feedMethod?: Maybe<Scalars['String']>;
  feedMinSize?: Maybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['numeric']>;
  feedOreType?: Maybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: Maybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['numeric']>;
  flowsheetAttachmentId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  grindingId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  improvementTargetsAdditionalInfo?: Maybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: Maybe<Scalars['String']>;
  lastEditedByUserId?: Maybe<Scalars['String']>;
  /** Name of the case */
  name?: Maybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['numeric']>;
  ownerUserId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['numeric']>;
  powerDrawAttachmentId?: Maybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: Maybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: Maybe<Scalars['String']>;
  salesforceOpportunityNumber?: Maybe<Scalars['String']>;
  settingsId?: Maybe<Scalars['Int']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: Maybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Int']>;
  throughputAttachmentId?: Maybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "case" */
export type Case_Max_Order_By = {
  additionalAttachmentInformation?: InputMaybe<Order_By>;
  additionalBasicInformation?: InputMaybe<Order_By>;
  additionalChamberInformation?: InputMaybe<Order_By>;
  additionalCrusherInformation?: InputMaybe<Order_By>;
  additionalFeedInformation?: InputMaybe<Order_By>;
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** Crusher additional information */
  crusherAdditionalInfo?: InputMaybe<Order_By>;
  /** Not for PG crushers */
  crusherCavityMaterial?: InputMaybe<Order_By>;
  /** Not for PG crushers */
  crusherCavityType?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** Crusher type (eg. PG6089) */
  crusherType?: InputMaybe<Order_By>;
  /** Case currency (eg. USD) */
  currency?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMethod?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  feedOreType?: InputMaybe<Order_By>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  improvementTargetsAdditionalInfo?: InputMaybe<Order_By>;
  improvementTargetsCrusherDuty?: InputMaybe<Order_By>;
  lastEditedByUserId?: InputMaybe<Order_By>;
  /** Name of the case */
  name?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  ownerUserId?: InputMaybe<Order_By>;
  phase?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: InputMaybe<Order_By>;
  /** Rock type name (eg. Copper ore) */
  rockType?: InputMaybe<Order_By>;
  salesforceOpportunityNumber?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Other target description */
  targetOther?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Min_Fields = {
  __typename?: 'case_min_fields';
  additionalAttachmentInformation?: Maybe<Scalars['String']>;
  additionalBasicInformation?: Maybe<Scalars['String']>;
  additionalChamberInformation?: Maybe<Scalars['String']>;
  additionalCrusherInformation?: Maybe<Scalars['String']>;
  additionalFeedInformation?: Maybe<Scalars['String']>;
  annualCrushingLineCapacity?: Maybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Int']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Crusher additional information */
  crusherAdditionalInfo?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: Maybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: Maybe<Scalars['String']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['numeric']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: Maybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['numeric']>;
  crusherRatedPower?: Maybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: Maybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: Maybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: Maybe<Scalars['String']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Int']>;
  dueDate?: Maybe<Scalars['date']>;
  expertId?: Maybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['numeric']>;
  feedCurveAttachmentId?: Maybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Int']>;
  feedMaxSize?: Maybe<Scalars['Int']>;
  feedMethod?: Maybe<Scalars['String']>;
  feedMinSize?: Maybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['numeric']>;
  feedOreType?: Maybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: Maybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['numeric']>;
  flowsheetAttachmentId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  grindingId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  improvementTargetsAdditionalInfo?: Maybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: Maybe<Scalars['String']>;
  lastEditedByUserId?: Maybe<Scalars['String']>;
  /** Name of the case */
  name?: Maybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['numeric']>;
  ownerUserId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['numeric']>;
  powerDrawAttachmentId?: Maybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: Maybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: Maybe<Scalars['String']>;
  salesforceOpportunityNumber?: Maybe<Scalars['String']>;
  settingsId?: Maybe<Scalars['Int']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: Maybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Int']>;
  throughputAttachmentId?: Maybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "case" */
export type Case_Min_Order_By = {
  additionalAttachmentInformation?: InputMaybe<Order_By>;
  additionalBasicInformation?: InputMaybe<Order_By>;
  additionalChamberInformation?: InputMaybe<Order_By>;
  additionalCrusherInformation?: InputMaybe<Order_By>;
  additionalFeedInformation?: InputMaybe<Order_By>;
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** Crusher additional information */
  crusherAdditionalInfo?: InputMaybe<Order_By>;
  /** Not for PG crushers */
  crusherCavityMaterial?: InputMaybe<Order_By>;
  /** Not for PG crushers */
  crusherCavityType?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** Crusher type (eg. PG6089) */
  crusherType?: InputMaybe<Order_By>;
  /** Case currency (eg. USD) */
  currency?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMethod?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  feedOreType?: InputMaybe<Order_By>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  improvementTargetsAdditionalInfo?: InputMaybe<Order_By>;
  improvementTargetsCrusherDuty?: InputMaybe<Order_By>;
  lastEditedByUserId?: InputMaybe<Order_By>;
  /** Name of the case */
  name?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  ownerUserId?: InputMaybe<Order_By>;
  phase?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: InputMaybe<Order_By>;
  /** Rock type name (eg. Copper ore) */
  rockType?: InputMaybe<Order_By>;
  salesforceOpportunityNumber?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Other target description */
  targetOther?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case" */
export type Case_Mutation_Response = {
  __typename?: 'case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Case>;
};

/** input type for inserting object relation for remote table "case" */
export type Case_Obj_Rel_Insert_Input = {
  data: Case_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** on_conflict condition type for table "case" */
export type Case_On_Conflict = {
  constraint: Case_Constraint;
  update_columns?: Array<Case_Update_Column>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Ordering options when selecting data from "case". */
export type Case_Order_By = {
  additionalAttachmentInformation?: InputMaybe<Order_By>;
  additionalBasicInformation?: InputMaybe<Order_By>;
  additionalChamberInformation?: InputMaybe<Order_By>;
  additionalCrusherInformation?: InputMaybe<Order_By>;
  additionalFeedInformation?: InputMaybe<Order_By>;
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  caseReportAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  caseStatus?: InputMaybe<CaseStatus_Order_By>;
  chokeFeed?: InputMaybe<Order_By>;
  concaveNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  concaveSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  crusherAdditionalInfo?: InputMaybe<Order_By>;
  crusherCavityMaterial?: InputMaybe<Order_By>;
  crusherCavityType?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  crusherCss?: InputMaybe<Order_By>;
  crusherForceOverload?: InputMaybe<Order_By>;
  crusherGrading?: InputMaybe<Order_By>;
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  crusherModel?: InputMaybe<Order_By>;
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  crusherSerialNumber?: InputMaybe<Order_By>;
  crusherSpeed?: InputMaybe<Order_By>;
  crusherStroke?: InputMaybe<Order_By>;
  crusherThroughput?: InputMaybe<Order_By>;
  crusherType?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  customerId?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  expert?: InputMaybe<User_Order_By>;
  expertConfirmed?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  feedAbrasiveness?: InputMaybe<Order_By>;
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachment?: InputMaybe<Attachment_Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  feedCurveAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  feedGradingMaxSize?: InputMaybe<Order_By>;
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMethod?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  feedMoisturePercent?: InputMaybe<Order_By>;
  feedOn?: InputMaybe<Order_By>;
  feedOreType?: InputMaybe<Order_By>;
  feedRockTestId?: InputMaybe<Order_By>;
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachment?: InputMaybe<Attachment_Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  flowsheetAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  followUp?: InputMaybe<FollowUp_Order_By>;
  followUpId?: InputMaybe<Order_By>;
  generalNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  generalSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  grinding?: InputMaybe<Grinding_Order_By>;
  grindingId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  improvementTargets?: InputMaybe<Order_By>;
  improvementTargetsAdditionalInfo?: InputMaybe<Order_By>;
  improvementTargetsCrusherDuty?: InputMaybe<Order_By>;
  improvementTargetsOtherInfo?: InputMaybe<Order_By>;
  lastEditedBy?: InputMaybe<User_Order_By>;
  lastEditedByUserId?: InputMaybe<Order_By>;
  mantleNewSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  mantleSolutionAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  metric?: InputMaybe<Order_By>;
  miningProducts_aggregate?: InputMaybe<MiningProduct_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfCrushers?: InputMaybe<Order_By>;
  operatingDaysPerYear?: InputMaybe<Order_By>;
  operatingHoursPerDay?: InputMaybe<Order_By>;
  operatingHoursPerYear?: InputMaybe<Order_By>;
  operatingProfit?: InputMaybe<Order_By>;
  ownerUserId?: InputMaybe<Order_By>;
  partSets_aggregate?: InputMaybe<PartSet_Aggregate_Order_By>;
  phase?: InputMaybe<Order_By>;
  pistonPressureAttachment?: InputMaybe<Attachment_Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  pistonPressureAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  pistonPressureAvg?: InputMaybe<Order_By>;
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachment?: InputMaybe<Attachment_Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  powerDrawAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  powerDrawAvg?: InputMaybe<Order_By>;
  powerDrawPeak?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  ringbounce?: InputMaybe<Order_By>;
  ringbounceAdditionalInfo?: InputMaybe<Order_By>;
  rockType?: InputMaybe<Order_By>;
  salesforceOpportunityNumber?: InputMaybe<Order_By>;
  settings?: InputMaybe<Settings_Order_By>;
  settingsId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  targetMax?: InputMaybe<Order_By>;
  targetMin?: InputMaybe<Order_By>;
  targetOther?: InputMaybe<Order_By>;
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachment?: InputMaybe<Attachment_Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  throughputAttachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  throughputAvg?: InputMaybe<Order_By>;
  throughputPeak?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: case */
export type Case_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Case_Prepend_Input = {
  improvementTargets?: InputMaybe<Scalars['jsonb']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "case" */
export enum Case_Select_Column {
  /** column name */
  AdditionalAttachmentInformation = 'additionalAttachmentInformation',
  /** column name */
  AdditionalBasicInformation = 'additionalBasicInformation',
  /** column name */
  AdditionalChamberInformation = 'additionalChamberInformation',
  /** column name */
  AdditionalCrusherInformation = 'additionalCrusherInformation',
  /** column name */
  AdditionalFeedInformation = 'additionalFeedInformation',
  /** column name */
  AnnualCrushingLineCapacity = 'annualCrushingLineCapacity',
  /** column name */
  AnnualWearConsumptionMachine = 'annualWearConsumptionMachine',
  /** column name */
  AnnualWearConsumptionProcess = 'annualWearConsumptionProcess',
  /** column name */
  ChokeFeed = 'chokeFeed',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CrusherAdditionalInfo = 'crusherAdditionalInfo',
  /** column name */
  CrusherCavityMaterial = 'crusherCavityMaterial',
  /** column name */
  CrusherCavityType = 'crusherCavityType',
  /** column name */
  CrusherCounterShaftSpeed = 'crusherCounterShaftSpeed',
  /** column name */
  CrusherCss = 'crusherCss',
  /** column name */
  CrusherForceOverload = 'crusherForceOverload',
  /** column name */
  CrusherGrading = 'crusherGrading',
  /** column name */
  CrusherLifetimeConcave = 'crusherLifetimeConcave',
  /** column name */
  CrusherLifetimeMantle = 'crusherLifetimeMantle',
  /** column name */
  CrusherModel = 'crusherModel',
  /** column name */
  CrusherOss = 'crusherOss',
  /** column name */
  CrusherRatedPower = 'crusherRatedPower',
  /** column name */
  CrusherSerialNumber = 'crusherSerialNumber',
  /** column name */
  CrusherSpeed = 'crusherSpeed',
  /** column name */
  CrusherStroke = 'crusherStroke',
  /** column name */
  CrusherThroughput = 'crusherThroughput',
  /** column name */
  CrusherType = 'crusherType',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  ExpertConfirmed = 'expertConfirmed',
  /** column name */
  ExpertId = 'expertId',
  /** column name */
  FeedAbrasiveness = 'feedAbrasiveness',
  /** column name */
  FeedCrushabilityPercent = 'feedCrushabilityPercent',
  /** column name */
  FeedCurveAttachmentId = 'feedCurveAttachmentId',
  /** column name */
  FeedGradingMaxSize = 'feedGradingMaxSize',
  /** column name */
  FeedGradingMinSize = 'feedGradingMinSize',
  /** column name */
  FeedMaxSize = 'feedMaxSize',
  /** column name */
  FeedMethod = 'feedMethod',
  /** column name */
  FeedMinSize = 'feedMinSize',
  /** column name */
  FeedMoisturePercent = 'feedMoisturePercent',
  /** column name */
  FeedOn = 'feedOn',
  /** column name */
  FeedOreType = 'feedOreType',
  /** column name */
  FeedRockTestId = 'feedRockTestId',
  /** column name */
  FeedSolidDensity = 'feedSolidDensity',
  /** column name */
  FlowsheetAttachmentId = 'flowsheetAttachmentId',
  /** column name */
  FollowUpId = 'followUpId',
  /** column name */
  GrindingId = 'grindingId',
  /** column name */
  Id = 'id',
  /** column name */
  ImprovementTargets = 'improvementTargets',
  /** column name */
  ImprovementTargetsAdditionalInfo = 'improvementTargetsAdditionalInfo',
  /** column name */
  ImprovementTargetsCrusherDuty = 'improvementTargetsCrusherDuty',
  /** column name */
  ImprovementTargetsOtherInfo = 'improvementTargetsOtherInfo',
  /** column name */
  LastEditedByUserId = 'lastEditedByUserId',
  /** column name */
  Metric = 'metric',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfCrushers = 'numberOfCrushers',
  /** column name */
  OperatingDaysPerYear = 'operatingDaysPerYear',
  /** column name */
  OperatingHoursPerDay = 'operatingHoursPerDay',
  /** column name */
  OperatingHoursPerYear = 'operatingHoursPerYear',
  /** column name */
  OperatingProfit = 'operatingProfit',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  Phase = 'phase',
  /** column name */
  PistonPressureAttachmentId = 'pistonPressureAttachmentId',
  /** column name */
  PistonPressureAvg = 'pistonPressureAvg',
  /** column name */
  PistonPressurePeak = 'pistonPressurePeak',
  /** column name */
  PowerDrawAttachmentId = 'powerDrawAttachmentId',
  /** column name */
  PowerDrawAvg = 'powerDrawAvg',
  /** column name */
  PowerDrawPeak = 'powerDrawPeak',
  /** column name */
  Product = 'product',
  /** column name */
  Ringbounce = 'ringbounce',
  /** column name */
  RingbounceAdditionalInfo = 'ringbounceAdditionalInfo',
  /** column name */
  RockType = 'rockType',
  /** column name */
  SalesforceOpportunityNumber = 'salesforceOpportunityNumber',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Status = 'status',
  /** column name */
  TargetMax = 'targetMax',
  /** column name */
  TargetMin = 'targetMin',
  /** column name */
  TargetOther = 'targetOther',
  /** column name */
  TargetThroughput = 'targetThroughput',
  /** column name */
  ThroughputAttachmentId = 'throughputAttachmentId',
  /** column name */
  ThroughputAvg = 'throughputAvg',
  /** column name */
  ThroughputPeak = 'throughputPeak',
  /** column name */
  UpdatedAt = 'updatedAt',
}

/** select "case_aggregate_bool_exp_bool_and_arguments_columns" columns of table "case" */
export enum Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ChokeFeed = 'chokeFeed',
  /** column name */
  CrusherForceOverload = 'crusherForceOverload',
  /** column name */
  ExpertConfirmed = 'expertConfirmed',
  /** column name */
  FeedOn = 'feedOn',
  /** column name */
  Metric = 'metric',
  /** column name */
  Ringbounce = 'ringbounce',
}

/** select "case_aggregate_bool_exp_bool_or_arguments_columns" columns of table "case" */
export enum Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ChokeFeed = 'chokeFeed',
  /** column name */
  CrusherForceOverload = 'crusherForceOverload',
  /** column name */
  ExpertConfirmed = 'expertConfirmed',
  /** column name */
  FeedOn = 'feedOn',
  /** column name */
  Metric = 'metric',
  /** column name */
  Ringbounce = 'ringbounce',
}

/** input type for updating data in table "case" */
export type Case_Set_Input = {
  additionalAttachmentInformation?: InputMaybe<Scalars['String']>;
  additionalBasicInformation?: InputMaybe<Scalars['String']>;
  additionalChamberInformation?: InputMaybe<Scalars['String']>;
  additionalCrusherInformation?: InputMaybe<Scalars['String']>;
  additionalFeedInformation?: InputMaybe<Scalars['String']>;
  annualCrushingLineCapacity?: InputMaybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: InputMaybe<Scalars['Int']>;
  annualWearConsumptionProcess?: InputMaybe<Scalars['Int']>;
  chokeFeed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Crusher additional information */
  crusherAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: InputMaybe<Scalars['String']>;
  crusherCounterShaftSpeed?: InputMaybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Scalars['numeric']>;
  crusherForceOverload?: InputMaybe<Scalars['Boolean']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: InputMaybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Scalars['numeric']>;
  crusherRatedPower?: InputMaybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: InputMaybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: InputMaybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: InputMaybe<Scalars['String']>;
  /** The customerId of an object */
  customerId?: InputMaybe<Scalars['Int']>;
  dueDate?: InputMaybe<Scalars['date']>;
  expertConfirmed?: InputMaybe<Scalars['Boolean']>;
  expertId?: InputMaybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Scalars['numeric']>;
  feedCurveAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Scalars['Int']>;
  feedMaxSize?: InputMaybe<Scalars['Int']>;
  feedMethod?: InputMaybe<Scalars['String']>;
  feedMinSize?: InputMaybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Scalars['numeric']>;
  /** Crusher on/off */
  feedOn?: InputMaybe<Scalars['Boolean']>;
  feedOreType?: InputMaybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: InputMaybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Scalars['numeric']>;
  flowsheetAttachmentId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  grindingId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  improvementTargets?: InputMaybe<Scalars['jsonb']>;
  improvementTargetsAdditionalInfo?: InputMaybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: InputMaybe<Scalars['String']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['jsonb']>;
  lastEditedByUserId?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Scalars['Boolean']>;
  /** Name of the case */
  name?: InputMaybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Scalars['numeric']>;
  ownerUserId?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  pistonPressureAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Scalars['numeric']>;
  powerDrawAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Scalars['String']>;
  /** Ringbounce */
  ringbounce?: InputMaybe<Scalars['Boolean']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: InputMaybe<Scalars['String']>;
  salesforceOpportunityNumber?: InputMaybe<Scalars['String']>;
  settingsId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CaseStatus_Enum>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: InputMaybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Scalars['Int']>;
  throughputAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Case_Stddev_Fields = {
  __typename?: 'case_stddev_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "case" */
export type Case_Stddev_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Case_Stddev_Pop_Fields = {
  __typename?: 'case_stddev_pop_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "case" */
export type Case_Stddev_Pop_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Case_Stddev_Samp_Fields = {
  __typename?: 'case_stddev_samp_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "case" */
export type Case_Stddev_Samp_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "case" */
export type Case_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Stream_Cursor_Value_Input = {
  additionalAttachmentInformation?: InputMaybe<Scalars['String']>;
  additionalBasicInformation?: InputMaybe<Scalars['String']>;
  additionalChamberInformation?: InputMaybe<Scalars['String']>;
  additionalCrusherInformation?: InputMaybe<Scalars['String']>;
  additionalFeedInformation?: InputMaybe<Scalars['String']>;
  annualCrushingLineCapacity?: InputMaybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: InputMaybe<Scalars['Int']>;
  annualWearConsumptionProcess?: InputMaybe<Scalars['Int']>;
  chokeFeed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Crusher additional information */
  crusherAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityMaterial?: InputMaybe<Scalars['String']>;
  /** Not for PG crushers */
  crusherCavityType?: InputMaybe<Scalars['String']>;
  crusherCounterShaftSpeed?: InputMaybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Scalars['numeric']>;
  crusherForceOverload?: InputMaybe<Scalars['Boolean']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Scalars['Int']>;
  /** Model of the crusher (6089 SUPERIOR) */
  crusherModel?: InputMaybe<Scalars['String']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Scalars['numeric']>;
  crusherRatedPower?: InputMaybe<Scalars['numeric']>;
  /** The serial number of the crusher (13920193) */
  crusherSerialNumber?: InputMaybe<Scalars['String']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Scalars['Int']>;
  /** Crusher type (eg. PG6089) */
  crusherType?: InputMaybe<Scalars['String']>;
  /** Case currency (eg. USD) */
  currency?: InputMaybe<Scalars['String']>;
  /** The customerId of an object */
  customerId?: InputMaybe<Scalars['Int']>;
  dueDate?: InputMaybe<Scalars['date']>;
  expertConfirmed?: InputMaybe<Scalars['Boolean']>;
  expertId?: InputMaybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Scalars['numeric']>;
  feedCurveAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Scalars['Int']>;
  feedMaxSize?: InputMaybe<Scalars['Int']>;
  feedMethod?: InputMaybe<Scalars['String']>;
  feedMinSize?: InputMaybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Scalars['numeric']>;
  /** Crusher on/off */
  feedOn?: InputMaybe<Scalars['Boolean']>;
  feedOreType?: InputMaybe<Scalars['String']>;
  /** Crusher rock test id (eg. TRE0012345) */
  feedRockTestId?: InputMaybe<Scalars['String']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Scalars['numeric']>;
  flowsheetAttachmentId?: InputMaybe<Scalars['Int']>;
  followUpId?: InputMaybe<Scalars['Int']>;
  grindingId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  improvementTargets?: InputMaybe<Scalars['jsonb']>;
  improvementTargetsAdditionalInfo?: InputMaybe<Scalars['String']>;
  improvementTargetsCrusherDuty?: InputMaybe<Scalars['String']>;
  improvementTargetsOtherInfo?: InputMaybe<Scalars['jsonb']>;
  lastEditedByUserId?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Scalars['Boolean']>;
  /** Name of the case */
  name?: InputMaybe<Scalars['String']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Scalars['numeric']>;
  ownerUserId?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  pistonPressureAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Scalars['numeric']>;
  powerDrawAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Scalars['String']>;
  /** Ringbounce */
  ringbounce?: InputMaybe<Scalars['Boolean']>;
  /** Ringbounce additional information */
  ringbounceAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Rock type name (eg. Copper ore) */
  rockType?: InputMaybe<Scalars['String']>;
  salesforceOpportunityNumber?: InputMaybe<Scalars['String']>;
  settingsId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CaseStatus_Enum>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Scalars['Int']>;
  /** Other target description */
  targetOther?: InputMaybe<Scalars['String']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Scalars['Int']>;
  throughputAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Case_Sum_Fields = {
  __typename?: 'case_sum_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['numeric']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Int']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Int']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['numeric']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['numeric']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Int']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Int']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Int']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['numeric']>;
  crusherRatedPower?: Maybe<Scalars['numeric']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['numeric']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['numeric']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Int']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Int']>;
  expertId?: Maybe<Scalars['Int']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['numeric']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['numeric']>;
  feedCurveAttachmentId?: Maybe<Scalars['Int']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Int']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Int']>;
  feedMaxSize?: Maybe<Scalars['Int']>;
  feedMinSize?: Maybe<Scalars['Int']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['numeric']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['numeric']>;
  flowsheetAttachmentId?: Maybe<Scalars['Int']>;
  followUpId?: Maybe<Scalars['Int']>;
  grindingId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Int']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['numeric']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['numeric']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Int']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['numeric']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Int']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['numeric']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['numeric']>;
  powerDrawAttachmentId?: Maybe<Scalars['Int']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['numeric']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['numeric']>;
  settingsId?: Maybe<Scalars['Int']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Int']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Int']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Int']>;
  throughputAttachmentId?: Maybe<Scalars['Int']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['numeric']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "case" */
export type Case_Sum_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** update columns of table "case" */
export enum Case_Update_Column {
  /** column name */
  AdditionalAttachmentInformation = 'additionalAttachmentInformation',
  /** column name */
  AdditionalBasicInformation = 'additionalBasicInformation',
  /** column name */
  AdditionalChamberInformation = 'additionalChamberInformation',
  /** column name */
  AdditionalCrusherInformation = 'additionalCrusherInformation',
  /** column name */
  AdditionalFeedInformation = 'additionalFeedInformation',
  /** column name */
  AnnualCrushingLineCapacity = 'annualCrushingLineCapacity',
  /** column name */
  AnnualWearConsumptionMachine = 'annualWearConsumptionMachine',
  /** column name */
  AnnualWearConsumptionProcess = 'annualWearConsumptionProcess',
  /** column name */
  ChokeFeed = 'chokeFeed',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CrusherAdditionalInfo = 'crusherAdditionalInfo',
  /** column name */
  CrusherCavityMaterial = 'crusherCavityMaterial',
  /** column name */
  CrusherCavityType = 'crusherCavityType',
  /** column name */
  CrusherCounterShaftSpeed = 'crusherCounterShaftSpeed',
  /** column name */
  CrusherCss = 'crusherCss',
  /** column name */
  CrusherForceOverload = 'crusherForceOverload',
  /** column name */
  CrusherGrading = 'crusherGrading',
  /** column name */
  CrusherLifetimeConcave = 'crusherLifetimeConcave',
  /** column name */
  CrusherLifetimeMantle = 'crusherLifetimeMantle',
  /** column name */
  CrusherModel = 'crusherModel',
  /** column name */
  CrusherOss = 'crusherOss',
  /** column name */
  CrusherRatedPower = 'crusherRatedPower',
  /** column name */
  CrusherSerialNumber = 'crusherSerialNumber',
  /** column name */
  CrusherSpeed = 'crusherSpeed',
  /** column name */
  CrusherStroke = 'crusherStroke',
  /** column name */
  CrusherThroughput = 'crusherThroughput',
  /** column name */
  CrusherType = 'crusherType',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  ExpertConfirmed = 'expertConfirmed',
  /** column name */
  ExpertId = 'expertId',
  /** column name */
  FeedAbrasiveness = 'feedAbrasiveness',
  /** column name */
  FeedCrushabilityPercent = 'feedCrushabilityPercent',
  /** column name */
  FeedCurveAttachmentId = 'feedCurveAttachmentId',
  /** column name */
  FeedGradingMaxSize = 'feedGradingMaxSize',
  /** column name */
  FeedGradingMinSize = 'feedGradingMinSize',
  /** column name */
  FeedMaxSize = 'feedMaxSize',
  /** column name */
  FeedMethod = 'feedMethod',
  /** column name */
  FeedMinSize = 'feedMinSize',
  /** column name */
  FeedMoisturePercent = 'feedMoisturePercent',
  /** column name */
  FeedOn = 'feedOn',
  /** column name */
  FeedOreType = 'feedOreType',
  /** column name */
  FeedRockTestId = 'feedRockTestId',
  /** column name */
  FeedSolidDensity = 'feedSolidDensity',
  /** column name */
  FlowsheetAttachmentId = 'flowsheetAttachmentId',
  /** column name */
  FollowUpId = 'followUpId',
  /** column name */
  GrindingId = 'grindingId',
  /** column name */
  Id = 'id',
  /** column name */
  ImprovementTargets = 'improvementTargets',
  /** column name */
  ImprovementTargetsAdditionalInfo = 'improvementTargetsAdditionalInfo',
  /** column name */
  ImprovementTargetsCrusherDuty = 'improvementTargetsCrusherDuty',
  /** column name */
  ImprovementTargetsOtherInfo = 'improvementTargetsOtherInfo',
  /** column name */
  LastEditedByUserId = 'lastEditedByUserId',
  /** column name */
  Metric = 'metric',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfCrushers = 'numberOfCrushers',
  /** column name */
  OperatingDaysPerYear = 'operatingDaysPerYear',
  /** column name */
  OperatingHoursPerDay = 'operatingHoursPerDay',
  /** column name */
  OperatingHoursPerYear = 'operatingHoursPerYear',
  /** column name */
  OperatingProfit = 'operatingProfit',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  Phase = 'phase',
  /** column name */
  PistonPressureAttachmentId = 'pistonPressureAttachmentId',
  /** column name */
  PistonPressureAvg = 'pistonPressureAvg',
  /** column name */
  PistonPressurePeak = 'pistonPressurePeak',
  /** column name */
  PowerDrawAttachmentId = 'powerDrawAttachmentId',
  /** column name */
  PowerDrawAvg = 'powerDrawAvg',
  /** column name */
  PowerDrawPeak = 'powerDrawPeak',
  /** column name */
  Product = 'product',
  /** column name */
  Ringbounce = 'ringbounce',
  /** column name */
  RingbounceAdditionalInfo = 'ringbounceAdditionalInfo',
  /** column name */
  RockType = 'rockType',
  /** column name */
  SalesforceOpportunityNumber = 'salesforceOpportunityNumber',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Status = 'status',
  /** column name */
  TargetMax = 'targetMax',
  /** column name */
  TargetMin = 'targetMin',
  /** column name */
  TargetOther = 'targetOther',
  /** column name */
  TargetThroughput = 'targetThroughput',
  /** column name */
  ThroughputAttachmentId = 'throughputAttachmentId',
  /** column name */
  ThroughputAvg = 'throughputAvg',
  /** column name */
  ThroughputPeak = 'throughputPeak',
  /** column name */
  UpdatedAt = 'updatedAt',
}

export type Case_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Case_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Case_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Case_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Case_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Case_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Case_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Case_Var_Pop_Fields = {
  __typename?: 'case_var_pop_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "case" */
export type Case_Var_Pop_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Case_Var_Samp_Fields = {
  __typename?: 'case_var_samp_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "case" */
export type Case_Var_Samp_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Case_Variance_Fields = {
  __typename?: 'case_variance_fields';
  annualCrushingLineCapacity?: Maybe<Scalars['Float']>;
  annualWearConsumptionMachine?: Maybe<Scalars['Float']>;
  annualWearConsumptionProcess?: Maybe<Scalars['Float']>;
  crusherCounterShaftSpeed?: Maybe<Scalars['Float']>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: Maybe<Scalars['Float']>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: Maybe<Scalars['Float']>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: Maybe<Scalars['Float']>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: Maybe<Scalars['Float']>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: Maybe<Scalars['Float']>;
  crusherRatedPower?: Maybe<Scalars['Float']>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: Maybe<Scalars['Float']>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: Maybe<Scalars['Float']>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: Maybe<Scalars['Float']>;
  /** The customerId of an object */
  customerId?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['Float']>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: Maybe<Scalars['Float']>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: Maybe<Scalars['Float']>;
  feedCurveAttachmentId?: Maybe<Scalars['Float']>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: Maybe<Scalars['Float']>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: Maybe<Scalars['Float']>;
  feedMaxSize?: Maybe<Scalars['Float']>;
  feedMinSize?: Maybe<Scalars['Float']>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: Maybe<Scalars['Float']>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: Maybe<Scalars['Float']>;
  flowsheetAttachmentId?: Maybe<Scalars['Float']>;
  followUpId?: Maybe<Scalars['Float']>;
  grindingId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: Maybe<Scalars['Float']>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: Maybe<Scalars['Float']>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: Maybe<Scalars['Float']>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: Maybe<Scalars['Float']>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: Maybe<Scalars['Float']>;
  pistonPressureAttachmentId?: Maybe<Scalars['Float']>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: Maybe<Scalars['Float']>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: Maybe<Scalars['Float']>;
  powerDrawAttachmentId?: Maybe<Scalars['Float']>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: Maybe<Scalars['Float']>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: Maybe<Scalars['Float']>;
  settingsId?: Maybe<Scalars['Float']>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: Maybe<Scalars['Float']>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: Maybe<Scalars['Float']>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: Maybe<Scalars['Float']>;
  throughputAttachmentId?: Maybe<Scalars['Float']>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: Maybe<Scalars['Float']>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "case" */
export type Case_Variance_Order_By = {
  annualCrushingLineCapacity?: InputMaybe<Order_By>;
  annualWearConsumptionMachine?: InputMaybe<Order_By>;
  annualWearConsumptionProcess?: InputMaybe<Order_By>;
  crusherCounterShaftSpeed?: InputMaybe<Order_By>;
  /** Crusher closed side setting [mm] (eg. 180) */
  crusherCss?: InputMaybe<Order_By>;
  /** Crusher grading [mm] (eg. 300) */
  crusherGrading?: InputMaybe<Order_By>;
  /** Crusher concave lifetime [mt] (eg. 18) */
  crusherLifetimeConcave?: InputMaybe<Order_By>;
  /** Crusher mantle lifetime [mt] (eg. 6) */
  crusherLifetimeMantle?: InputMaybe<Order_By>;
  /** Crusher open side setting [mm] (eg. 210) */
  crusherOss?: InputMaybe<Order_By>;
  crusherRatedPower?: InputMaybe<Order_By>;
  /** Crusher speed [rpm] (eg. 160) */
  crusherSpeed?: InputMaybe<Order_By>;
  /** Stroke [mm] (eg.30) */
  crusherStroke?: InputMaybe<Order_By>;
  /** Crusher throughput [t/h] (3000) */
  crusherThroughput?: InputMaybe<Order_By>;
  /** The customerId of an object */
  customerId?: InputMaybe<Order_By>;
  expertId?: InputMaybe<Order_By>;
  /** Abrasiveness [g/t] (eg. 1000) */
  feedAbrasiveness?: InputMaybe<Order_By>;
  /** Crushability percent [%] (eg. 34) */
  feedCrushabilityPercent?: InputMaybe<Order_By>;
  feedCurveAttachmentId?: InputMaybe<Order_By>;
  /** Feed grading maximum size [mm] (eg. 300) */
  feedGradingMaxSize?: InputMaybe<Order_By>;
  /** Feed grading minimum size [mm] (eg. 50) */
  feedGradingMinSize?: InputMaybe<Order_By>;
  feedMaxSize?: InputMaybe<Order_By>;
  feedMinSize?: InputMaybe<Order_By>;
  /** Moisture percent [%] (eg. 1) */
  feedMoisturePercent?: InputMaybe<Order_By>;
  /** Feed solid density  [t/m3] (eg. 2.6) */
  feedSolidDensity?: InputMaybe<Order_By>;
  flowsheetAttachmentId?: InputMaybe<Order_By>;
  followUpId?: InputMaybe<Order_By>;
  grindingId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Number of crushers in running parallel [pcs] (eg. 2) */
  numberOfCrushers?: InputMaybe<Order_By>;
  /** Operating days per year [d] (eg. 340) */
  operatingDaysPerYear?: InputMaybe<Order_By>;
  /** Operating hours per day [h] (eg. 22) */
  operatingHoursPerDay?: InputMaybe<Order_By>;
  /** Operating hours per year [h] (eg. 7480) */
  operatingHoursPerYear?: InputMaybe<Order_By>;
  /** Operating profit [%] (eg. 15.0) */
  operatingProfit?: InputMaybe<Order_By>;
  pistonPressureAttachmentId?: InputMaybe<Order_By>;
  /** Piston pressure average [bar] (eg. 20) */
  pistonPressureAvg?: InputMaybe<Order_By>;
  /** Piston pressure peak [bar] (eg. 25) */
  pistonPressurePeak?: InputMaybe<Order_By>;
  powerDrawAttachmentId?: InputMaybe<Order_By>;
  /** Power draw average [kW] (eg. 300) */
  powerDrawAvg?: InputMaybe<Order_By>;
  /** Power draw peak [kW] (eg. 450) */
  powerDrawPeak?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  /** Target maximum size [mm] (eg. 0) */
  targetMax?: InputMaybe<Order_By>;
  /** Target minimum size [mm] (eg. 0) */
  targetMin?: InputMaybe<Order_By>;
  /** Target throughput [tph] (eg. 3000) */
  targetThroughput?: InputMaybe<Order_By>;
  throughputAttachmentId?: InputMaybe<Order_By>;
  /** Throughput average [mtph] (eg. 3000) */
  throughputAvg?: InputMaybe<Order_By>;
  /** Throughput peak [mtph] (eg. 3300) */
  throughputPeak?: InputMaybe<Order_By>;
};

/** columns and relationships of "concavePiece" */
export type ConcavePiece = {
  __typename?: 'concavePiece';
  caseId?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['String']>;
  fasteningMethod?: Maybe<Scalars['String']>;
  /** The id of an object */
  id: Scalars['Int'];
  material?: Maybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: Maybe<Scalars['String']>;
  numberOfSegments?: Maybe<Scalars['Int']>;
  partNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  partSet?: Maybe<PartSet>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  segmentWeight?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "concavePiece" */
export type ConcavePiece_Aggregate = {
  __typename?: 'concavePiece_aggregate';
  aggregate?: Maybe<ConcavePiece_Aggregate_Fields>;
  nodes: Array<ConcavePiece>;
};

export type ConcavePiece_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConcavePiece_Aggregate_Bool_Exp_Count>;
};

export type ConcavePiece_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConcavePiece_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "concavePiece" */
export type ConcavePiece_Aggregate_Fields = {
  __typename?: 'concavePiece_aggregate_fields';
  avg?: Maybe<ConcavePiece_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ConcavePiece_Max_Fields>;
  min?: Maybe<ConcavePiece_Min_Fields>;
  stddev?: Maybe<ConcavePiece_Stddev_Fields>;
  stddev_pop?: Maybe<ConcavePiece_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConcavePiece_Stddev_Samp_Fields>;
  sum?: Maybe<ConcavePiece_Sum_Fields>;
  var_pop?: Maybe<ConcavePiece_Var_Pop_Fields>;
  var_samp?: Maybe<ConcavePiece_Var_Samp_Fields>;
  variance?: Maybe<ConcavePiece_Variance_Fields>;
};

/** aggregate fields of "concavePiece" */
export type ConcavePiece_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "concavePiece" */
export type ConcavePiece_Aggregate_Order_By = {
  avg?: InputMaybe<ConcavePiece_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConcavePiece_Max_Order_By>;
  min?: InputMaybe<ConcavePiece_Min_Order_By>;
  stddev?: InputMaybe<ConcavePiece_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConcavePiece_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConcavePiece_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConcavePiece_Sum_Order_By>;
  var_pop?: InputMaybe<ConcavePiece_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConcavePiece_Var_Samp_Order_By>;
  variance?: InputMaybe<ConcavePiece_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "concavePiece" */
export type ConcavePiece_Arr_Rel_Insert_Input = {
  data: Array<ConcavePiece_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConcavePiece_On_Conflict>;
};

/** aggregate avg on columns */
export type ConcavePiece_Avg_Fields = {
  __typename?: 'concavePiece_avg_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "concavePiece" */
export type ConcavePiece_Avg_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "concavePiece". All fields are combined with a logical 'AND'. */
export type ConcavePiece_Bool_Exp = {
  _and?: InputMaybe<Array<ConcavePiece_Bool_Exp>>;
  _not?: InputMaybe<ConcavePiece_Bool_Exp>;
  _or?: InputMaybe<Array<ConcavePiece_Bool_Exp>>;
  caseId?: InputMaybe<Int_Comparison_Exp>;
  configuration?: InputMaybe<String_Comparison_Exp>;
  fasteningMethod?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfSegments?: InputMaybe<Int_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  partSet?: InputMaybe<PartSet_Bool_Exp>;
  partSetId?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  pricePerKg?: InputMaybe<Numeric_Comparison_Exp>;
  pricePerKgMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  segmentWeight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "concavePiece" */
export enum ConcavePiece_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConcavePiecePkey = 'concavePiece_pkey',
}

/** input type for incrementing numeric columns in table "concavePiece" */
export type ConcavePiece_Inc_Input = {
  caseId?: InputMaybe<Scalars['Int']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  numberOfSegments?: InputMaybe<Scalars['Int']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  segmentWeight?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "concavePiece" */
export type ConcavePiece_Insert_Input = {
  caseId?: InputMaybe<Scalars['Int']>;
  configuration?: InputMaybe<Scalars['String']>;
  fasteningMethod?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: InputMaybe<Scalars['String']>;
  numberOfSegments?: InputMaybe<Scalars['Int']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSet?: InputMaybe<PartSet_Obj_Rel_Insert_Input>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  segmentWeight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type ConcavePiece_Max_Fields = {
  __typename?: 'concavePiece_max_fields';
  caseId?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['String']>;
  fasteningMethod?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  material?: Maybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: Maybe<Scalars['String']>;
  numberOfSegments?: Maybe<Scalars['Int']>;
  partNumber?: Maybe<Scalars['String']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  segmentWeight?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "concavePiece" */
export type ConcavePiece_Max_Order_By = {
  caseId?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  fasteningMethod?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  /** Name of the concave piece (eg. MM213) */
  name?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConcavePiece_Min_Fields = {
  __typename?: 'concavePiece_min_fields';
  caseId?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['String']>;
  fasteningMethod?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  material?: Maybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: Maybe<Scalars['String']>;
  numberOfSegments?: Maybe<Scalars['Int']>;
  partNumber?: Maybe<Scalars['String']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  segmentWeight?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "concavePiece" */
export type ConcavePiece_Min_Order_By = {
  caseId?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  fasteningMethod?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  /** Name of the concave piece (eg. MM213) */
  name?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "concavePiece" */
export type ConcavePiece_Mutation_Response = {
  __typename?: 'concavePiece_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConcavePiece>;
};

/** on_conflict condition type for table "concavePiece" */
export type ConcavePiece_On_Conflict = {
  constraint: ConcavePiece_Constraint;
  update_columns?: Array<ConcavePiece_Update_Column>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

/** Ordering options when selecting data from "concavePiece". */
export type ConcavePiece_Order_By = {
  caseId?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  fasteningMethod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSet?: InputMaybe<PartSet_Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: concavePiece */
export type ConcavePiece_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "concavePiece" */
export enum ConcavePiece_Select_Column {
  /** column name */
  CaseId = 'caseId',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  FasteningMethod = 'fasteningMethod',
  /** column name */
  Id = 'id',
  /** column name */
  Material = 'material',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSegments = 'numberOfSegments',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartSetId = 'partSetId',
  /** column name */
  Price = 'price',
  /** column name */
  PriceMarketArea = 'priceMarketArea',
  /** column name */
  PricePerKg = 'pricePerKg',
  /** column name */
  PricePerKgMarketArea = 'pricePerKgMarketArea',
  /** column name */
  SegmentWeight = 'segmentWeight',
}

/** input type for updating data in table "concavePiece" */
export type ConcavePiece_Set_Input = {
  caseId?: InputMaybe<Scalars['Int']>;
  configuration?: InputMaybe<Scalars['String']>;
  fasteningMethod?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: InputMaybe<Scalars['String']>;
  numberOfSegments?: InputMaybe<Scalars['Int']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  segmentWeight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type ConcavePiece_Stddev_Fields = {
  __typename?: 'concavePiece_stddev_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "concavePiece" */
export type ConcavePiece_Stddev_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConcavePiece_Stddev_Pop_Fields = {
  __typename?: 'concavePiece_stddev_pop_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "concavePiece" */
export type ConcavePiece_Stddev_Pop_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConcavePiece_Stddev_Samp_Fields = {
  __typename?: 'concavePiece_stddev_samp_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "concavePiece" */
export type ConcavePiece_Stddev_Samp_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "concavePiece" */
export type ConcavePiece_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConcavePiece_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConcavePiece_Stream_Cursor_Value_Input = {
  caseId?: InputMaybe<Scalars['Int']>;
  configuration?: InputMaybe<Scalars['String']>;
  fasteningMethod?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the concave piece (eg. MM213) */
  name?: InputMaybe<Scalars['String']>;
  numberOfSegments?: InputMaybe<Scalars['Int']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  segmentWeight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type ConcavePiece_Sum_Fields = {
  __typename?: 'concavePiece_sum_fields';
  caseId?: Maybe<Scalars['Int']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  numberOfSegments?: Maybe<Scalars['Int']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  segmentWeight?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "concavePiece" */
export type ConcavePiece_Sum_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** update columns of table "concavePiece" */
export enum ConcavePiece_Update_Column {
  /** column name */
  CaseId = 'caseId',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  FasteningMethod = 'fasteningMethod',
  /** column name */
  Id = 'id',
  /** column name */
  Material = 'material',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSegments = 'numberOfSegments',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartSetId = 'partSetId',
  /** column name */
  Price = 'price',
  /** column name */
  PriceMarketArea = 'priceMarketArea',
  /** column name */
  PricePerKg = 'pricePerKg',
  /** column name */
  PricePerKgMarketArea = 'pricePerKgMarketArea',
  /** column name */
  SegmentWeight = 'segmentWeight',
}

export type ConcavePiece_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConcavePiece_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConcavePiece_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConcavePiece_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConcavePiece_Var_Pop_Fields = {
  __typename?: 'concavePiece_var_pop_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "concavePiece" */
export type ConcavePiece_Var_Pop_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConcavePiece_Var_Samp_Fields = {
  __typename?: 'concavePiece_var_samp_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "concavePiece" */
export type ConcavePiece_Var_Samp_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConcavePiece_Variance_Fields = {
  __typename?: 'concavePiece_variance_fields';
  caseId?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  numberOfSegments?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  segmentWeight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "concavePiece" */
export type ConcavePiece_Variance_Order_By = {
  caseId?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  numberOfSegments?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  segmentWeight?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** columns and relationships of "customer" */
export type Customer = {
  __typename?: 'customer';
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  /** Country of customer */
  country?: Maybe<Scalars['String']>;
  /** The id of an object */
  id: Scalars['Int'];
  /** Metso id of the customer */
  metsoId?: Maybe<Scalars['String']>;
  /** Name of the customer */
  name?: Maybe<Scalars['String']>;
  /** Customer site name */
  siteName?: Maybe<Scalars['String']>;
};

/** columns and relationships of "customer" */
export type CustomerCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** columns and relationships of "customer" */
export type CustomerCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** aggregated selection of "customer" */
export type Customer_Aggregate = {
  __typename?: 'customer_aggregate';
  aggregate?: Maybe<Customer_Aggregate_Fields>;
  nodes: Array<Customer>;
};

/** aggregate fields of "customer" */
export type Customer_Aggregate_Fields = {
  __typename?: 'customer_aggregate_fields';
  avg?: Maybe<Customer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Customer_Max_Fields>;
  min?: Maybe<Customer_Min_Fields>;
  stddev?: Maybe<Customer_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Sum_Fields>;
  var_pop?: Maybe<Customer_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Var_Samp_Fields>;
  variance?: Maybe<Customer_Variance_Fields>;
};

/** aggregate fields of "customer" */
export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Customer_Avg_Fields = {
  __typename?: 'customer_avg_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>;
  _not?: InputMaybe<Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Bool_Exp>>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metsoId?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  siteName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer" */
export enum Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerPkey = 'customer_pkey',
}

/** input type for incrementing numeric columns in table "customer" */
export type Customer_Inc_Input = {
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "customer" */
export type Customer_Insert_Input = {
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  /** Country of customer */
  country?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Metso id of the customer */
  metsoId?: InputMaybe<Scalars['String']>;
  /** Name of the customer */
  name?: InputMaybe<Scalars['String']>;
  /** Customer site name */
  siteName?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Customer_Max_Fields = {
  __typename?: 'customer_max_fields';
  /** Country of customer */
  country?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Metso id of the customer */
  metsoId?: Maybe<Scalars['String']>;
  /** Name of the customer */
  name?: Maybe<Scalars['String']>;
  /** Customer site name */
  siteName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customer_Min_Fields = {
  __typename?: 'customer_min_fields';
  /** Country of customer */
  country?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Metso id of the customer */
  metsoId?: Maybe<Scalars['String']>;
  /** Name of the customer */
  name?: Maybe<Scalars['String']>;
  /** Customer site name */
  siteName?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "customer" */
export type Customer_Mutation_Response = {
  __typename?: 'customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer>;
};

/** input type for inserting object relation for remote table "customer" */
export type Customer_Obj_Rel_Insert_Input = {
  data: Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};

/** on_conflict condition type for table "customer" */
export type Customer_On_Conflict = {
  constraint: Customer_Constraint;
  update_columns?: Array<Customer_Update_Column>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "customer". */
export type Customer_Order_By = {
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metsoId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  siteName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer */
export type Customer_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "customer" */
export enum Customer_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  MetsoId = 'metsoId',
  /** column name */
  Name = 'name',
  /** column name */
  SiteName = 'siteName',
}

/** input type for updating data in table "customer" */
export type Customer_Set_Input = {
  /** Country of customer */
  country?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Metso id of the customer */
  metsoId?: InputMaybe<Scalars['String']>;
  /** Name of the customer */
  name?: InputMaybe<Scalars['String']>;
  /** Customer site name */
  siteName?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Customer_Stddev_Fields = {
  __typename?: 'customer_stddev_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Stddev_Pop_Fields = {
  __typename?: 'customer_stddev_pop_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Stddev_Samp_Fields = {
  __typename?: 'customer_stddev_samp_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customer" */
export type Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Stream_Cursor_Value_Input = {
  /** Country of customer */
  country?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Metso id of the customer */
  metsoId?: InputMaybe<Scalars['String']>;
  /** Name of the customer */
  name?: InputMaybe<Scalars['String']>;
  /** Customer site name */
  siteName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Customer_Sum_Fields = {
  __typename?: 'customer_sum_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "customer" */
export enum Customer_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  MetsoId = 'metsoId',
  /** column name */
  Name = 'name',
  /** column name */
  SiteName = 'siteName',
}

export type Customer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Var_Pop_Fields = {
  __typename?: 'customer_var_pop_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Customer_Var_Samp_Fields = {
  __typename?: 'customer_var_samp_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Customer_Variance_Fields = {
  __typename?: 'customer_variance_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "fileType" */
export type FileType = {
  __typename?: 'fileType';
  /** Name of the filetype */
  name: Scalars['String'];
};

/** aggregated selection of "fileType" */
export type FileType_Aggregate = {
  __typename?: 'fileType_aggregate';
  aggregate?: Maybe<FileType_Aggregate_Fields>;
  nodes: Array<FileType>;
};

/** aggregate fields of "fileType" */
export type FileType_Aggregate_Fields = {
  __typename?: 'fileType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FileType_Max_Fields>;
  min?: Maybe<FileType_Min_Fields>;
};

/** aggregate fields of "fileType" */
export type FileType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FileType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fileType". All fields are combined with a logical 'AND'. */
export type FileType_Bool_Exp = {
  _and?: InputMaybe<Array<FileType_Bool_Exp>>;
  _not?: InputMaybe<FileType_Bool_Exp>;
  _or?: InputMaybe<Array<FileType_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fileType" */
export enum FileType_Constraint {
  /** unique or primary key constraint on columns "name" */
  FileTypePkey = 'fileType_pkey',
}

/** input type for inserting data into table "fileType" */
export type FileType_Insert_Input = {
  /** Name of the filetype */
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FileType_Max_Fields = {
  __typename?: 'fileType_max_fields';
  /** Name of the filetype */
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FileType_Min_Fields = {
  __typename?: 'fileType_min_fields';
  /** Name of the filetype */
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fileType" */
export type FileType_Mutation_Response = {
  __typename?: 'fileType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileType>;
};

/** on_conflict condition type for table "fileType" */
export type FileType_On_Conflict = {
  constraint: FileType_Constraint;
  update_columns?: Array<FileType_Update_Column>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

/** Ordering options when selecting data from "fileType". */
export type FileType_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fileType */
export type FileType_Pk_Columns_Input = {
  /** Name of the filetype */
  name: Scalars['String'];
};

/** select columns of table "fileType" */
export enum FileType_Select_Column {
  /** column name */
  Name = 'name',
}

/** input type for updating data in table "fileType" */
export type FileType_Set_Input = {
  /** Name of the filetype */
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "fileType" */
export type FileType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FileType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FileType_Stream_Cursor_Value_Input = {
  /** Name of the filetype */
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "fileType" */
export enum FileType_Update_Column {
  /** column name */
  Name = 'name',
}

export type FileType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FileType_Bool_Exp;
};

/** Table for case follow ups. */
export type FollowUp = {
  __typename?: 'followUp';
  /** An array relationship */
  attachments: Array<Attachment>;
  /** An aggregate relationship */
  attachments_aggregate: Attachment_Aggregate;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  installationDate?: Maybe<Scalars['date']>;
  mantleChangeDate?: Maybe<Scalars['date']>;
  measuredCapacity?: Maybe<Scalars['numeric']>;
  measuredWearLifeHours?: Maybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: Maybe<Scalars['numeric']>;
  removalDate?: Maybe<Scalars['date']>;
  target?: Maybe<Scalars['String']>;
};

/** Table for case follow ups. */
export type FollowUpAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Table for case follow ups. */
export type FollowUpAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Table for case follow ups. */
export type FollowUpCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Table for case follow ups. */
export type FollowUpCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** aggregated selection of "followUp" */
export type FollowUp_Aggregate = {
  __typename?: 'followUp_aggregate';
  aggregate?: Maybe<FollowUp_Aggregate_Fields>;
  nodes: Array<FollowUp>;
};

/** aggregate fields of "followUp" */
export type FollowUp_Aggregate_Fields = {
  __typename?: 'followUp_aggregate_fields';
  avg?: Maybe<FollowUp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FollowUp_Max_Fields>;
  min?: Maybe<FollowUp_Min_Fields>;
  stddev?: Maybe<FollowUp_Stddev_Fields>;
  stddev_pop?: Maybe<FollowUp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FollowUp_Stddev_Samp_Fields>;
  sum?: Maybe<FollowUp_Sum_Fields>;
  var_pop?: Maybe<FollowUp_Var_Pop_Fields>;
  var_samp?: Maybe<FollowUp_Var_Samp_Fields>;
  variance?: Maybe<FollowUp_Variance_Fields>;
};

/** aggregate fields of "followUp" */
export type FollowUp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FollowUp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FollowUp_Avg_Fields = {
  __typename?: 'followUp_avg_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "followUp". All fields are combined with a logical 'AND'. */
export type FollowUp_Bool_Exp = {
  _and?: InputMaybe<Array<FollowUp_Bool_Exp>>;
  _not?: InputMaybe<FollowUp_Bool_Exp>;
  _or?: InputMaybe<Array<FollowUp_Bool_Exp>>;
  attachments?: InputMaybe<Attachment_Bool_Exp>;
  attachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  installationDate?: InputMaybe<Date_Comparison_Exp>;
  mantleChangeDate?: InputMaybe<Date_Comparison_Exp>;
  measuredCapacity?: InputMaybe<Numeric_Comparison_Exp>;
  measuredWearLifeHours?: InputMaybe<Numeric_Comparison_Exp>;
  measuredWearLifeTonnes?: InputMaybe<Numeric_Comparison_Exp>;
  removalDate?: InputMaybe<Date_Comparison_Exp>;
  target?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "followUp" */
export enum FollowUp_Constraint {
  /** unique or primary key constraint on columns "id" */
  FollowUpPkey = 'followUp_pkey',
}

/** input type for incrementing numeric columns in table "followUp" */
export type FollowUp_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  measuredCapacity?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeHours?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "followUp" */
export type FollowUp_Insert_Input = {
  attachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  installationDate?: InputMaybe<Scalars['date']>;
  mantleChangeDate?: InputMaybe<Scalars['date']>;
  measuredCapacity?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeHours?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: InputMaybe<Scalars['numeric']>;
  removalDate?: InputMaybe<Scalars['date']>;
  target?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FollowUp_Max_Fields = {
  __typename?: 'followUp_max_fields';
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  installationDate?: Maybe<Scalars['date']>;
  mantleChangeDate?: Maybe<Scalars['date']>;
  measuredCapacity?: Maybe<Scalars['numeric']>;
  measuredWearLifeHours?: Maybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: Maybe<Scalars['numeric']>;
  removalDate?: Maybe<Scalars['date']>;
  target?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FollowUp_Min_Fields = {
  __typename?: 'followUp_min_fields';
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  installationDate?: Maybe<Scalars['date']>;
  mantleChangeDate?: Maybe<Scalars['date']>;
  measuredCapacity?: Maybe<Scalars['numeric']>;
  measuredWearLifeHours?: Maybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: Maybe<Scalars['numeric']>;
  removalDate?: Maybe<Scalars['date']>;
  target?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "followUp" */
export type FollowUp_Mutation_Response = {
  __typename?: 'followUp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FollowUp>;
};

/** input type for inserting object relation for remote table "followUp" */
export type FollowUp_Obj_Rel_Insert_Input = {
  data: FollowUp_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FollowUp_On_Conflict>;
};

/** on_conflict condition type for table "followUp" */
export type FollowUp_On_Conflict = {
  constraint: FollowUp_Constraint;
  update_columns?: Array<FollowUp_Update_Column>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

/** Ordering options when selecting data from "followUp". */
export type FollowUp_Order_By = {
  attachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installationDate?: InputMaybe<Order_By>;
  mantleChangeDate?: InputMaybe<Order_By>;
  measuredCapacity?: InputMaybe<Order_By>;
  measuredWearLifeHours?: InputMaybe<Order_By>;
  measuredWearLifeTonnes?: InputMaybe<Order_By>;
  removalDate?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** primary key columns input for table: followUp */
export type FollowUp_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "followUp" */
export enum FollowUp_Select_Column {
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  InstallationDate = 'installationDate',
  /** column name */
  MantleChangeDate = 'mantleChangeDate',
  /** column name */
  MeasuredCapacity = 'measuredCapacity',
  /** column name */
  MeasuredWearLifeHours = 'measuredWearLifeHours',
  /** column name */
  MeasuredWearLifeTonnes = 'measuredWearLifeTonnes',
  /** column name */
  RemovalDate = 'removalDate',
  /** column name */
  Target = 'target',
}

/** input type for updating data in table "followUp" */
export type FollowUp_Set_Input = {
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  installationDate?: InputMaybe<Scalars['date']>;
  mantleChangeDate?: InputMaybe<Scalars['date']>;
  measuredCapacity?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeHours?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: InputMaybe<Scalars['numeric']>;
  removalDate?: InputMaybe<Scalars['date']>;
  target?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FollowUp_Stddev_Fields = {
  __typename?: 'followUp_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FollowUp_Stddev_Pop_Fields = {
  __typename?: 'followUp_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FollowUp_Stddev_Samp_Fields = {
  __typename?: 'followUp_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "followUp" */
export type FollowUp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FollowUp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FollowUp_Stream_Cursor_Value_Input = {
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  installationDate?: InputMaybe<Scalars['date']>;
  mantleChangeDate?: InputMaybe<Scalars['date']>;
  measuredCapacity?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeHours?: InputMaybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: InputMaybe<Scalars['numeric']>;
  removalDate?: InputMaybe<Scalars['date']>;
  target?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FollowUp_Sum_Fields = {
  __typename?: 'followUp_sum_fields';
  id?: Maybe<Scalars['Int']>;
  measuredCapacity?: Maybe<Scalars['numeric']>;
  measuredWearLifeHours?: Maybe<Scalars['numeric']>;
  measuredWearLifeTonnes?: Maybe<Scalars['numeric']>;
};

/** update columns of table "followUp" */
export enum FollowUp_Update_Column {
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Id = 'id',
  /** column name */
  InstallationDate = 'installationDate',
  /** column name */
  MantleChangeDate = 'mantleChangeDate',
  /** column name */
  MeasuredCapacity = 'measuredCapacity',
  /** column name */
  MeasuredWearLifeHours = 'measuredWearLifeHours',
  /** column name */
  MeasuredWearLifeTonnes = 'measuredWearLifeTonnes',
  /** column name */
  RemovalDate = 'removalDate',
  /** column name */
  Target = 'target',
}

export type FollowUp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FollowUp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FollowUp_Set_Input>;
  /** filter the rows which have to be updated */
  where: FollowUp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FollowUp_Var_Pop_Fields = {
  __typename?: 'followUp_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FollowUp_Var_Samp_Fields = {
  __typename?: 'followUp_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FollowUp_Variance_Fields = {
  __typename?: 'followUp_variance_fields';
  id?: Maybe<Scalars['Float']>;
  measuredCapacity?: Maybe<Scalars['Float']>;
  measuredWearLifeHours?: Maybe<Scalars['Float']>;
  measuredWearLifeTonnes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "grinding" */
export type Grinding = {
  __typename?: 'grinding';
  bondWorkIndexOfOre?: Maybe<Scalars['numeric']>;
  capacityOfMills?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  energyCost?: Maybe<Scalars['numeric']>;
  grindingFactor?: Maybe<Scalars['numeric']>;
  id: Scalars['Int'];
  millLiningGrindingMediaCosts?: Maybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: Maybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: Maybe<Scalars['numeric']>;
  millingCircuitFactor?: Maybe<Scalars['numeric']>;
  p80ProductGradation?: Maybe<Scalars['numeric']>;
  safetyFactor?: Maybe<Scalars['numeric']>;
  shareOfEnergySavings?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "grinding" */
export type GrindingCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** columns and relationships of "grinding" */
export type GrindingCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** aggregated selection of "grinding" */
export type Grinding_Aggregate = {
  __typename?: 'grinding_aggregate';
  aggregate?: Maybe<Grinding_Aggregate_Fields>;
  nodes: Array<Grinding>;
};

/** aggregate fields of "grinding" */
export type Grinding_Aggregate_Fields = {
  __typename?: 'grinding_aggregate_fields';
  avg?: Maybe<Grinding_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grinding_Max_Fields>;
  min?: Maybe<Grinding_Min_Fields>;
  stddev?: Maybe<Grinding_Stddev_Fields>;
  stddev_pop?: Maybe<Grinding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grinding_Stddev_Samp_Fields>;
  sum?: Maybe<Grinding_Sum_Fields>;
  var_pop?: Maybe<Grinding_Var_Pop_Fields>;
  var_samp?: Maybe<Grinding_Var_Samp_Fields>;
  variance?: Maybe<Grinding_Variance_Fields>;
};

/** aggregate fields of "grinding" */
export type Grinding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grinding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Grinding_Avg_Fields = {
  __typename?: 'grinding_avg_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "grinding". All fields are combined with a logical 'AND'. */
export type Grinding_Bool_Exp = {
  _and?: InputMaybe<Array<Grinding_Bool_Exp>>;
  _not?: InputMaybe<Grinding_Bool_Exp>;
  _or?: InputMaybe<Array<Grinding_Bool_Exp>>;
  bondWorkIndexOfOre?: InputMaybe<Numeric_Comparison_Exp>;
  capacityOfMills?: InputMaybe<Numeric_Comparison_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  energyCost?: InputMaybe<Numeric_Comparison_Exp>;
  grindingFactor?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  millLiningGrindingMediaCosts?: InputMaybe<Numeric_Comparison_Exp>;
  millOperatingDaysPerYear?: InputMaybe<Numeric_Comparison_Exp>;
  millOperatingHoursPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  millingCircuitFactor?: InputMaybe<Numeric_Comparison_Exp>;
  p80ProductGradation?: InputMaybe<Numeric_Comparison_Exp>;
  safetyFactor?: InputMaybe<Numeric_Comparison_Exp>;
  shareOfEnergySavings?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "grinding" */
export enum Grinding_Constraint {
  /** unique or primary key constraint on columns "id" */
  GrindingPkey = 'grinding_pkey',
}

/** input type for incrementing numeric columns in table "grinding" */
export type Grinding_Inc_Input = {
  bondWorkIndexOfOre?: InputMaybe<Scalars['numeric']>;
  capacityOfMills?: InputMaybe<Scalars['numeric']>;
  energyCost?: InputMaybe<Scalars['numeric']>;
  grindingFactor?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: InputMaybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  millingCircuitFactor?: InputMaybe<Scalars['numeric']>;
  p80ProductGradation?: InputMaybe<Scalars['numeric']>;
  safetyFactor?: InputMaybe<Scalars['numeric']>;
  shareOfEnergySavings?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grinding" */
export type Grinding_Insert_Input = {
  bondWorkIndexOfOre?: InputMaybe<Scalars['numeric']>;
  capacityOfMills?: InputMaybe<Scalars['numeric']>;
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  energyCost?: InputMaybe<Scalars['numeric']>;
  grindingFactor?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: InputMaybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  millingCircuitFactor?: InputMaybe<Scalars['numeric']>;
  p80ProductGradation?: InputMaybe<Scalars['numeric']>;
  safetyFactor?: InputMaybe<Scalars['numeric']>;
  shareOfEnergySavings?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Grinding_Max_Fields = {
  __typename?: 'grinding_max_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['numeric']>;
  capacityOfMills?: Maybe<Scalars['numeric']>;
  energyCost?: Maybe<Scalars['numeric']>;
  grindingFactor?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: Maybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: Maybe<Scalars['numeric']>;
  millingCircuitFactor?: Maybe<Scalars['numeric']>;
  p80ProductGradation?: Maybe<Scalars['numeric']>;
  safetyFactor?: Maybe<Scalars['numeric']>;
  shareOfEnergySavings?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Grinding_Min_Fields = {
  __typename?: 'grinding_min_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['numeric']>;
  capacityOfMills?: Maybe<Scalars['numeric']>;
  energyCost?: Maybe<Scalars['numeric']>;
  grindingFactor?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: Maybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: Maybe<Scalars['numeric']>;
  millingCircuitFactor?: Maybe<Scalars['numeric']>;
  p80ProductGradation?: Maybe<Scalars['numeric']>;
  safetyFactor?: Maybe<Scalars['numeric']>;
  shareOfEnergySavings?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "grinding" */
export type Grinding_Mutation_Response = {
  __typename?: 'grinding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grinding>;
};

/** input type for inserting object relation for remote table "grinding" */
export type Grinding_Obj_Rel_Insert_Input = {
  data: Grinding_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Grinding_On_Conflict>;
};

/** on_conflict condition type for table "grinding" */
export type Grinding_On_Conflict = {
  constraint: Grinding_Constraint;
  update_columns?: Array<Grinding_Update_Column>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

/** Ordering options when selecting data from "grinding". */
export type Grinding_Order_By = {
  bondWorkIndexOfOre?: InputMaybe<Order_By>;
  capacityOfMills?: InputMaybe<Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  energyCost?: InputMaybe<Order_By>;
  grindingFactor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  millLiningGrindingMediaCosts?: InputMaybe<Order_By>;
  millOperatingDaysPerYear?: InputMaybe<Order_By>;
  millOperatingHoursPerDay?: InputMaybe<Order_By>;
  millingCircuitFactor?: InputMaybe<Order_By>;
  p80ProductGradation?: InputMaybe<Order_By>;
  safetyFactor?: InputMaybe<Order_By>;
  shareOfEnergySavings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grinding */
export type Grinding_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grinding" */
export enum Grinding_Select_Column {
  /** column name */
  BondWorkIndexOfOre = 'bondWorkIndexOfOre',
  /** column name */
  CapacityOfMills = 'capacityOfMills',
  /** column name */
  EnergyCost = 'energyCost',
  /** column name */
  GrindingFactor = 'grindingFactor',
  /** column name */
  Id = 'id',
  /** column name */
  MillLiningGrindingMediaCosts = 'millLiningGrindingMediaCosts',
  /** column name */
  MillOperatingDaysPerYear = 'millOperatingDaysPerYear',
  /** column name */
  MillOperatingHoursPerDay = 'millOperatingHoursPerDay',
  /** column name */
  MillingCircuitFactor = 'millingCircuitFactor',
  /** column name */
  P80ProductGradation = 'p80ProductGradation',
  /** column name */
  SafetyFactor = 'safetyFactor',
  /** column name */
  ShareOfEnergySavings = 'shareOfEnergySavings',
}

/** input type for updating data in table "grinding" */
export type Grinding_Set_Input = {
  bondWorkIndexOfOre?: InputMaybe<Scalars['numeric']>;
  capacityOfMills?: InputMaybe<Scalars['numeric']>;
  energyCost?: InputMaybe<Scalars['numeric']>;
  grindingFactor?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: InputMaybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  millingCircuitFactor?: InputMaybe<Scalars['numeric']>;
  p80ProductGradation?: InputMaybe<Scalars['numeric']>;
  safetyFactor?: InputMaybe<Scalars['numeric']>;
  shareOfEnergySavings?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Grinding_Stddev_Fields = {
  __typename?: 'grinding_stddev_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Grinding_Stddev_Pop_Fields = {
  __typename?: 'grinding_stddev_pop_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Grinding_Stddev_Samp_Fields = {
  __typename?: 'grinding_stddev_samp_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "grinding" */
export type Grinding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grinding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grinding_Stream_Cursor_Value_Input = {
  bondWorkIndexOfOre?: InputMaybe<Scalars['numeric']>;
  capacityOfMills?: InputMaybe<Scalars['numeric']>;
  energyCost?: InputMaybe<Scalars['numeric']>;
  grindingFactor?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: InputMaybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: InputMaybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: InputMaybe<Scalars['numeric']>;
  millingCircuitFactor?: InputMaybe<Scalars['numeric']>;
  p80ProductGradation?: InputMaybe<Scalars['numeric']>;
  safetyFactor?: InputMaybe<Scalars['numeric']>;
  shareOfEnergySavings?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Grinding_Sum_Fields = {
  __typename?: 'grinding_sum_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['numeric']>;
  capacityOfMills?: Maybe<Scalars['numeric']>;
  energyCost?: Maybe<Scalars['numeric']>;
  grindingFactor?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['numeric']>;
  millOperatingDaysPerYear?: Maybe<Scalars['numeric']>;
  millOperatingHoursPerDay?: Maybe<Scalars['numeric']>;
  millingCircuitFactor?: Maybe<Scalars['numeric']>;
  p80ProductGradation?: Maybe<Scalars['numeric']>;
  safetyFactor?: Maybe<Scalars['numeric']>;
  shareOfEnergySavings?: Maybe<Scalars['numeric']>;
};

/** update columns of table "grinding" */
export enum Grinding_Update_Column {
  /** column name */
  BondWorkIndexOfOre = 'bondWorkIndexOfOre',
  /** column name */
  CapacityOfMills = 'capacityOfMills',
  /** column name */
  EnergyCost = 'energyCost',
  /** column name */
  GrindingFactor = 'grindingFactor',
  /** column name */
  Id = 'id',
  /** column name */
  MillLiningGrindingMediaCosts = 'millLiningGrindingMediaCosts',
  /** column name */
  MillOperatingDaysPerYear = 'millOperatingDaysPerYear',
  /** column name */
  MillOperatingHoursPerDay = 'millOperatingHoursPerDay',
  /** column name */
  MillingCircuitFactor = 'millingCircuitFactor',
  /** column name */
  P80ProductGradation = 'p80ProductGradation',
  /** column name */
  SafetyFactor = 'safetyFactor',
  /** column name */
  ShareOfEnergySavings = 'shareOfEnergySavings',
}

export type Grinding_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grinding_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grinding_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grinding_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grinding_Var_Pop_Fields = {
  __typename?: 'grinding_var_pop_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Grinding_Var_Samp_Fields = {
  __typename?: 'grinding_var_samp_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Grinding_Variance_Fields = {
  __typename?: 'grinding_variance_fields';
  bondWorkIndexOfOre?: Maybe<Scalars['Float']>;
  capacityOfMills?: Maybe<Scalars['Float']>;
  energyCost?: Maybe<Scalars['Float']>;
  grindingFactor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  millLiningGrindingMediaCosts?: Maybe<Scalars['Float']>;
  millOperatingDaysPerYear?: Maybe<Scalars['Float']>;
  millOperatingHoursPerDay?: Maybe<Scalars['Float']>;
  millingCircuitFactor?: Maybe<Scalars['Float']>;
  p80ProductGradation?: Maybe<Scalars['Float']>;
  safetyFactor?: Maybe<Scalars['Float']>;
  shareOfEnergySavings?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "mantlePiece" */
export type MantlePiece = {
  __typename?: 'mantlePiece';
  description?: Maybe<Scalars['String']>;
  /** The id of an object */
  id: Scalars['Int'];
  material?: Maybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  partSet?: Maybe<PartSet>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "mantlePiece" */
export type MantlePiece_Aggregate = {
  __typename?: 'mantlePiece_aggregate';
  aggregate?: Maybe<MantlePiece_Aggregate_Fields>;
  nodes: Array<MantlePiece>;
};

export type MantlePiece_Aggregate_Bool_Exp = {
  count?: InputMaybe<MantlePiece_Aggregate_Bool_Exp_Count>;
};

export type MantlePiece_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MantlePiece_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MantlePiece_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mantlePiece" */
export type MantlePiece_Aggregate_Fields = {
  __typename?: 'mantlePiece_aggregate_fields';
  avg?: Maybe<MantlePiece_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MantlePiece_Max_Fields>;
  min?: Maybe<MantlePiece_Min_Fields>;
  stddev?: Maybe<MantlePiece_Stddev_Fields>;
  stddev_pop?: Maybe<MantlePiece_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MantlePiece_Stddev_Samp_Fields>;
  sum?: Maybe<MantlePiece_Sum_Fields>;
  var_pop?: Maybe<MantlePiece_Var_Pop_Fields>;
  var_samp?: Maybe<MantlePiece_Var_Samp_Fields>;
  variance?: Maybe<MantlePiece_Variance_Fields>;
};

/** aggregate fields of "mantlePiece" */
export type MantlePiece_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MantlePiece_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mantlePiece" */
export type MantlePiece_Aggregate_Order_By = {
  avg?: InputMaybe<MantlePiece_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MantlePiece_Max_Order_By>;
  min?: InputMaybe<MantlePiece_Min_Order_By>;
  stddev?: InputMaybe<MantlePiece_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MantlePiece_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MantlePiece_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MantlePiece_Sum_Order_By>;
  var_pop?: InputMaybe<MantlePiece_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MantlePiece_Var_Samp_Order_By>;
  variance?: InputMaybe<MantlePiece_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mantlePiece" */
export type MantlePiece_Arr_Rel_Insert_Input = {
  data: Array<MantlePiece_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MantlePiece_On_Conflict>;
};

/** aggregate avg on columns */
export type MantlePiece_Avg_Fields = {
  __typename?: 'mantlePiece_avg_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mantlePiece" */
export type MantlePiece_Avg_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mantlePiece". All fields are combined with a logical 'AND'. */
export type MantlePiece_Bool_Exp = {
  _and?: InputMaybe<Array<MantlePiece_Bool_Exp>>;
  _not?: InputMaybe<MantlePiece_Bool_Exp>;
  _or?: InputMaybe<Array<MantlePiece_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  partSet?: InputMaybe<PartSet_Bool_Exp>;
  partSetId?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  pricePerKg?: InputMaybe<Numeric_Comparison_Exp>;
  pricePerKgMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "mantlePiece" */
export enum MantlePiece_Constraint {
  /** unique or primary key constraint on columns "id" */
  MantlePiecePkey = 'mantlePiece_pkey',
}

/** input type for incrementing numeric columns in table "mantlePiece" */
export type MantlePiece_Inc_Input = {
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "mantlePiece" */
export type MantlePiece_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSet?: InputMaybe<PartSet_Obj_Rel_Insert_Input>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type MantlePiece_Max_Fields = {
  __typename?: 'mantlePiece_max_fields';
  description?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  material?: Maybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "mantlePiece" */
export type MantlePiece_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MantlePiece_Min_Fields = {
  __typename?: 'mantlePiece_min_fields';
  description?: Maybe<Scalars['String']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  material?: Maybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "mantlePiece" */
export type MantlePiece_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mantlePiece" */
export type MantlePiece_Mutation_Response = {
  __typename?: 'mantlePiece_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MantlePiece>;
};

/** on_conflict condition type for table "mantlePiece" */
export type MantlePiece_On_Conflict = {
  constraint: MantlePiece_Constraint;
  update_columns?: Array<MantlePiece_Update_Column>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

/** Ordering options when selecting data from "mantlePiece". */
export type MantlePiece_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partSet?: InputMaybe<PartSet_Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mantlePiece */
export type MantlePiece_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "mantlePiece" */
export enum MantlePiece_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Material = 'material',
  /** column name */
  Name = 'name',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartSetId = 'partSetId',
  /** column name */
  Price = 'price',
  /** column name */
  PriceMarketArea = 'priceMarketArea',
  /** column name */
  PricePerKg = 'pricePerKg',
  /** column name */
  PricePerKgMarketArea = 'pricePerKgMarketArea',
  /** column name */
  Type = 'type',
  /** column name */
  Weight = 'weight',
}

/** input type for updating data in table "mantlePiece" */
export type MantlePiece_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type MantlePiece_Stddev_Fields = {
  __typename?: 'mantlePiece_stddev_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mantlePiece" */
export type MantlePiece_Stddev_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MantlePiece_Stddev_Pop_Fields = {
  __typename?: 'mantlePiece_stddev_pop_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mantlePiece" */
export type MantlePiece_Stddev_Pop_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MantlePiece_Stddev_Samp_Fields = {
  __typename?: 'mantlePiece_stddev_samp_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mantlePiece" */
export type MantlePiece_Stddev_Samp_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mantlePiece" */
export type MantlePiece_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MantlePiece_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MantlePiece_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  /** Name of the mantle piece (eg. MM12345) */
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partSetId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceMarketArea?: InputMaybe<Scalars['numeric']>;
  pricePerKg?: InputMaybe<Scalars['numeric']>;
  pricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type MantlePiece_Sum_Fields = {
  __typename?: 'mantlePiece_sum_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  partSetId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  priceMarketArea?: Maybe<Scalars['numeric']>;
  pricePerKg?: Maybe<Scalars['numeric']>;
  pricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "mantlePiece" */
export type MantlePiece_Sum_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "mantlePiece" */
export enum MantlePiece_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Material = 'material',
  /** column name */
  Name = 'name',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartSetId = 'partSetId',
  /** column name */
  Price = 'price',
  /** column name */
  PriceMarketArea = 'priceMarketArea',
  /** column name */
  PricePerKg = 'pricePerKg',
  /** column name */
  PricePerKgMarketArea = 'pricePerKgMarketArea',
  /** column name */
  Type = 'type',
  /** column name */
  Weight = 'weight',
}

export type MantlePiece_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MantlePiece_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MantlePiece_Set_Input>;
  /** filter the rows which have to be updated */
  where: MantlePiece_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MantlePiece_Var_Pop_Fields = {
  __typename?: 'mantlePiece_var_pop_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mantlePiece" */
export type MantlePiece_Var_Pop_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MantlePiece_Var_Samp_Fields = {
  __typename?: 'mantlePiece_var_samp_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mantlePiece" */
export type MantlePiece_Var_Samp_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MantlePiece_Variance_Fields = {
  __typename?: 'mantlePiece_variance_fields';
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  partSetId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceMarketArea?: Maybe<Scalars['Float']>;
  pricePerKg?: Maybe<Scalars['Float']>;
  pricePerKgMarketArea?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mantlePiece" */
export type MantlePiece_Variance_Order_By = {
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  partSetId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceMarketArea?: InputMaybe<Order_By>;
  pricePerKg?: InputMaybe<Order_By>;
  pricePerKgMarketArea?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "miningProduct" */
export type MiningProduct = {
  __typename?: 'miningProduct';
  /** An object relationship */
  case: Case;
  /** The caseId of an object */
  caseId: Scalars['Int'];
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['numeric']>;
  grading?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id: Scalars['Int'];
  /** Name of the mining product (eg. Copper) */
  name?: Maybe<Scalars['String']>;
  nameOther?: Maybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['numeric']>;
  priceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "miningProduct" */
export type MiningProduct_Aggregate = {
  __typename?: 'miningProduct_aggregate';
  aggregate?: Maybe<MiningProduct_Aggregate_Fields>;
  nodes: Array<MiningProduct>;
};

export type MiningProduct_Aggregate_Bool_Exp = {
  count?: InputMaybe<MiningProduct_Aggregate_Bool_Exp_Count>;
};

export type MiningProduct_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MiningProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MiningProduct_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "miningProduct" */
export type MiningProduct_Aggregate_Fields = {
  __typename?: 'miningProduct_aggregate_fields';
  avg?: Maybe<MiningProduct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MiningProduct_Max_Fields>;
  min?: Maybe<MiningProduct_Min_Fields>;
  stddev?: Maybe<MiningProduct_Stddev_Fields>;
  stddev_pop?: Maybe<MiningProduct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MiningProduct_Stddev_Samp_Fields>;
  sum?: Maybe<MiningProduct_Sum_Fields>;
  var_pop?: Maybe<MiningProduct_Var_Pop_Fields>;
  var_samp?: Maybe<MiningProduct_Var_Samp_Fields>;
  variance?: Maybe<MiningProduct_Variance_Fields>;
};

/** aggregate fields of "miningProduct" */
export type MiningProduct_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MiningProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "miningProduct" */
export type MiningProduct_Aggregate_Order_By = {
  avg?: InputMaybe<MiningProduct_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MiningProduct_Max_Order_By>;
  min?: InputMaybe<MiningProduct_Min_Order_By>;
  stddev?: InputMaybe<MiningProduct_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MiningProduct_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MiningProduct_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MiningProduct_Sum_Order_By>;
  var_pop?: InputMaybe<MiningProduct_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MiningProduct_Var_Samp_Order_By>;
  variance?: InputMaybe<MiningProduct_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "miningProduct" */
export type MiningProduct_Arr_Rel_Insert_Input = {
  data: Array<MiningProduct_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MiningProduct_On_Conflict>;
};

/** aggregate avg on columns */
export type MiningProduct_Avg_Fields = {
  __typename?: 'miningProduct_avg_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "miningProduct" */
export type MiningProduct_Avg_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "miningProduct". All fields are combined with a logical 'AND'. */
export type MiningProduct_Bool_Exp = {
  _and?: InputMaybe<Array<MiningProduct_Bool_Exp>>;
  _not?: InputMaybe<MiningProduct_Bool_Exp>;
  _or?: InputMaybe<Array<MiningProduct_Bool_Exp>>;
  case?: InputMaybe<Case_Bool_Exp>;
  caseId?: InputMaybe<Int_Comparison_Exp>;
  grade?: InputMaybe<Numeric_Comparison_Exp>;
  grading?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nameOther?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  recoveryRatePercent?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "miningProduct" */
export enum MiningProduct_Constraint {
  /** unique or primary key constraint on columns "id" */
  MiningProductPkey = 'miningProduct_pkey',
}

/** input type for incrementing numeric columns in table "miningProduct" */
export type MiningProduct_Inc_Input = {
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Scalars['numeric']>;
  grading?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Scalars['numeric']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "miningProduct" */
export type MiningProduct_Insert_Input = {
  case?: InputMaybe<Case_Obj_Rel_Insert_Input>;
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Scalars['numeric']>;
  grading?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Name of the mining product (eg. Copper) */
  name?: InputMaybe<Scalars['String']>;
  nameOther?: InputMaybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Scalars['numeric']>;
  priceUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type MiningProduct_Max_Fields = {
  __typename?: 'miningProduct_max_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['numeric']>;
  grading?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Name of the mining product (eg. Copper) */
  name?: Maybe<Scalars['String']>;
  nameOther?: Maybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['numeric']>;
  priceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "miningProduct" */
export type MiningProduct_Max_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Name of the mining product (eg. Copper) */
  name?: InputMaybe<Order_By>;
  nameOther?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  priceUpdatedAt?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MiningProduct_Min_Fields = {
  __typename?: 'miningProduct_min_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['numeric']>;
  grading?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Name of the mining product (eg. Copper) */
  name?: Maybe<Scalars['String']>;
  nameOther?: Maybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['numeric']>;
  priceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "miningProduct" */
export type MiningProduct_Min_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Name of the mining product (eg. Copper) */
  name?: InputMaybe<Order_By>;
  nameOther?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  priceUpdatedAt?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "miningProduct" */
export type MiningProduct_Mutation_Response = {
  __typename?: 'miningProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MiningProduct>;
};

/** on_conflict condition type for table "miningProduct" */
export type MiningProduct_On_Conflict = {
  constraint: MiningProduct_Constraint;
  update_columns?: Array<MiningProduct_Update_Column>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

/** Ordering options when selecting data from "miningProduct". */
export type MiningProduct_Order_By = {
  case?: InputMaybe<Case_Order_By>;
  caseId?: InputMaybe<Order_By>;
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nameOther?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceUpdatedAt?: InputMaybe<Order_By>;
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** primary key columns input for table: miningProduct */
export type MiningProduct_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "miningProduct" */
export enum MiningProduct_Select_Column {
  /** column name */
  CaseId = 'caseId',
  /** column name */
  Grade = 'grade',
  /** column name */
  Grading = 'grading',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameOther = 'nameOther',
  /** column name */
  Price = 'price',
  /** column name */
  PriceUpdatedAt = 'priceUpdatedAt',
  /** column name */
  RecoveryRatePercent = 'recoveryRatePercent',
}

/** input type for updating data in table "miningProduct" */
export type MiningProduct_Set_Input = {
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Scalars['numeric']>;
  grading?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Name of the mining product (eg. Copper) */
  name?: InputMaybe<Scalars['String']>;
  nameOther?: InputMaybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Scalars['numeric']>;
  priceUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type MiningProduct_Stddev_Fields = {
  __typename?: 'miningProduct_stddev_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "miningProduct" */
export type MiningProduct_Stddev_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MiningProduct_Stddev_Pop_Fields = {
  __typename?: 'miningProduct_stddev_pop_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "miningProduct" */
export type MiningProduct_Stddev_Pop_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MiningProduct_Stddev_Samp_Fields = {
  __typename?: 'miningProduct_stddev_samp_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "miningProduct" */
export type MiningProduct_Stddev_Samp_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "miningProduct" */
export type MiningProduct_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MiningProduct_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MiningProduct_Stream_Cursor_Value_Input = {
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Scalars['numeric']>;
  grading?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  /** Name of the mining product (eg. Copper) */
  name?: InputMaybe<Scalars['String']>;
  nameOther?: InputMaybe<Scalars['String']>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Scalars['numeric']>;
  priceUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type MiningProduct_Sum_Fields = {
  __typename?: 'miningProduct_sum_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['numeric']>;
  grading?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['numeric']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "miningProduct" */
export type MiningProduct_Sum_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** update columns of table "miningProduct" */
export enum MiningProduct_Update_Column {
  /** column name */
  CaseId = 'caseId',
  /** column name */
  Grade = 'grade',
  /** column name */
  Grading = 'grading',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameOther = 'nameOther',
  /** column name */
  Price = 'price',
  /** column name */
  PriceUpdatedAt = 'priceUpdatedAt',
  /** column name */
  RecoveryRatePercent = 'recoveryRatePercent',
}

export type MiningProduct_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MiningProduct_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MiningProduct_Set_Input>;
  /** filter the rows which have to be updated */
  where: MiningProduct_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MiningProduct_Var_Pop_Fields = {
  __typename?: 'miningProduct_var_pop_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "miningProduct" */
export type MiningProduct_Var_Pop_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MiningProduct_Var_Samp_Fields = {
  __typename?: 'miningProduct_var_samp_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "miningProduct" */
export type MiningProduct_Var_Samp_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MiningProduct_Variance_Fields = {
  __typename?: 'miningProduct_variance_fields';
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: Maybe<Scalars['Float']>;
  grading?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  /** Current stock price of the mining product */
  price?: Maybe<Scalars['Float']>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "miningProduct" */
export type MiningProduct_Variance_Order_By = {
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  /** Grade of the mining product [%]  (eg. 2.0) */
  grade?: InputMaybe<Order_By>;
  grading?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  /** Current stock price of the mining product */
  price?: InputMaybe<Order_By>;
  /** Recovery percent of the mining product [%] (eg. 90) */
  recoveryRatePercent?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "attachment" */
  delete_attachment?: Maybe<Attachment_Mutation_Response>;
  /** delete single row from the table: "attachment" */
  delete_attachment_by_pk?: Maybe<Attachment>;
  /** delete data from the table: "case" */
  delete_case?: Maybe<Case_Mutation_Response>;
  /** delete data from the table: "caseStatus" */
  delete_caseStatus?: Maybe<CaseStatus_Mutation_Response>;
  /** delete single row from the table: "caseStatus" */
  delete_caseStatus_by_pk?: Maybe<CaseStatus>;
  /** delete single row from the table: "case" */
  delete_case_by_pk?: Maybe<Case>;
  /** delete data from the table: "concavePiece" */
  delete_concavePiece?: Maybe<ConcavePiece_Mutation_Response>;
  /** delete single row from the table: "concavePiece" */
  delete_concavePiece_by_pk?: Maybe<ConcavePiece>;
  /** delete data from the table: "customer" */
  delete_customer?: Maybe<Customer_Mutation_Response>;
  /** delete single row from the table: "customer" */
  delete_customer_by_pk?: Maybe<Customer>;
  /** delete data from the table: "fileType" */
  delete_fileType?: Maybe<FileType_Mutation_Response>;
  /** delete single row from the table: "fileType" */
  delete_fileType_by_pk?: Maybe<FileType>;
  /** delete data from the table: "followUp" */
  delete_followUp?: Maybe<FollowUp_Mutation_Response>;
  /** delete single row from the table: "followUp" */
  delete_followUp_by_pk?: Maybe<FollowUp>;
  /** delete data from the table: "grinding" */
  delete_grinding?: Maybe<Grinding_Mutation_Response>;
  /** delete single row from the table: "grinding" */
  delete_grinding_by_pk?: Maybe<Grinding>;
  /** delete data from the table: "mantlePiece" */
  delete_mantlePiece?: Maybe<MantlePiece_Mutation_Response>;
  /** delete single row from the table: "mantlePiece" */
  delete_mantlePiece_by_pk?: Maybe<MantlePiece>;
  /** delete data from the table: "miningProduct" */
  delete_miningProduct?: Maybe<MiningProduct_Mutation_Response>;
  /** delete single row from the table: "miningProduct" */
  delete_miningProduct_by_pk?: Maybe<MiningProduct>;
  /** delete data from the table: "partSet" */
  delete_partSet?: Maybe<PartSet_Mutation_Response>;
  /** delete single row from the table: "partSet" */
  delete_partSet_by_pk?: Maybe<PartSet>;
  /** delete data from the table: "settings" */
  delete_settings?: Maybe<Settings_Mutation_Response>;
  /** delete single row from the table: "settings" */
  delete_settings_by_pk?: Maybe<Settings>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** insert data into the table: "attachment" */
  insert_attachment?: Maybe<Attachment_Mutation_Response>;
  /** insert a single row into the table: "attachment" */
  insert_attachment_one?: Maybe<Attachment>;
  /** insert data into the table: "case" */
  insert_case?: Maybe<Case_Mutation_Response>;
  /** insert data into the table: "caseStatus" */
  insert_caseStatus?: Maybe<CaseStatus_Mutation_Response>;
  /** insert a single row into the table: "caseStatus" */
  insert_caseStatus_one?: Maybe<CaseStatus>;
  /** insert a single row into the table: "case" */
  insert_case_one?: Maybe<Case>;
  /** insert data into the table: "concavePiece" */
  insert_concavePiece?: Maybe<ConcavePiece_Mutation_Response>;
  /** insert a single row into the table: "concavePiece" */
  insert_concavePiece_one?: Maybe<ConcavePiece>;
  /** insert data into the table: "customer" */
  insert_customer?: Maybe<Customer_Mutation_Response>;
  /** insert a single row into the table: "customer" */
  insert_customer_one?: Maybe<Customer>;
  /** insert data into the table: "fileType" */
  insert_fileType?: Maybe<FileType_Mutation_Response>;
  /** insert a single row into the table: "fileType" */
  insert_fileType_one?: Maybe<FileType>;
  /** insert data into the table: "followUp" */
  insert_followUp?: Maybe<FollowUp_Mutation_Response>;
  /** insert a single row into the table: "followUp" */
  insert_followUp_one?: Maybe<FollowUp>;
  /** insert data into the table: "grinding" */
  insert_grinding?: Maybe<Grinding_Mutation_Response>;
  /** insert a single row into the table: "grinding" */
  insert_grinding_one?: Maybe<Grinding>;
  /** insert data into the table: "mantlePiece" */
  insert_mantlePiece?: Maybe<MantlePiece_Mutation_Response>;
  /** insert a single row into the table: "mantlePiece" */
  insert_mantlePiece_one?: Maybe<MantlePiece>;
  /** insert data into the table: "miningProduct" */
  insert_miningProduct?: Maybe<MiningProduct_Mutation_Response>;
  /** insert a single row into the table: "miningProduct" */
  insert_miningProduct_one?: Maybe<MiningProduct>;
  /** insert data into the table: "partSet" */
  insert_partSet?: Maybe<PartSet_Mutation_Response>;
  /** insert a single row into the table: "partSet" */
  insert_partSet_one?: Maybe<PartSet>;
  /** insert data into the table: "settings" */
  insert_settings?: Maybe<Settings_Mutation_Response>;
  /** insert a single row into the table: "settings" */
  insert_settings_one?: Maybe<Settings>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** update data of the table: "attachment" */
  update_attachment?: Maybe<Attachment_Mutation_Response>;
  /** update single row of the table: "attachment" */
  update_attachment_by_pk?: Maybe<Attachment>;
  /** update multiples rows of table: "attachment" */
  update_attachment_many?: Maybe<Array<Maybe<Attachment_Mutation_Response>>>;
  /** update data of the table: "case" */
  update_case?: Maybe<Case_Mutation_Response>;
  /** update data of the table: "caseStatus" */
  update_caseStatus?: Maybe<CaseStatus_Mutation_Response>;
  /** update single row of the table: "caseStatus" */
  update_caseStatus_by_pk?: Maybe<CaseStatus>;
  /** update multiples rows of table: "caseStatus" */
  update_caseStatus_many?: Maybe<Array<Maybe<CaseStatus_Mutation_Response>>>;
  /** update single row of the table: "case" */
  update_case_by_pk?: Maybe<Case>;
  /** update multiples rows of table: "case" */
  update_case_many?: Maybe<Array<Maybe<Case_Mutation_Response>>>;
  /** update data of the table: "concavePiece" */
  update_concavePiece?: Maybe<ConcavePiece_Mutation_Response>;
  /** update single row of the table: "concavePiece" */
  update_concavePiece_by_pk?: Maybe<ConcavePiece>;
  /** update multiples rows of table: "concavePiece" */
  update_concavePiece_many?: Maybe<
    Array<Maybe<ConcavePiece_Mutation_Response>>
  >;
  /** update data of the table: "customer" */
  update_customer?: Maybe<Customer_Mutation_Response>;
  /** update single row of the table: "customer" */
  update_customer_by_pk?: Maybe<Customer>;
  /** update multiples rows of table: "customer" */
  update_customer_many?: Maybe<Array<Maybe<Customer_Mutation_Response>>>;
  /** update data of the table: "fileType" */
  update_fileType?: Maybe<FileType_Mutation_Response>;
  /** update single row of the table: "fileType" */
  update_fileType_by_pk?: Maybe<FileType>;
  /** update multiples rows of table: "fileType" */
  update_fileType_many?: Maybe<Array<Maybe<FileType_Mutation_Response>>>;
  /** update data of the table: "followUp" */
  update_followUp?: Maybe<FollowUp_Mutation_Response>;
  /** update single row of the table: "followUp" */
  update_followUp_by_pk?: Maybe<FollowUp>;
  /** update multiples rows of table: "followUp" */
  update_followUp_many?: Maybe<Array<Maybe<FollowUp_Mutation_Response>>>;
  /** update data of the table: "grinding" */
  update_grinding?: Maybe<Grinding_Mutation_Response>;
  /** update single row of the table: "grinding" */
  update_grinding_by_pk?: Maybe<Grinding>;
  /** update multiples rows of table: "grinding" */
  update_grinding_many?: Maybe<Array<Maybe<Grinding_Mutation_Response>>>;
  /** update data of the table: "mantlePiece" */
  update_mantlePiece?: Maybe<MantlePiece_Mutation_Response>;
  /** update single row of the table: "mantlePiece" */
  update_mantlePiece_by_pk?: Maybe<MantlePiece>;
  /** update multiples rows of table: "mantlePiece" */
  update_mantlePiece_many?: Maybe<Array<Maybe<MantlePiece_Mutation_Response>>>;
  /** update data of the table: "miningProduct" */
  update_miningProduct?: Maybe<MiningProduct_Mutation_Response>;
  /** update single row of the table: "miningProduct" */
  update_miningProduct_by_pk?: Maybe<MiningProduct>;
  /** update multiples rows of table: "miningProduct" */
  update_miningProduct_many?: Maybe<
    Array<Maybe<MiningProduct_Mutation_Response>>
  >;
  /** update data of the table: "partSet" */
  update_partSet?: Maybe<PartSet_Mutation_Response>;
  /** update single row of the table: "partSet" */
  update_partSet_by_pk?: Maybe<PartSet>;
  /** update multiples rows of table: "partSet" */
  update_partSet_many?: Maybe<Array<Maybe<PartSet_Mutation_Response>>>;
  /** update data of the table: "settings" */
  update_settings?: Maybe<Settings_Mutation_Response>;
  /** update single row of the table: "settings" */
  update_settings_by_pk?: Maybe<Settings>;
  /** update multiples rows of table: "settings" */
  update_settings_many?: Maybe<Array<Maybe<Settings_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
};

/** mutation root */
export type Mutation_RootDelete_AttachmentArgs = {
  where: Attachment_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_CaseArgs = {
  where: Case_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_CaseStatusArgs = {
  where: CaseStatus_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_CaseStatus_By_PkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type Mutation_RootDelete_Case_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_ConcavePieceArgs = {
  where: ConcavePiece_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_ConcavePiece_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_CustomerArgs = {
  where: Customer_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Customer_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_FileTypeArgs = {
  where: FileType_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_FileType_By_PkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type Mutation_RootDelete_FollowUpArgs = {
  where: FollowUp_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_FollowUp_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_GrindingArgs = {
  where: Grinding_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Grinding_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_MantlePieceArgs = {
  where: MantlePiece_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_MantlePiece_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_MiningProductArgs = {
  where: MiningProduct_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_MiningProduct_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_PartSetArgs = {
  where: PartSet_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_PartSet_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_SettingsArgs = {
  where: Settings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Settings_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type Mutation_RootInsert_AttachmentArgs = {
  objects: Array<Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Attachment_OneArgs = {
  object: Attachment_Insert_Input;
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CaseArgs = {
  objects: Array<Case_Insert_Input>;
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CaseStatusArgs = {
  objects: Array<CaseStatus_Insert_Input>;
  on_conflict?: InputMaybe<CaseStatus_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CaseStatus_OneArgs = {
  object: CaseStatus_Insert_Input;
  on_conflict?: InputMaybe<CaseStatus_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Case_OneArgs = {
  object: Case_Insert_Input;
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ConcavePieceArgs = {
  objects: Array<ConcavePiece_Insert_Input>;
  on_conflict?: InputMaybe<ConcavePiece_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ConcavePiece_OneArgs = {
  object: ConcavePiece_Insert_Input;
  on_conflict?: InputMaybe<ConcavePiece_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CustomerArgs = {
  objects: Array<Customer_Insert_Input>;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Customer_OneArgs = {
  object: Customer_Insert_Input;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FileTypeArgs = {
  objects: Array<FileType_Insert_Input>;
  on_conflict?: InputMaybe<FileType_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FileType_OneArgs = {
  object: FileType_Insert_Input;
  on_conflict?: InputMaybe<FileType_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FollowUpArgs = {
  objects: Array<FollowUp_Insert_Input>;
  on_conflict?: InputMaybe<FollowUp_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_FollowUp_OneArgs = {
  object: FollowUp_Insert_Input;
  on_conflict?: InputMaybe<FollowUp_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_GrindingArgs = {
  objects: Array<Grinding_Insert_Input>;
  on_conflict?: InputMaybe<Grinding_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Grinding_OneArgs = {
  object: Grinding_Insert_Input;
  on_conflict?: InputMaybe<Grinding_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MantlePieceArgs = {
  objects: Array<MantlePiece_Insert_Input>;
  on_conflict?: InputMaybe<MantlePiece_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MantlePiece_OneArgs = {
  object: MantlePiece_Insert_Input;
  on_conflict?: InputMaybe<MantlePiece_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MiningProductArgs = {
  objects: Array<MiningProduct_Insert_Input>;
  on_conflict?: InputMaybe<MiningProduct_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_MiningProduct_OneArgs = {
  object: MiningProduct_Insert_Input;
  on_conflict?: InputMaybe<MiningProduct_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_PartSetArgs = {
  objects: Array<PartSet_Insert_Input>;
  on_conflict?: InputMaybe<PartSet_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_PartSet_OneArgs = {
  object: PartSet_Insert_Input;
  on_conflict?: InputMaybe<PartSet_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_SettingsArgs = {
  objects: Array<Settings_Insert_Input>;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Settings_OneArgs = {
  object: Settings_Insert_Input;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** mutation root */
export type Mutation_RootUpdate_AttachmentArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>;
  _set?: InputMaybe<Attachment_Set_Input>;
  where: Attachment_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>;
  _set?: InputMaybe<Attachment_Set_Input>;
  pk_columns: Attachment_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Attachment_ManyArgs = {
  updates: Array<Attachment_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_CaseArgs = {
  _append?: InputMaybe<Case_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Delete_Key_Input>;
  _inc?: InputMaybe<Case_Inc_Input>;
  _prepend?: InputMaybe<Case_Prepend_Input>;
  _set?: InputMaybe<Case_Set_Input>;
  where: Case_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_CaseStatusArgs = {
  _set?: InputMaybe<CaseStatus_Set_Input>;
  where: CaseStatus_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_CaseStatus_By_PkArgs = {
  _set?: InputMaybe<CaseStatus_Set_Input>;
  pk_columns: CaseStatus_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_CaseStatus_ManyArgs = {
  updates: Array<CaseStatus_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Case_By_PkArgs = {
  _append?: InputMaybe<Case_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Delete_Key_Input>;
  _inc?: InputMaybe<Case_Inc_Input>;
  _prepend?: InputMaybe<Case_Prepend_Input>;
  _set?: InputMaybe<Case_Set_Input>;
  pk_columns: Case_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Case_ManyArgs = {
  updates: Array<Case_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_ConcavePieceArgs = {
  _inc?: InputMaybe<ConcavePiece_Inc_Input>;
  _set?: InputMaybe<ConcavePiece_Set_Input>;
  where: ConcavePiece_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_ConcavePiece_By_PkArgs = {
  _inc?: InputMaybe<ConcavePiece_Inc_Input>;
  _set?: InputMaybe<ConcavePiece_Set_Input>;
  pk_columns: ConcavePiece_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ConcavePiece_ManyArgs = {
  updates: Array<ConcavePiece_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_CustomerArgs = {
  _inc?: InputMaybe<Customer_Inc_Input>;
  _set?: InputMaybe<Customer_Set_Input>;
  where: Customer_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Customer_By_PkArgs = {
  _inc?: InputMaybe<Customer_Inc_Input>;
  _set?: InputMaybe<Customer_Set_Input>;
  pk_columns: Customer_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Customer_ManyArgs = {
  updates: Array<Customer_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_FileTypeArgs = {
  _set?: InputMaybe<FileType_Set_Input>;
  where: FileType_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_FileType_By_PkArgs = {
  _set?: InputMaybe<FileType_Set_Input>;
  pk_columns: FileType_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_FileType_ManyArgs = {
  updates: Array<FileType_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_FollowUpArgs = {
  _inc?: InputMaybe<FollowUp_Inc_Input>;
  _set?: InputMaybe<FollowUp_Set_Input>;
  where: FollowUp_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_FollowUp_By_PkArgs = {
  _inc?: InputMaybe<FollowUp_Inc_Input>;
  _set?: InputMaybe<FollowUp_Set_Input>;
  pk_columns: FollowUp_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_FollowUp_ManyArgs = {
  updates: Array<FollowUp_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_GrindingArgs = {
  _inc?: InputMaybe<Grinding_Inc_Input>;
  _set?: InputMaybe<Grinding_Set_Input>;
  where: Grinding_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Grinding_By_PkArgs = {
  _inc?: InputMaybe<Grinding_Inc_Input>;
  _set?: InputMaybe<Grinding_Set_Input>;
  pk_columns: Grinding_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Grinding_ManyArgs = {
  updates: Array<Grinding_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_MantlePieceArgs = {
  _inc?: InputMaybe<MantlePiece_Inc_Input>;
  _set?: InputMaybe<MantlePiece_Set_Input>;
  where: MantlePiece_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_MantlePiece_By_PkArgs = {
  _inc?: InputMaybe<MantlePiece_Inc_Input>;
  _set?: InputMaybe<MantlePiece_Set_Input>;
  pk_columns: MantlePiece_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_MantlePiece_ManyArgs = {
  updates: Array<MantlePiece_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_MiningProductArgs = {
  _inc?: InputMaybe<MiningProduct_Inc_Input>;
  _set?: InputMaybe<MiningProduct_Set_Input>;
  where: MiningProduct_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_MiningProduct_By_PkArgs = {
  _inc?: InputMaybe<MiningProduct_Inc_Input>;
  _set?: InputMaybe<MiningProduct_Set_Input>;
  pk_columns: MiningProduct_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_MiningProduct_ManyArgs = {
  updates: Array<MiningProduct_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_PartSetArgs = {
  _inc?: InputMaybe<PartSet_Inc_Input>;
  _set?: InputMaybe<PartSet_Set_Input>;
  where: PartSet_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_PartSet_By_PkArgs = {
  _inc?: InputMaybe<PartSet_Inc_Input>;
  _set?: InputMaybe<PartSet_Set_Input>;
  pk_columns: PartSet_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_PartSet_ManyArgs = {
  updates: Array<PartSet_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_SettingsArgs = {
  _append?: InputMaybe<Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Settings_Inc_Input>;
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  _set?: InputMaybe<Settings_Set_Input>;
  where: Settings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Settings_By_PkArgs = {
  _append?: InputMaybe<Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Settings_Inc_Input>;
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  _set?: InputMaybe<Settings_Set_Input>;
  pk_columns: Settings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Settings_ManyArgs = {
  updates: Array<Settings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

/** columns and relationships of "partSet" */
export type PartSet = {
  __typename?: 'partSet';
  additionalInfoForTiers?: Maybe<Scalars['String']>;
  bowlLinerDescription?: Maybe<Scalars['String']>;
  bowlLinerMaterial?: Maybe<Scalars['String']>;
  bowlLinerPartNumber?: Maybe<Scalars['String']>;
  bowlLinerPrice?: Maybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerWeight?: Maybe<Scalars['numeric']>;
  carouselInUse?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  case?: Maybe<Case>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChange?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  concavePieces: Array<ConcavePiece>;
  /** An aggregate relationship */
  concavePieces_aggregate: ConcavePiece_Aggregate;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['numeric']>;
  desiredEndProduct?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id: Scalars['Int'];
  lowerMantlesPerSet?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  mantlePieces: Array<MantlePiece>;
  /** An aggregate relationship */
  mantlePieces_aggregate: MantlePiece_Aggregate;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['numeric']>;
  numberOfConcaveTiers?: Maybe<Scalars['Int']>;
  numberOfMantlePieces?: Maybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['numeric']>;
  otherRelineCost?: Maybe<Scalars['Int']>;
  p80Crusher?: Maybe<Scalars['numeric']>;
  p80Screen?: Maybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['numeric']>;
  relineCostDirect?: Maybe<Scalars['Int']>;
  relineDowntime?: Maybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  /** Indicates whether part set is filled on solution page or on data collection phase. */
  solution: Scalars['Boolean'];
  /** Part set supplier name */
  supplierName?: Maybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['numeric']>;
  wearLifeOfPartSets?: Maybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "partSet" */
export type PartSetConcavePiecesArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

/** columns and relationships of "partSet" */
export type PartSetConcavePieces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

/** columns and relationships of "partSet" */
export type PartSetMantlePiecesArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

/** columns and relationships of "partSet" */
export type PartSetMantlePieces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

/** aggregated selection of "partSet" */
export type PartSet_Aggregate = {
  __typename?: 'partSet_aggregate';
  aggregate?: Maybe<PartSet_Aggregate_Fields>;
  nodes: Array<PartSet>;
};

export type PartSet_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PartSet_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PartSet_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PartSet_Aggregate_Bool_Exp_Count>;
};

export type PartSet_Aggregate_Bool_Exp_Bool_And = {
  arguments: PartSet_Select_Column_PartSet_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartSet_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PartSet_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PartSet_Select_Column_PartSet_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartSet_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PartSet_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PartSet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartSet_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partSet" */
export type PartSet_Aggregate_Fields = {
  __typename?: 'partSet_aggregate_fields';
  avg?: Maybe<PartSet_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PartSet_Max_Fields>;
  min?: Maybe<PartSet_Min_Fields>;
  stddev?: Maybe<PartSet_Stddev_Fields>;
  stddev_pop?: Maybe<PartSet_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PartSet_Stddev_Samp_Fields>;
  sum?: Maybe<PartSet_Sum_Fields>;
  var_pop?: Maybe<PartSet_Var_Pop_Fields>;
  var_samp?: Maybe<PartSet_Var_Samp_Fields>;
  variance?: Maybe<PartSet_Variance_Fields>;
};

/** aggregate fields of "partSet" */
export type PartSet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PartSet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partSet" */
export type PartSet_Aggregate_Order_By = {
  avg?: InputMaybe<PartSet_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PartSet_Max_Order_By>;
  min?: InputMaybe<PartSet_Min_Order_By>;
  stddev?: InputMaybe<PartSet_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PartSet_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PartSet_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PartSet_Sum_Order_By>;
  var_pop?: InputMaybe<PartSet_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PartSet_Var_Samp_Order_By>;
  variance?: InputMaybe<PartSet_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partSet" */
export type PartSet_Arr_Rel_Insert_Input = {
  data: Array<PartSet_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PartSet_On_Conflict>;
};

/** aggregate avg on columns */
export type PartSet_Avg_Fields = {
  __typename?: 'partSet_avg_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "partSet" */
export type PartSet_Avg_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partSet". All fields are combined with a logical 'AND'. */
export type PartSet_Bool_Exp = {
  _and?: InputMaybe<Array<PartSet_Bool_Exp>>;
  _not?: InputMaybe<PartSet_Bool_Exp>;
  _or?: InputMaybe<Array<PartSet_Bool_Exp>>;
  additionalInfoForTiers?: InputMaybe<String_Comparison_Exp>;
  bowlLinerDescription?: InputMaybe<String_Comparison_Exp>;
  bowlLinerMaterial?: InputMaybe<String_Comparison_Exp>;
  bowlLinerPartNumber?: InputMaybe<String_Comparison_Exp>;
  bowlLinerPrice?: InputMaybe<Numeric_Comparison_Exp>;
  bowlLinerPriceMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  bowlLinerPricePerKg?: InputMaybe<Numeric_Comparison_Exp>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  bowlLinerWeight?: InputMaybe<Numeric_Comparison_Exp>;
  carouselInUse?: InputMaybe<Boolean_Comparison_Exp>;
  case?: InputMaybe<Case_Bool_Exp>;
  caseId?: InputMaybe<Int_Comparison_Exp>;
  changeOutCostMantleToShaft?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutCostOfSegment?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutCostShaftChange?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutShaftChangeDowntime?: InputMaybe<Numeric_Comparison_Exp>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  concavePieces?: InputMaybe<ConcavePiece_Bool_Exp>;
  concavePieces_aggregate?: InputMaybe<ConcavePiece_Aggregate_Bool_Exp>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Numeric_Comparison_Exp>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Numeric_Comparison_Exp>;
  desiredEndProduct?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lowerMantlesPerSet?: InputMaybe<Numeric_Comparison_Exp>;
  mantlePieces?: InputMaybe<MantlePiece_Bool_Exp>;
  mantlePieces_aggregate?: InputMaybe<MantlePiece_Aggregate_Bool_Exp>;
  middleMantlesPerSet?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfConcaveTiers?: InputMaybe<Int_Comparison_Exp>;
  numberOfMantlePieces?: InputMaybe<Int_Comparison_Exp>;
  otherCostsOfSegmentChange?: InputMaybe<Numeric_Comparison_Exp>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  otherRelineCost?: InputMaybe<Int_Comparison_Exp>;
  p80Crusher?: InputMaybe<Numeric_Comparison_Exp>;
  p80Screen?: InputMaybe<Numeric_Comparison_Exp>;
  priceOfSegmentSet?: InputMaybe<Numeric_Comparison_Exp>;
  priceOfUpperMantle?: InputMaybe<Numeric_Comparison_Exp>;
  relineCostDirect?: InputMaybe<Int_Comparison_Exp>;
  relineDowntime?: InputMaybe<Int_Comparison_Exp>;
  segmentChangeOutDowntime?: InputMaybe<Numeric_Comparison_Exp>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  solution?: InputMaybe<Boolean_Comparison_Exp>;
  supplierName?: InputMaybe<String_Comparison_Exp>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Numeric_Comparison_Exp>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Numeric_Comparison_Exp>;
  totalCrushingCapacity?: InputMaybe<Numeric_Comparison_Exp>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Numeric_Comparison_Exp>;
  upperMantlesPerSet?: InputMaybe<Numeric_Comparison_Exp>;
  wearLifeOfPartSets?: InputMaybe<Numeric_Comparison_Exp>;
  wearLifePartsSet?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "partSet" */
export enum PartSet_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartSetPkey = 'partSet_pkey',
}

/** input type for incrementing numeric columns in table "partSet" */
export type PartSet_Inc_Input = {
  bowlLinerPrice?: InputMaybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerWeight?: InputMaybe<Scalars['numeric']>;
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: InputMaybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChange?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Scalars['numeric']>;
  desiredEndProduct?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  lowerMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  numberOfConcaveTiers?: InputMaybe<Scalars['Int']>;
  numberOfMantlePieces?: InputMaybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  otherRelineCost?: InputMaybe<Scalars['Int']>;
  p80Crusher?: InputMaybe<Scalars['numeric']>;
  p80Screen?: InputMaybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Scalars['numeric']>;
  relineCostDirect?: InputMaybe<Scalars['Int']>;
  relineDowntime?: InputMaybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  wearLifeOfPartSets?: InputMaybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "partSet" */
export type PartSet_Insert_Input = {
  additionalInfoForTiers?: InputMaybe<Scalars['String']>;
  bowlLinerDescription?: InputMaybe<Scalars['String']>;
  bowlLinerMaterial?: InputMaybe<Scalars['String']>;
  bowlLinerPartNumber?: InputMaybe<Scalars['String']>;
  bowlLinerPrice?: InputMaybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerWeight?: InputMaybe<Scalars['numeric']>;
  carouselInUse?: InputMaybe<Scalars['Boolean']>;
  case?: InputMaybe<Case_Obj_Rel_Insert_Input>;
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: InputMaybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChange?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  concavePieces?: InputMaybe<ConcavePiece_Arr_Rel_Insert_Input>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Scalars['numeric']>;
  desiredEndProduct?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  lowerMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  mantlePieces?: InputMaybe<MantlePiece_Arr_Rel_Insert_Input>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  numberOfConcaveTiers?: InputMaybe<Scalars['Int']>;
  numberOfMantlePieces?: InputMaybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  otherRelineCost?: InputMaybe<Scalars['Int']>;
  p80Crusher?: InputMaybe<Scalars['numeric']>;
  p80Screen?: InputMaybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Scalars['numeric']>;
  relineCostDirect?: InputMaybe<Scalars['Int']>;
  relineDowntime?: InputMaybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Indicates whether part set is filled on solution page or on data collection phase. */
  solution?: InputMaybe<Scalars['Boolean']>;
  /** Part set supplier name */
  supplierName?: InputMaybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  wearLifeOfPartSets?: InputMaybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PartSet_Max_Fields = {
  __typename?: 'partSet_max_fields';
  additionalInfoForTiers?: Maybe<Scalars['String']>;
  bowlLinerDescription?: Maybe<Scalars['String']>;
  bowlLinerMaterial?: Maybe<Scalars['String']>;
  bowlLinerPartNumber?: Maybe<Scalars['String']>;
  bowlLinerPrice?: Maybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerWeight?: Maybe<Scalars['numeric']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChange?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['numeric']>;
  desiredEndProduct?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  lowerMantlesPerSet?: Maybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['numeric']>;
  numberOfConcaveTiers?: Maybe<Scalars['Int']>;
  numberOfMantlePieces?: Maybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['numeric']>;
  otherRelineCost?: Maybe<Scalars['Int']>;
  p80Crusher?: Maybe<Scalars['numeric']>;
  p80Screen?: Maybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['numeric']>;
  relineCostDirect?: Maybe<Scalars['Int']>;
  relineDowntime?: Maybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  /** Part set supplier name */
  supplierName?: Maybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['numeric']>;
  wearLifeOfPartSets?: Maybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "partSet" */
export type PartSet_Max_Order_By = {
  additionalInfoForTiers?: InputMaybe<Order_By>;
  bowlLinerDescription?: InputMaybe<Order_By>;
  bowlLinerMaterial?: InputMaybe<Order_By>;
  bowlLinerPartNumber?: InputMaybe<Order_By>;
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  /** Part set supplier name */
  supplierName?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PartSet_Min_Fields = {
  __typename?: 'partSet_min_fields';
  additionalInfoForTiers?: Maybe<Scalars['String']>;
  bowlLinerDescription?: Maybe<Scalars['String']>;
  bowlLinerMaterial?: Maybe<Scalars['String']>;
  bowlLinerPartNumber?: Maybe<Scalars['String']>;
  bowlLinerPrice?: Maybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerWeight?: Maybe<Scalars['numeric']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChange?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['numeric']>;
  desiredEndProduct?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  lowerMantlesPerSet?: Maybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['numeric']>;
  numberOfConcaveTiers?: Maybe<Scalars['Int']>;
  numberOfMantlePieces?: Maybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['numeric']>;
  otherRelineCost?: Maybe<Scalars['Int']>;
  p80Crusher?: Maybe<Scalars['numeric']>;
  p80Screen?: Maybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['numeric']>;
  relineCostDirect?: Maybe<Scalars['Int']>;
  relineDowntime?: Maybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  /** Part set supplier name */
  supplierName?: Maybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['numeric']>;
  wearLifeOfPartSets?: Maybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "partSet" */
export type PartSet_Min_Order_By = {
  additionalInfoForTiers?: InputMaybe<Order_By>;
  bowlLinerDescription?: InputMaybe<Order_By>;
  bowlLinerMaterial?: InputMaybe<Order_By>;
  bowlLinerPartNumber?: InputMaybe<Order_By>;
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  /** Part set supplier name */
  supplierName?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partSet" */
export type PartSet_Mutation_Response = {
  __typename?: 'partSet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartSet>;
};

/** input type for inserting object relation for remote table "partSet" */
export type PartSet_Obj_Rel_Insert_Input = {
  data: PartSet_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PartSet_On_Conflict>;
};

/** on_conflict condition type for table "partSet" */
export type PartSet_On_Conflict = {
  constraint: PartSet_Constraint;
  update_columns?: Array<PartSet_Update_Column>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

/** Ordering options when selecting data from "partSet". */
export type PartSet_Order_By = {
  additionalInfoForTiers?: InputMaybe<Order_By>;
  bowlLinerDescription?: InputMaybe<Order_By>;
  bowlLinerMaterial?: InputMaybe<Order_By>;
  bowlLinerPartNumber?: InputMaybe<Order_By>;
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  carouselInUse?: InputMaybe<Order_By>;
  case?: InputMaybe<Case_Order_By>;
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  concavePieces_aggregate?: InputMaybe<ConcavePiece_Aggregate_Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  mantlePieces_aggregate?: InputMaybe<MantlePiece_Aggregate_Order_By>;
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  priceOfSegmentSet?: InputMaybe<Order_By>;
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
  supplierName?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partSet */
export type PartSet_Pk_Columns_Input = {
  /** The id of an object */
  id: Scalars['Int'];
};

/** select columns of table "partSet" */
export enum PartSet_Select_Column {
  /** column name */
  AdditionalInfoForTiers = 'additionalInfoForTiers',
  /** column name */
  BowlLinerDescription = 'bowlLinerDescription',
  /** column name */
  BowlLinerMaterial = 'bowlLinerMaterial',
  /** column name */
  BowlLinerPartNumber = 'bowlLinerPartNumber',
  /** column name */
  BowlLinerPrice = 'bowlLinerPrice',
  /** column name */
  BowlLinerPriceMarketArea = 'bowlLinerPriceMarketArea',
  /** column name */
  BowlLinerPricePerKg = 'bowlLinerPricePerKg',
  /** column name */
  BowlLinerPricePerKgMarketArea = 'bowlLinerPricePerKgMarketArea',
  /** column name */
  BowlLinerWeight = 'bowlLinerWeight',
  /** column name */
  CarouselInUse = 'carouselInUse',
  /** column name */
  CaseId = 'caseId',
  /** column name */
  ChangeOutCostMantleToShaft = 'changeOutCostMantleToShaft',
  /** column name */
  ChangeOutCostMantleToShaftMarketArea = 'changeOutCostMantleToShaftMarketArea',
  /** column name */
  ChangeOutCostOfSegment = 'changeOutCostOfSegment',
  /** column name */
  ChangeOutCostOfSegmentMarketArea = 'changeOutCostOfSegmentMarketArea',
  /** column name */
  ChangeOutCostShaftChange = 'changeOutCostShaftChange',
  /** column name */
  ChangeOutCostShaftChangeMarketArea = 'changeOutCostShaftChangeMarketArea',
  /** column name */
  ChangeOutShaftChangeDowntime = 'changeOutShaftChangeDowntime',
  /** column name */
  ChangeOutShaftChangeDowntimeMarketArea = 'changeOutShaftChangeDowntimeMarketArea',
  /** column name */
  CrusherWearLifePerConcaveSetHours = 'crusherWearLifePerConcaveSetHours',
  /** column name */
  CrusherWearLifePerConcaveSetTons = 'crusherWearLifePerConcaveSetTons',
  /** column name */
  DesiredEndProduct = 'desiredEndProduct',
  /** column name */
  Id = 'id',
  /** column name */
  LowerMantlesPerSet = 'lowerMantlesPerSet',
  /** column name */
  MiddleMantlesPerSet = 'middleMantlesPerSet',
  /** column name */
  NumberOfConcaveTiers = 'numberOfConcaveTiers',
  /** column name */
  NumberOfMantlePieces = 'numberOfMantlePieces',
  /** column name */
  OtherCostsOfSegmentChange = 'otherCostsOfSegmentChange',
  /** column name */
  OtherCostsOfSegmentChangeMarketArea = 'otherCostsOfSegmentChangeMarketArea',
  /** column name */
  OtherRelineCost = 'otherRelineCost',
  /** column name */
  P80Crusher = 'p80Crusher',
  /** column name */
  P80Screen = 'p80Screen',
  /** column name */
  PriceOfSegmentSet = 'priceOfSegmentSet',
  /** column name */
  PriceOfUpperMantle = 'priceOfUpperMantle',
  /** column name */
  RelineCostDirect = 'relineCostDirect',
  /** column name */
  RelineDowntime = 'relineDowntime',
  /** column name */
  SegmentChangeOutDowntime = 'segmentChangeOutDowntime',
  /** column name */
  SegmentChangeOutDowntimeMarketArea = 'segmentChangeOutDowntimeMarketArea',
  /** column name */
  Solution = 'solution',
  /** column name */
  SupplierName = 'supplierName',
  /** column name */
  TotalCostOfConcaveSegmentSet = 'totalCostOfConcaveSegmentSet',
  /** column name */
  TotalCostOfConcaveSegmentSetMarketArea = 'totalCostOfConcaveSegmentSetMarketArea',
  /** column name */
  TotalCrushingCapacity = 'totalCrushingCapacity',
  /** column name */
  TotalWeightOfConcaveSegmentSet = 'totalWeightOfConcaveSegmentSet',
  /** column name */
  UpperMantlesPerSet = 'upperMantlesPerSet',
  /** column name */
  WearLifeOfPartSets = 'wearLifeOfPartSets',
  /** column name */
  WearLifePartsSet = 'wearLifePartsSet',
}

/** select "partSet_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partSet" */
export enum PartSet_Select_Column_PartSet_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CarouselInUse = 'carouselInUse',
  /** column name */
  Solution = 'solution',
}

/** select "partSet_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partSet" */
export enum PartSet_Select_Column_PartSet_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CarouselInUse = 'carouselInUse',
  /** column name */
  Solution = 'solution',
}

/** input type for updating data in table "partSet" */
export type PartSet_Set_Input = {
  additionalInfoForTiers?: InputMaybe<Scalars['String']>;
  bowlLinerDescription?: InputMaybe<Scalars['String']>;
  bowlLinerMaterial?: InputMaybe<Scalars['String']>;
  bowlLinerPartNumber?: InputMaybe<Scalars['String']>;
  bowlLinerPrice?: InputMaybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerWeight?: InputMaybe<Scalars['numeric']>;
  carouselInUse?: InputMaybe<Scalars['Boolean']>;
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: InputMaybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChange?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Scalars['numeric']>;
  desiredEndProduct?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  lowerMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  numberOfConcaveTiers?: InputMaybe<Scalars['Int']>;
  numberOfMantlePieces?: InputMaybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  otherRelineCost?: InputMaybe<Scalars['Int']>;
  p80Crusher?: InputMaybe<Scalars['numeric']>;
  p80Screen?: InputMaybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Scalars['numeric']>;
  relineCostDirect?: InputMaybe<Scalars['Int']>;
  relineDowntime?: InputMaybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Indicates whether part set is filled on solution page or on data collection phase. */
  solution?: InputMaybe<Scalars['Boolean']>;
  /** Part set supplier name */
  supplierName?: InputMaybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  wearLifeOfPartSets?: InputMaybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PartSet_Stddev_Fields = {
  __typename?: 'partSet_stddev_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "partSet" */
export type PartSet_Stddev_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PartSet_Stddev_Pop_Fields = {
  __typename?: 'partSet_stddev_pop_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "partSet" */
export type PartSet_Stddev_Pop_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PartSet_Stddev_Samp_Fields = {
  __typename?: 'partSet_stddev_samp_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "partSet" */
export type PartSet_Stddev_Samp_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partSet" */
export type PartSet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PartSet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PartSet_Stream_Cursor_Value_Input = {
  additionalInfoForTiers?: InputMaybe<Scalars['String']>;
  bowlLinerDescription?: InputMaybe<Scalars['String']>;
  bowlLinerMaterial?: InputMaybe<Scalars['String']>;
  bowlLinerPartNumber?: InputMaybe<Scalars['String']>;
  bowlLinerPrice?: InputMaybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: InputMaybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Scalars['numeric']>;
  bowlLinerWeight?: InputMaybe<Scalars['numeric']>;
  carouselInUse?: InputMaybe<Scalars['Boolean']>;
  /** The caseId of an object */
  caseId?: InputMaybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: InputMaybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChange?: InputMaybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: InputMaybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Scalars['numeric']>;
  desiredEndProduct?: InputMaybe<Scalars['numeric']>;
  /** The id of an object */
  id?: InputMaybe<Scalars['Int']>;
  lowerMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  numberOfConcaveTiers?: InputMaybe<Scalars['Int']>;
  numberOfMantlePieces?: InputMaybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Scalars['numeric']>;
  otherRelineCost?: InputMaybe<Scalars['Int']>;
  p80Crusher?: InputMaybe<Scalars['numeric']>;
  p80Screen?: InputMaybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Scalars['numeric']>;
  relineCostDirect?: InputMaybe<Scalars['Int']>;
  relineDowntime?: InputMaybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Indicates whether part set is filled on solution page or on data collection phase. */
  solution?: InputMaybe<Scalars['Boolean']>;
  /** Part set supplier name */
  supplierName?: InputMaybe<Scalars['String']>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Scalars['numeric']>;
  wearLifeOfPartSets?: InputMaybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PartSet_Sum_Fields = {
  __typename?: 'partSet_sum_fields';
  bowlLinerPrice?: Maybe<Scalars['numeric']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKg?: Maybe<Scalars['numeric']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['numeric']>;
  bowlLinerWeight?: Maybe<Scalars['numeric']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Int']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['numeric']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['numeric']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['numeric']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChange?: Maybe<Scalars['numeric']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['numeric']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['numeric']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['numeric']>;
  desiredEndProduct?: Maybe<Scalars['numeric']>;
  /** The id of an object */
  id?: Maybe<Scalars['Int']>;
  lowerMantlesPerSet?: Maybe<Scalars['numeric']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['numeric']>;
  numberOfConcaveTiers?: Maybe<Scalars['Int']>;
  numberOfMantlePieces?: Maybe<Scalars['Int']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['numeric']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['numeric']>;
  otherRelineCost?: Maybe<Scalars['Int']>;
  p80Crusher?: Maybe<Scalars['numeric']>;
  p80Screen?: Maybe<Scalars['numeric']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['numeric']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['numeric']>;
  relineCostDirect?: Maybe<Scalars['Int']>;
  relineDowntime?: Maybe<Scalars['Int']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['numeric']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['numeric']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['numeric']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['numeric']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['numeric']>;
  wearLifeOfPartSets?: Maybe<Scalars['numeric']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "partSet" */
export type PartSet_Sum_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** update columns of table "partSet" */
export enum PartSet_Update_Column {
  /** column name */
  AdditionalInfoForTiers = 'additionalInfoForTiers',
  /** column name */
  BowlLinerDescription = 'bowlLinerDescription',
  /** column name */
  BowlLinerMaterial = 'bowlLinerMaterial',
  /** column name */
  BowlLinerPartNumber = 'bowlLinerPartNumber',
  /** column name */
  BowlLinerPrice = 'bowlLinerPrice',
  /** column name */
  BowlLinerPriceMarketArea = 'bowlLinerPriceMarketArea',
  /** column name */
  BowlLinerPricePerKg = 'bowlLinerPricePerKg',
  /** column name */
  BowlLinerPricePerKgMarketArea = 'bowlLinerPricePerKgMarketArea',
  /** column name */
  BowlLinerWeight = 'bowlLinerWeight',
  /** column name */
  CarouselInUse = 'carouselInUse',
  /** column name */
  CaseId = 'caseId',
  /** column name */
  ChangeOutCostMantleToShaft = 'changeOutCostMantleToShaft',
  /** column name */
  ChangeOutCostMantleToShaftMarketArea = 'changeOutCostMantleToShaftMarketArea',
  /** column name */
  ChangeOutCostOfSegment = 'changeOutCostOfSegment',
  /** column name */
  ChangeOutCostOfSegmentMarketArea = 'changeOutCostOfSegmentMarketArea',
  /** column name */
  ChangeOutCostShaftChange = 'changeOutCostShaftChange',
  /** column name */
  ChangeOutCostShaftChangeMarketArea = 'changeOutCostShaftChangeMarketArea',
  /** column name */
  ChangeOutShaftChangeDowntime = 'changeOutShaftChangeDowntime',
  /** column name */
  ChangeOutShaftChangeDowntimeMarketArea = 'changeOutShaftChangeDowntimeMarketArea',
  /** column name */
  CrusherWearLifePerConcaveSetHours = 'crusherWearLifePerConcaveSetHours',
  /** column name */
  CrusherWearLifePerConcaveSetTons = 'crusherWearLifePerConcaveSetTons',
  /** column name */
  DesiredEndProduct = 'desiredEndProduct',
  /** column name */
  Id = 'id',
  /** column name */
  LowerMantlesPerSet = 'lowerMantlesPerSet',
  /** column name */
  MiddleMantlesPerSet = 'middleMantlesPerSet',
  /** column name */
  NumberOfConcaveTiers = 'numberOfConcaveTiers',
  /** column name */
  NumberOfMantlePieces = 'numberOfMantlePieces',
  /** column name */
  OtherCostsOfSegmentChange = 'otherCostsOfSegmentChange',
  /** column name */
  OtherCostsOfSegmentChangeMarketArea = 'otherCostsOfSegmentChangeMarketArea',
  /** column name */
  OtherRelineCost = 'otherRelineCost',
  /** column name */
  P80Crusher = 'p80Crusher',
  /** column name */
  P80Screen = 'p80Screen',
  /** column name */
  PriceOfSegmentSet = 'priceOfSegmentSet',
  /** column name */
  PriceOfUpperMantle = 'priceOfUpperMantle',
  /** column name */
  RelineCostDirect = 'relineCostDirect',
  /** column name */
  RelineDowntime = 'relineDowntime',
  /** column name */
  SegmentChangeOutDowntime = 'segmentChangeOutDowntime',
  /** column name */
  SegmentChangeOutDowntimeMarketArea = 'segmentChangeOutDowntimeMarketArea',
  /** column name */
  Solution = 'solution',
  /** column name */
  SupplierName = 'supplierName',
  /** column name */
  TotalCostOfConcaveSegmentSet = 'totalCostOfConcaveSegmentSet',
  /** column name */
  TotalCostOfConcaveSegmentSetMarketArea = 'totalCostOfConcaveSegmentSetMarketArea',
  /** column name */
  TotalCrushingCapacity = 'totalCrushingCapacity',
  /** column name */
  TotalWeightOfConcaveSegmentSet = 'totalWeightOfConcaveSegmentSet',
  /** column name */
  UpperMantlesPerSet = 'upperMantlesPerSet',
  /** column name */
  WearLifeOfPartSets = 'wearLifeOfPartSets',
  /** column name */
  WearLifePartsSet = 'wearLifePartsSet',
}

export type PartSet_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PartSet_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartSet_Set_Input>;
  /** filter the rows which have to be updated */
  where: PartSet_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PartSet_Var_Pop_Fields = {
  __typename?: 'partSet_var_pop_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "partSet" */
export type PartSet_Var_Pop_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PartSet_Var_Samp_Fields = {
  __typename?: 'partSet_var_samp_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "partSet" */
export type PartSet_Var_Samp_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PartSet_Variance_Fields = {
  __typename?: 'partSet_variance_fields';
  bowlLinerPrice?: Maybe<Scalars['Float']>;
  bowlLinerPriceMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKg?: Maybe<Scalars['Float']>;
  bowlLinerPricePerKgMarketArea?: Maybe<Scalars['Float']>;
  bowlLinerWeight?: Maybe<Scalars['Float']>;
  /** The caseId of an object */
  caseId?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaft?: Maybe<Scalars['Float']>;
  changeOutCostMantleToShaftMarketArea?: Maybe<Scalars['Float']>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: Maybe<Scalars['Float']>;
  changeOutCostOfSegmentMarketArea?: Maybe<Scalars['Float']>;
  changeOutCostShaftChange?: Maybe<Scalars['Float']>;
  changeOutCostShaftChangeMarketArea?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntime?: Maybe<Scalars['Float']>;
  changeOutShaftChangeDowntimeMarketArea?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetHours?: Maybe<Scalars['Float']>;
  crusherWearLifePerConcaveSetTons?: Maybe<Scalars['Float']>;
  desiredEndProduct?: Maybe<Scalars['Float']>;
  /** The id of an object */
  id?: Maybe<Scalars['Float']>;
  lowerMantlesPerSet?: Maybe<Scalars['Float']>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: Maybe<Scalars['Float']>;
  numberOfConcaveTiers?: Maybe<Scalars['Float']>;
  numberOfMantlePieces?: Maybe<Scalars['Float']>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: Maybe<Scalars['Float']>;
  otherCostsOfSegmentChangeMarketArea?: Maybe<Scalars['Float']>;
  otherRelineCost?: Maybe<Scalars['Float']>;
  p80Crusher?: Maybe<Scalars['Float']>;
  p80Screen?: Maybe<Scalars['Float']>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: Maybe<Scalars['Float']>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: Maybe<Scalars['Float']>;
  relineCostDirect?: Maybe<Scalars['Float']>;
  relineDowntime?: Maybe<Scalars['Float']>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: Maybe<Scalars['Float']>;
  segmentChangeOutDowntimeMarketArea?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  totalCostOfConcaveSegmentSetMarketArea?: Maybe<Scalars['Float']>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: Maybe<Scalars['Float']>;
  totalWeightOfConcaveSegmentSet?: Maybe<Scalars['Float']>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: Maybe<Scalars['Float']>;
  wearLifeOfPartSets?: Maybe<Scalars['Float']>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "partSet" */
export type PartSet_Variance_Order_By = {
  bowlLinerPrice?: InputMaybe<Order_By>;
  bowlLinerPriceMarketArea?: InputMaybe<Order_By>;
  bowlLinerPricePerKg?: InputMaybe<Order_By>;
  bowlLinerPricePerKgMarketArea?: InputMaybe<Order_By>;
  bowlLinerWeight?: InputMaybe<Order_By>;
  /** The caseId of an object */
  caseId?: InputMaybe<Order_By>;
  changeOutCostMantleToShaft?: InputMaybe<Order_By>;
  changeOutCostMantleToShaftMarketArea?: InputMaybe<Order_By>;
  /** Change out cost of segment set (eg. 110000) */
  changeOutCostOfSegment?: InputMaybe<Order_By>;
  changeOutCostOfSegmentMarketArea?: InputMaybe<Order_By>;
  changeOutCostShaftChange?: InputMaybe<Order_By>;
  changeOutCostShaftChangeMarketArea?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntime?: InputMaybe<Order_By>;
  changeOutShaftChangeDowntimeMarketArea?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetHours?: InputMaybe<Order_By>;
  crusherWearLifePerConcaveSetTons?: InputMaybe<Order_By>;
  desiredEndProduct?: InputMaybe<Order_By>;
  /** The id of an object */
  id?: InputMaybe<Order_By>;
  lowerMantlesPerSet?: InputMaybe<Order_By>;
  /** Number of middle mantles per set [pcs] (eg. XX) */
  middleMantlesPerSet?: InputMaybe<Order_By>;
  numberOfConcaveTiers?: InputMaybe<Order_By>;
  numberOfMantlePieces?: InputMaybe<Order_By>;
  /** Other costs of segment set (eg. 5000) */
  otherCostsOfSegmentChange?: InputMaybe<Order_By>;
  otherCostsOfSegmentChangeMarketArea?: InputMaybe<Order_By>;
  otherRelineCost?: InputMaybe<Order_By>;
  p80Crusher?: InputMaybe<Order_By>;
  p80Screen?: InputMaybe<Order_By>;
  /** Price of segment set (eg. 110000) */
  priceOfSegmentSet?: InputMaybe<Order_By>;
  /** Price of upper mantle (eg. XX) */
  priceOfUpperMantle?: InputMaybe<Order_By>;
  relineCostDirect?: InputMaybe<Order_By>;
  relineDowntime?: InputMaybe<Order_By>;
  /** Segment change out downtime [h] (eg. 96) */
  segmentChangeOutDowntime?: InputMaybe<Order_By>;
  segmentChangeOutDowntimeMarketArea?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSet?: InputMaybe<Order_By>;
  totalCostOfConcaveSegmentSetMarketArea?: InputMaybe<Order_By>;
  /** Total crushing capacity [t/h] (eg. 3000) */
  totalCrushingCapacity?: InputMaybe<Order_By>;
  totalWeightOfConcaveSegmentSet?: InputMaybe<Order_By>;
  /** Number of upper mantles per set [pcs] (eg. XX) */
  upperMantlesPerSet?: InputMaybe<Order_By>;
  wearLifeOfPartSets?: InputMaybe<Order_By>;
  /** Wear life of parts set [t] (eg. 5000000) */
  wearLifePartsSet?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "attachment" */
  attachment: Array<Attachment>;
  /** fetch aggregated fields from the table: "attachment" */
  attachment_aggregate: Attachment_Aggregate;
  /** fetch data from the table: "attachment" using primary key columns */
  attachment_by_pk?: Maybe<Attachment>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch data from the table: "caseStatus" */
  caseStatus: Array<CaseStatus>;
  /** fetch aggregated fields from the table: "caseStatus" */
  caseStatus_aggregate: CaseStatus_Aggregate;
  /** fetch data from the table: "caseStatus" using primary key columns */
  caseStatus_by_pk?: Maybe<CaseStatus>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table: "concavePiece" */
  concavePiece: Array<ConcavePiece>;
  /** fetch aggregated fields from the table: "concavePiece" */
  concavePiece_aggregate: ConcavePiece_Aggregate;
  /** fetch data from the table: "concavePiece" using primary key columns */
  concavePiece_by_pk?: Maybe<ConcavePiece>;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>;
  /** fetch data from the table: "fileType" */
  fileType: Array<FileType>;
  /** fetch aggregated fields from the table: "fileType" */
  fileType_aggregate: FileType_Aggregate;
  /** fetch data from the table: "fileType" using primary key columns */
  fileType_by_pk?: Maybe<FileType>;
  /** fetch data from the table: "followUp" */
  followUp: Array<FollowUp>;
  /** fetch aggregated fields from the table: "followUp" */
  followUp_aggregate: FollowUp_Aggregate;
  /** fetch data from the table: "followUp" using primary key columns */
  followUp_by_pk?: Maybe<FollowUp>;
  /** fetch data from the table: "grinding" */
  grinding: Array<Grinding>;
  /** fetch aggregated fields from the table: "grinding" */
  grinding_aggregate: Grinding_Aggregate;
  /** fetch data from the table: "grinding" using primary key columns */
  grinding_by_pk?: Maybe<Grinding>;
  /** fetch data from the table: "mantlePiece" */
  mantlePiece: Array<MantlePiece>;
  /** fetch aggregated fields from the table: "mantlePiece" */
  mantlePiece_aggregate: MantlePiece_Aggregate;
  /** fetch data from the table: "mantlePiece" using primary key columns */
  mantlePiece_by_pk?: Maybe<MantlePiece>;
  /** fetch data from the table: "miningProduct" */
  miningProduct: Array<MiningProduct>;
  /** fetch aggregated fields from the table: "miningProduct" */
  miningProduct_aggregate: MiningProduct_Aggregate;
  /** fetch data from the table: "miningProduct" using primary key columns */
  miningProduct_by_pk?: Maybe<MiningProduct>;
  /** fetch data from the table: "partSet" */
  partSet: Array<PartSet>;
  /** fetch aggregated fields from the table: "partSet" */
  partSet_aggregate: PartSet_Aggregate;
  /** fetch data from the table: "partSet" using primary key columns */
  partSet_by_pk?: Maybe<PartSet>;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};

export type Query_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

export type Query_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

export type Query_RootAttachment_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

export type Query_RootCaseStatusArgs = {
  distinct_on?: InputMaybe<Array<CaseStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaseStatus_Order_By>>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

export type Query_RootCaseStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CaseStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaseStatus_Order_By>>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

export type Query_RootCaseStatus_By_PkArgs = {
  name: Scalars['String'];
};

export type Query_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

export type Query_RootCase_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootConcavePieceArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

export type Query_RootConcavePiece_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

export type Query_RootConcavePiece_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type Query_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type Query_RootCustomer_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootFileTypeArgs = {
  distinct_on?: InputMaybe<Array<FileType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileType_Order_By>>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

export type Query_RootFileType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileType_Order_By>>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

export type Query_RootFileType_By_PkArgs = {
  name: Scalars['String'];
};

export type Query_RootFollowUpArgs = {
  distinct_on?: InputMaybe<Array<FollowUp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FollowUp_Order_By>>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

export type Query_RootFollowUp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FollowUp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FollowUp_Order_By>>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

export type Query_RootFollowUp_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootGrindingArgs = {
  distinct_on?: InputMaybe<Array<Grinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grinding_Order_By>>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

export type Query_RootGrinding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grinding_Order_By>>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

export type Query_RootGrinding_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootMantlePieceArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

export type Query_RootMantlePiece_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

export type Query_RootMantlePiece_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootMiningProductArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

export type Query_RootMiningProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

export type Query_RootMiningProduct_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootPartSetArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

export type Query_RootPartSet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

export type Query_RootPartSet_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

export type Query_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

export type Query_RootSettings_By_PkArgs = {
  id: Scalars['Int'];
};

export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

export type Query_RootUser_By_PkArgs = {
  id: Scalars['Int'];
};

/** Case settings */
export type Settings = {
  __typename?: 'settings';
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  disabledFields?: Maybe<Scalars['jsonb']>;
  hideBackingConsumption: Scalars['Boolean'];
  id: Scalars['Int'];
};

/** Case settings */
export type SettingsCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Case settings */
export type SettingsCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Case settings */
export type SettingsDisabledFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "settings" */
export type Settings_Aggregate = {
  __typename?: 'settings_aggregate';
  aggregate?: Maybe<Settings_Aggregate_Fields>;
  nodes: Array<Settings>;
};

/** aggregate fields of "settings" */
export type Settings_Aggregate_Fields = {
  __typename?: 'settings_aggregate_fields';
  avg?: Maybe<Settings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Settings_Max_Fields>;
  min?: Maybe<Settings_Min_Fields>;
  stddev?: Maybe<Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Settings_Sum_Fields>;
  var_pop?: Maybe<Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Settings_Var_Samp_Fields>;
  variance?: Maybe<Settings_Variance_Fields>;
};

/** aggregate fields of "settings" */
export type Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Settings_Append_Input = {
  disabledFields?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Settings_Avg_Fields = {
  __typename?: 'settings_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "settings". All fields are combined with a logical 'AND'. */
export type Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Settings_Bool_Exp>>;
  _not?: InputMaybe<Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Settings_Bool_Exp>>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  disabledFields?: InputMaybe<Jsonb_Comparison_Exp>;
  hideBackingConsumption?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "settings" */
export enum Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  SettingsPkey = 'settings_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Settings_Delete_At_Path_Input = {
  disabledFields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Settings_Delete_Elem_Input = {
  disabledFields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Settings_Delete_Key_Input = {
  disabledFields?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "settings" */
export type Settings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "settings" */
export type Settings_Insert_Input = {
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  disabledFields?: InputMaybe<Scalars['jsonb']>;
  hideBackingConsumption?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Settings_Max_Fields = {
  __typename?: 'settings_max_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Settings_Min_Fields = {
  __typename?: 'settings_min_fields';
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "settings" */
export type Settings_Mutation_Response = {
  __typename?: 'settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Settings>;
};

/** input type for inserting object relation for remote table "settings" */
export type Settings_Obj_Rel_Insert_Input = {
  data: Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};

/** on_conflict condition type for table "settings" */
export type Settings_On_Conflict = {
  constraint: Settings_Constraint;
  update_columns?: Array<Settings_Update_Column>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "settings". */
export type Settings_Order_By = {
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  disabledFields?: InputMaybe<Order_By>;
  hideBackingConsumption?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: settings */
export type Settings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Settings_Prepend_Input = {
  disabledFields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "settings" */
export enum Settings_Select_Column {
  /** column name */
  DisabledFields = 'disabledFields',
  /** column name */
  HideBackingConsumption = 'hideBackingConsumption',
  /** column name */
  Id = 'id',
}

/** input type for updating data in table "settings" */
export type Settings_Set_Input = {
  disabledFields?: InputMaybe<Scalars['jsonb']>;
  hideBackingConsumption?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Settings_Stddev_Fields = {
  __typename?: 'settings_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Settings_Stddev_Pop_Fields = {
  __typename?: 'settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Settings_Stddev_Samp_Fields = {
  __typename?: 'settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "settings" */
export type Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Settings_Stream_Cursor_Value_Input = {
  disabledFields?: InputMaybe<Scalars['jsonb']>;
  hideBackingConsumption?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Settings_Sum_Fields = {
  __typename?: 'settings_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "settings" */
export enum Settings_Update_Column {
  /** column name */
  DisabledFields = 'disabledFields',
  /** column name */
  HideBackingConsumption = 'hideBackingConsumption',
  /** column name */
  Id = 'id',
}

export type Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Settings_Var_Pop_Fields = {
  __typename?: 'settings_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Settings_Var_Samp_Fields = {
  __typename?: 'settings_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Settings_Variance_Fields = {
  __typename?: 'settings_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "attachment" */
  attachment: Array<Attachment>;
  /** fetch aggregated fields from the table: "attachment" */
  attachment_aggregate: Attachment_Aggregate;
  /** fetch data from the table: "attachment" using primary key columns */
  attachment_by_pk?: Maybe<Attachment>;
  /** fetch data from the table in a streaming manner: "attachment" */
  attachment_stream: Array<Attachment>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch data from the table: "caseStatus" */
  caseStatus: Array<CaseStatus>;
  /** fetch aggregated fields from the table: "caseStatus" */
  caseStatus_aggregate: CaseStatus_Aggregate;
  /** fetch data from the table: "caseStatus" using primary key columns */
  caseStatus_by_pk?: Maybe<CaseStatus>;
  /** fetch data from the table in a streaming manner: "caseStatus" */
  caseStatus_stream: Array<CaseStatus>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table in a streaming manner: "case" */
  case_stream: Array<Case>;
  /** fetch data from the table: "concavePiece" */
  concavePiece: Array<ConcavePiece>;
  /** fetch aggregated fields from the table: "concavePiece" */
  concavePiece_aggregate: ConcavePiece_Aggregate;
  /** fetch data from the table: "concavePiece" using primary key columns */
  concavePiece_by_pk?: Maybe<ConcavePiece>;
  /** fetch data from the table in a streaming manner: "concavePiece" */
  concavePiece_stream: Array<ConcavePiece>;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>;
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<Customer>;
  /** fetch data from the table: "fileType" */
  fileType: Array<FileType>;
  /** fetch aggregated fields from the table: "fileType" */
  fileType_aggregate: FileType_Aggregate;
  /** fetch data from the table: "fileType" using primary key columns */
  fileType_by_pk?: Maybe<FileType>;
  /** fetch data from the table in a streaming manner: "fileType" */
  fileType_stream: Array<FileType>;
  /** fetch data from the table: "followUp" */
  followUp: Array<FollowUp>;
  /** fetch aggregated fields from the table: "followUp" */
  followUp_aggregate: FollowUp_Aggregate;
  /** fetch data from the table: "followUp" using primary key columns */
  followUp_by_pk?: Maybe<FollowUp>;
  /** fetch data from the table in a streaming manner: "followUp" */
  followUp_stream: Array<FollowUp>;
  /** fetch data from the table: "grinding" */
  grinding: Array<Grinding>;
  /** fetch aggregated fields from the table: "grinding" */
  grinding_aggregate: Grinding_Aggregate;
  /** fetch data from the table: "grinding" using primary key columns */
  grinding_by_pk?: Maybe<Grinding>;
  /** fetch data from the table in a streaming manner: "grinding" */
  grinding_stream: Array<Grinding>;
  /** fetch data from the table: "mantlePiece" */
  mantlePiece: Array<MantlePiece>;
  /** fetch aggregated fields from the table: "mantlePiece" */
  mantlePiece_aggregate: MantlePiece_Aggregate;
  /** fetch data from the table: "mantlePiece" using primary key columns */
  mantlePiece_by_pk?: Maybe<MantlePiece>;
  /** fetch data from the table in a streaming manner: "mantlePiece" */
  mantlePiece_stream: Array<MantlePiece>;
  /** fetch data from the table: "miningProduct" */
  miningProduct: Array<MiningProduct>;
  /** fetch aggregated fields from the table: "miningProduct" */
  miningProduct_aggregate: MiningProduct_Aggregate;
  /** fetch data from the table: "miningProduct" using primary key columns */
  miningProduct_by_pk?: Maybe<MiningProduct>;
  /** fetch data from the table in a streaming manner: "miningProduct" */
  miningProduct_stream: Array<MiningProduct>;
  /** fetch data from the table: "partSet" */
  partSet: Array<PartSet>;
  /** fetch aggregated fields from the table: "partSet" */
  partSet_aggregate: PartSet_Aggregate;
  /** fetch data from the table: "partSet" using primary key columns */
  partSet_by_pk?: Maybe<PartSet>;
  /** fetch data from the table in a streaming manner: "partSet" */
  partSet_stream: Array<PartSet>;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** fetch data from the table in a streaming manner: "settings" */
  settings_stream: Array<Settings>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
};

export type Subscription_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

export type Subscription_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

export type Subscription_RootAttachment_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootAttachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

export type Subscription_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

export type Subscription_RootCaseStatusArgs = {
  distinct_on?: InputMaybe<Array<CaseStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaseStatus_Order_By>>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

export type Subscription_RootCaseStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CaseStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaseStatus_Order_By>>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

export type Subscription_RootCaseStatus_By_PkArgs = {
  name: Scalars['String'];
};

export type Subscription_RootCaseStatus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CaseStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<CaseStatus_Bool_Exp>;
};

export type Subscription_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

export type Subscription_RootCase_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootCase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Case_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

export type Subscription_RootConcavePieceArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

export type Subscription_RootConcavePiece_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConcavePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcavePiece_Order_By>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

export type Subscription_RootConcavePiece_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootConcavePiece_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConcavePiece_Stream_Cursor_Input>>;
  where?: InputMaybe<ConcavePiece_Bool_Exp>;
};

export type Subscription_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type Subscription_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type Subscription_RootCustomer_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type Subscription_RootFileTypeArgs = {
  distinct_on?: InputMaybe<Array<FileType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileType_Order_By>>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

export type Subscription_RootFileType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileType_Order_By>>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

export type Subscription_RootFileType_By_PkArgs = {
  name: Scalars['String'];
};

export type Subscription_RootFileType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FileType_Stream_Cursor_Input>>;
  where?: InputMaybe<FileType_Bool_Exp>;
};

export type Subscription_RootFollowUpArgs = {
  distinct_on?: InputMaybe<Array<FollowUp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FollowUp_Order_By>>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

export type Subscription_RootFollowUp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FollowUp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FollowUp_Order_By>>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

export type Subscription_RootFollowUp_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootFollowUp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FollowUp_Stream_Cursor_Input>>;
  where?: InputMaybe<FollowUp_Bool_Exp>;
};

export type Subscription_RootGrindingArgs = {
  distinct_on?: InputMaybe<Array<Grinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grinding_Order_By>>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

export type Subscription_RootGrinding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grinding_Order_By>>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

export type Subscription_RootGrinding_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootGrinding_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grinding_Stream_Cursor_Input>>;
  where?: InputMaybe<Grinding_Bool_Exp>;
};

export type Subscription_RootMantlePieceArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

export type Subscription_RootMantlePiece_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MantlePiece_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MantlePiece_Order_By>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

export type Subscription_RootMantlePiece_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootMantlePiece_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MantlePiece_Stream_Cursor_Input>>;
  where?: InputMaybe<MantlePiece_Bool_Exp>;
};

export type Subscription_RootMiningProductArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

export type Subscription_RootMiningProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MiningProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MiningProduct_Order_By>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

export type Subscription_RootMiningProduct_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootMiningProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MiningProduct_Stream_Cursor_Input>>;
  where?: InputMaybe<MiningProduct_Bool_Exp>;
};

export type Subscription_RootPartSetArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

export type Subscription_RootPartSet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartSet_Order_By>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

export type Subscription_RootPartSet_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootPartSet_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PartSet_Stream_Cursor_Input>>;
  where?: InputMaybe<PartSet_Bool_Exp>;
};

export type Subscription_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

export type Subscription_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

export type Subscription_RootSettings_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['Int'];
};

export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  /** An array relationship */
  assignedCases: Array<Case>;
  /** An aggregate relationship */
  assignedCases_aggregate: Case_Aggregate;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastLoggedIn?: Maybe<Scalars['timestamptz']>;
  lastName: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** columns and relationships of "user" */
export type UserAssignedCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** columns and relationships of "user" */
export type UserAssignedCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** columns and relationships of "user" */
export type UserCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** columns and relationships of "user" */
export type UserCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};

/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  assignedCases?: InputMaybe<Case_Bool_Exp>;
  assignedCases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lastLoggedIn?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseOwnerPkey = 'caseOwner_pkey',
  /** unique or primary key constraint on columns "userId" */
  UserUserIdKey = 'user_userId_key',
}

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  assignedCases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lastLoggedIn?: InputMaybe<Scalars['timestamptz']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastLoggedIn?: Maybe<Scalars['timestamptz']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastLoggedIn?: Maybe<Scalars['timestamptz']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  assignedCases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastLoggedIn?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastLoggedIn = 'lastLoggedIn',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lastLoggedIn?: InputMaybe<Scalars['timestamptz']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lastLoggedIn?: InputMaybe<Scalars['timestamptz']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastLoggedIn = 'lastLoggedIn',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId',
}

export type User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Update_ExpertMutationVariables = Exact<{
  caseId?: InputMaybe<Scalars['Int']>;
  expertId?: InputMaybe<Scalars['Int']>;
}>;

export type Update_ExpertMutation = {
  __typename?: 'mutation_root';
  update_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{
      __typename?: 'case';
      id: number;
      expertId?: number | null;
    }>;
  } | null;
};

export type Update_Case_StatusMutationVariables = Exact<{
  caseStatus?: InputMaybe<CaseStatus_Enum>;
  caseId?: InputMaybe<Scalars['Int']>;
}>;

export type Update_Case_StatusMutation = {
  __typename?: 'mutation_root';
  update_case?: {
    __typename?: 'case_mutation_response';
    affected_rows: number;
    returning: Array<{ __typename?: 'case'; id: number }>;
  } | null;
};

export type Add_CaseMutationVariables = Exact<{
  objects: Array<Case_Insert_Input> | Case_Insert_Input;
  updateColumns: Array<Case_Update_Column> | Case_Update_Column;
  removeConcavePiece: ConcavePiece_Bool_Exp;
  noConcave: Scalars['Boolean'];
  removeMantlePiece: MantlePiece_Bool_Exp;
  noMantle: Scalars['Boolean'];
}>;

export type Add_CaseMutation = {
  __typename?: 'mutation_root';
  delete_concavePiece?: {
    __typename?: 'concavePiece_mutation_response';
    returning: Array<{ __typename?: 'concavePiece'; id: number }>;
  } | null;
  delete_mantlePiece?: {
    __typename?: 'mantlePiece_mutation_response';
    returning: Array<{ __typename?: 'mantlePiece'; id: number }>;
  } | null;
  insert_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{
      __typename?: 'case';
      id: number;
      name?: string | null;
      partSets: Array<{
        __typename?: 'partSet';
        id: number;
        solution: boolean;
        supplierName?: string | null;
        totalCrushingCapacity?: any | null;
        crusherWearLifePerConcaveSetTons?: any | null;
        crusherWearLifePerConcaveSetHours?: any | null;
      }>;
    }>;
  } | null;
};

export type UpsertLightCaseMutationVariables = Exact<{
  objects: Array<Case_Insert_Input> | Case_Insert_Input;
  updateColumns: Array<Case_Update_Column> | Case_Update_Column;
}>;

export type UpsertLightCaseMutation = {
  __typename?: 'mutation_root';
  insert_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{ __typename?: 'case'; id: number; name?: string | null }>;
  } | null;
};

export type Add_Or_Update_SolutionMutationVariables = Exact<{
  objects: Array<Case_Insert_Input> | Case_Insert_Input;
  updateColumns: Array<Case_Update_Column> | Case_Update_Column;
  removeConcavePiece: ConcavePiece_Bool_Exp;
  noConcave: Scalars['Boolean'];
  removeMantlePiece: MantlePiece_Bool_Exp;
  noMantle: Scalars['Boolean'];
}>;

export type Add_Or_Update_SolutionMutation = {
  __typename?: 'mutation_root';
  delete_concavePiece?: {
    __typename?: 'concavePiece_mutation_response';
    returning: Array<{ __typename?: 'concavePiece'; id: number }>;
  } | null;
  delete_mantlePiece?: {
    __typename?: 'mantlePiece_mutation_response';
    returning: Array<{ __typename?: 'mantlePiece'; id: number }>;
  } | null;
  insert_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{ __typename?: 'case'; id: number }>;
  } | null;
};

export type RemoveAttachmentMutationVariables = Exact<{
  where: Attachment_Bool_Exp;
}>;

export type RemoveAttachmentMutation = {
  __typename?: 'mutation_root';
  delete_attachment?: {
    __typename?: 'attachment_mutation_response';
    affected_rows: number;
  } | null;
};

export type DeleteCaseMutationVariables = Exact<{
  caseIds: Case_Bool_Exp;
}>;

export type DeleteCaseMutation = {
  __typename?: 'mutation_root';
  delete_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{ __typename?: 'case'; id: number }>;
  } | null;
};

export type Upsert_CaseMutationVariables = Exact<{
  objects: Array<Case_Insert_Input> | Case_Insert_Input;
  updateColumns: Array<Case_Update_Column> | Case_Update_Column;
}>;

export type Upsert_CaseMutation = {
  __typename?: 'mutation_root';
  insert_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{ __typename?: 'case'; id: number }>;
  } | null;
};

export type UpsertFollowUpMutationVariables = Exact<{
  objects: Array<FollowUp_Insert_Input> | FollowUp_Insert_Input;
  onConflict?: InputMaybe<FollowUp_On_Conflict>;
}>;

export type UpsertFollowUpMutation = {
  __typename?: 'mutation_root';
  insert_followUp?: {
    __typename?: 'followUp_mutation_response';
    returning: Array<{
      __typename?: 'followUp';
      id: number;
      measuredCapacity?: any | null;
      installationDate?: any | null;
      measuredWearLifeHours?: any | null;
      removalDate?: any | null;
      measuredWearLifeTonnes?: any | null;
      mantleChangeDate?: any | null;
      target?: string | null;
      feedback?: string | null;
      attachments: Array<{
        __typename?: 'attachment';
        url?: string | null;
        size?: any | null;
        originalname?: string | null;
        mimetype?: string | null;
        id: number;
        container?: string | null;
        blob?: string | null;
      }>;
      cases: Array<{ __typename?: 'case'; id: number }>;
    }>;
  } | null;
};

export type AssignFollowUpToCaseMutationVariables = Exact<{
  caseId: Scalars['Int'];
  followUpId: Scalars['Int'];
}>;

export type AssignFollowUpToCaseMutation = {
  __typename?: 'mutation_root';
  update_case?: {
    __typename?: 'case_mutation_response';
    returning: Array<{ __typename?: 'case'; id: number }>;
  } | null;
};

export type DeleteMiningProductMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteMiningProductMutation = {
  __typename?: 'mutation_root';
  delete_miningProduct?: {
    __typename?: 'miningProduct_mutation_response';
    affected_rows: number;
  } | null;
};

export type UpsertSettingsMutationVariables = Exact<{
  object: Settings_Insert_Input;
  updateColumns: Array<Settings_Update_Column> | Settings_Update_Column;
}>;

export type UpsertSettingsMutation = {
  __typename?: 'mutation_root';
  insert_settings_one?: { __typename?: 'settings'; id: number } | null;
};

export type AddSettingsToCaseMutationVariables = Exact<{
  caseId: Scalars['Int'];
  settingsId: Scalars['Int'];
}>;

export type AddSettingsToCaseMutation = {
  __typename?: 'mutation_root';
  update_case_by_pk?: { __typename?: 'case'; id: number } | null;
};

export type CustomerFieldsFragment = {
  __typename?: 'customer';
  id: number;
  name?: string | null;
  siteName?: string | null;
  metsoId?: string | null;
  country?: string | null;
};

export type AttachmentFieldsFragment = {
  __typename?: 'attachment';
  id: number;
  mimetype?: string | null;
  size?: any | null;
  url?: string | null;
  originalname?: string | null;
  container?: string | null;
  blob?: string | null;
};

export type MiningProductFieldsFragment = {
  __typename: 'miningProduct';
  id: number;
  name?: string | null;
  nameOther?: string | null;
  recoveryRatePercent?: any | null;
  price?: any | null;
  priceUpdatedAt?: any | null;
  grade?: any | null;
  grading?: any | null;
};

export type ConcavePieceFieldsFragment = {
  __typename?: 'concavePiece';
  id: number;
  partNumber?: string | null;
  material?: string | null;
  configuration?: string | null;
  fasteningMethod?: string | null;
  numberOfSegments?: number | null;
  segmentWeight?: any | null;
  pricePerKg?: any | null;
  price?: any | null;
  pricePerKgMarketArea?: any | null;
  priceMarketArea?: any | null;
};

export type MantlePieceFieldsFragment = {
  __typename?: 'mantlePiece';
  id: number;
  partNumber?: string | null;
  weight?: any | null;
  material?: string | null;
  pricePerKg?: any | null;
  price?: any | null;
  type?: string | null;
  pricePerKgMarketArea?: any | null;
  priceMarketArea?: any | null;
  description?: string | null;
};

export type PartSetFieldsFragment = {
  __typename?: 'partSet';
  id: number;
  solution: boolean;
  supplierName?: string | null;
  numberOfConcaveTiers?: number | null;
  otherRelineCost?: number | null;
  relineCostDirect?: number | null;
  relineDowntime?: number | null;
  carouselInUse?: boolean | null;
  changeOutCostOfSegment?: any | null;
  otherCostsOfSegmentChange?: any | null;
  segmentChangeOutDowntime?: any | null;
  totalCostOfConcaveSegmentSet?: any | null;
  totalWeightOfConcaveSegmentSet?: any | null;
  additionalInfoForTiers?: string | null;
  crusherWearLifePerConcaveSetTons?: any | null;
  crusherWearLifePerConcaveSetHours?: any | null;
  totalCrushingCapacity?: any | null;
  numberOfMantlePieces?: number | null;
  upperMantlesPerSet?: any | null;
  middleMantlesPerSet?: any | null;
  lowerMantlesPerSet?: any | null;
  changeOutCostMantleToShaft?: any | null;
  changeOutCostShaftChange?: any | null;
  changeOutShaftChangeDowntime?: any | null;
  desiredEndProduct?: any | null;
  wearLifeOfPartSets?: any | null;
  p80Crusher?: any | null;
  p80Screen?: any | null;
  bowlLinerPartNumber?: string | null;
  bowlLinerMaterial?: string | null;
  bowlLinerWeight?: any | null;
  bowlLinerPricePerKg?: any | null;
  bowlLinerPricePerKgMarketArea?: any | null;
  bowlLinerPrice?: any | null;
  bowlLinerPriceMarketArea?: any | null;
  bowlLinerDescription?: string | null;
  changeOutCostMantleToShaftMarketArea?: any | null;
  changeOutCostShaftChangeMarketArea?: any | null;
  changeOutShaftChangeDowntimeMarketArea?: any | null;
  totalCostOfConcaveSegmentSetMarketArea?: any | null;
  changeOutCostOfSegmentMarketArea?: any | null;
  otherCostsOfSegmentChangeMarketArea?: any | null;
  segmentChangeOutDowntimeMarketArea?: any | null;
  concavePieces: Array<{
    __typename?: 'concavePiece';
    id: number;
    partNumber?: string | null;
    material?: string | null;
    configuration?: string | null;
    fasteningMethod?: string | null;
    numberOfSegments?: number | null;
    segmentWeight?: any | null;
    pricePerKg?: any | null;
    price?: any | null;
    pricePerKgMarketArea?: any | null;
    priceMarketArea?: any | null;
  }>;
  mantlePieces: Array<{
    __typename?: 'mantlePiece';
    id: number;
    partNumber?: string | null;
    weight?: any | null;
    material?: string | null;
    pricePerKg?: any | null;
    price?: any | null;
    type?: string | null;
    pricePerKgMarketArea?: any | null;
    priceMarketArea?: any | null;
    description?: string | null;
  }>;
};

export type GrindingFieldsFragment = {
  __typename?: 'grinding';
  id: number;
  millOperatingHoursPerDay?: any | null;
  millOperatingDaysPerYear?: any | null;
  energyCost?: any | null;
  millLiningGrindingMediaCosts?: any | null;
  capacityOfMills?: any | null;
  bondWorkIndexOfOre?: any | null;
  p80ProductGradation?: any | null;
  grindingFactor?: any | null;
  millingCircuitFactor?: any | null;
  safetyFactor?: any | null;
  shareOfEnergySavings?: any | null;
};

export type GetCasesQueryVariables = Exact<{
  where?: InputMaybe<Case_Bool_Exp>;
}>;

export type GetCasesQuery = {
  __typename?: 'query_root';
  case: Array<{
    __typename: 'case';
    id: number;
    name?: string | null;
    createdAt: any;
    dueDate?: any | null;
    status?: CaseStatus_Enum | null;
    crusherType?: string | null;
    salesforceOpportunityNumber?: string | null;
    customer?: {
      __typename?: 'customer';
      id: number;
      name?: string | null;
      country?: string | null;
    } | null;
    user?: {
      __typename?: 'user';
      id: number;
      userId?: string | null;
      firstName: string;
      lastName: string;
    } | null;
    expert?: {
      __typename?: 'user';
      id: number;
      firstName: string;
      lastName: string;
    } | null;
  }>;
};

export type GetCaseQueryVariables = Exact<{
  id: Scalars['Int'];
  partSetWhere?: InputMaybe<PartSet_Bool_Exp>;
}>;

export type GetCaseQuery = {
  __typename?: 'query_root';
  case?: {
    __typename: 'case';
    id: number;
    name?: string | null;
    customerId?: number | null;
    crusherType?: string | null;
    crusherModel?: string | null;
    crusherCavityType?: string | null;
    crusherSerialNumber?: string | null;
    crusherCavityMaterial?: string | null;
    crusherThroughput?: number | null;
    crusherGrading?: number | null;
    crusherLifetimeConcave?: number | null;
    crusherLifetimeMantle?: number | null;
    crusherAdditionalInfo?: string | null;
    annualWearConsumptionMachine?: number | null;
    annualWearConsumptionProcess?: number | null;
    crusherCss?: any | null;
    crusherOss?: any | null;
    crusherSpeed?: any | null;
    crusherCounterShaftSpeed?: any | null;
    feedRockTestId?: string | null;
    feedAbrasiveness?: any | null;
    feedCrushabilityPercent?: any | null;
    feedOn?: boolean | null;
    rockType?: string | null;
    feedGradingMinSize?: number | null;
    feedGradingMaxSize?: number | null;
    feedSolidDensity?: any | null;
    feedMoisturePercent?: any | null;
    crusherStroke?: any | null;
    ringbounce?: boolean | null;
    ringbounceAdditionalInfo?: string | null;
    chokeFeed?: boolean | null;
    feedMethod?: string | null;
    powerDrawAvg?: any | null;
    powerDrawPeak?: any | null;
    pistonPressureAvg?: any | null;
    pistonPressurePeak?: any | null;
    throughputAvg?: any | null;
    throughputPeak?: any | null;
    improvementTargets?: any | null;
    improvementTargetsCrusherDuty?: string | null;
    improvementTargetsAdditionalInfo?: string | null;
    improvementTargetsOtherInfo?: any | null;
    salesforceOpportunityNumber?: string | null;
    product?: string | null;
    targetThroughput?: number | null;
    currency?: string | null;
    operatingProfit?: any | null;
    numberOfCrushers?: number | null;
    operatingHoursPerDay?: any | null;
    operatingDaysPerYear?: any | null;
    operatingHoursPerYear?: number | null;
    targetMax?: number | null;
    targetMin?: number | null;
    targetOther?: string | null;
    status?: CaseStatus_Enum | null;
    crusherForceOverload?: boolean | null;
    annualCrushingLineCapacity?: any | null;
    crusherRatedPower?: any | null;
    feedOreType?: string | null;
    feedMaxSize?: number | null;
    feedMinSize?: number | null;
    updatedAt: any;
    additionalBasicInformation?: string | null;
    additionalCrusherInformation?: string | null;
    additionalChamberInformation?: string | null;
    additionalFeedInformation?: string | null;
    additionalAttachmentInformation?: string | null;
    phase?: string | null;
    grindingId?: number | null;
    createdAt: any;
    dueDate?: any | null;
    customer?: {
      __typename?: 'customer';
      id: number;
      name?: string | null;
      siteName?: string | null;
      metsoId?: string | null;
      country?: string | null;
    } | null;
    expert?: {
      __typename?: 'user';
      id: number;
      firstName: string;
      lastName: string;
    } | null;
    lastEditedBy?: {
      __typename?: 'user';
      firstName: string;
      lastName: string;
    } | null;
    miningProducts: Array<{
      __typename: 'miningProduct';
      id: number;
      name?: string | null;
      nameOther?: string | null;
      recoveryRatePercent?: any | null;
      price?: any | null;
      priceUpdatedAt?: any | null;
      grade?: any | null;
      grading?: any | null;
    }>;
    user?: {
      __typename?: 'user';
      id: number;
      firstName: string;
      lastName: string;
    } | null;
    feedCurveAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    caseReportAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    powerDrawAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    pistonPressureAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    throughputAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    flowsheetAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    generalSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    mantleSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    concaveSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    generalNewSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    mantleNewSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    concaveNewSolutionAttachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
    partSets: Array<{
      __typename?: 'partSet';
      id: number;
      solution: boolean;
      supplierName?: string | null;
      numberOfConcaveTiers?: number | null;
      otherRelineCost?: number | null;
      relineCostDirect?: number | null;
      relineDowntime?: number | null;
      carouselInUse?: boolean | null;
      changeOutCostOfSegment?: any | null;
      otherCostsOfSegmentChange?: any | null;
      segmentChangeOutDowntime?: any | null;
      totalCostOfConcaveSegmentSet?: any | null;
      totalWeightOfConcaveSegmentSet?: any | null;
      additionalInfoForTiers?: string | null;
      crusherWearLifePerConcaveSetTons?: any | null;
      crusherWearLifePerConcaveSetHours?: any | null;
      totalCrushingCapacity?: any | null;
      numberOfMantlePieces?: number | null;
      upperMantlesPerSet?: any | null;
      middleMantlesPerSet?: any | null;
      lowerMantlesPerSet?: any | null;
      changeOutCostMantleToShaft?: any | null;
      changeOutCostShaftChange?: any | null;
      changeOutShaftChangeDowntime?: any | null;
      desiredEndProduct?: any | null;
      wearLifeOfPartSets?: any | null;
      p80Crusher?: any | null;
      p80Screen?: any | null;
      bowlLinerPartNumber?: string | null;
      bowlLinerMaterial?: string | null;
      bowlLinerWeight?: any | null;
      bowlLinerPricePerKg?: any | null;
      bowlLinerPricePerKgMarketArea?: any | null;
      bowlLinerPrice?: any | null;
      bowlLinerPriceMarketArea?: any | null;
      bowlLinerDescription?: string | null;
      changeOutCostMantleToShaftMarketArea?: any | null;
      changeOutCostShaftChangeMarketArea?: any | null;
      changeOutShaftChangeDowntimeMarketArea?: any | null;
      totalCostOfConcaveSegmentSetMarketArea?: any | null;
      changeOutCostOfSegmentMarketArea?: any | null;
      otherCostsOfSegmentChangeMarketArea?: any | null;
      segmentChangeOutDowntimeMarketArea?: any | null;
      concavePieces: Array<{
        __typename?: 'concavePiece';
        id: number;
        partNumber?: string | null;
        material?: string | null;
        configuration?: string | null;
        fasteningMethod?: string | null;
        numberOfSegments?: number | null;
        segmentWeight?: any | null;
        pricePerKg?: any | null;
        price?: any | null;
        pricePerKgMarketArea?: any | null;
        priceMarketArea?: any | null;
      }>;
      mantlePieces: Array<{
        __typename?: 'mantlePiece';
        id: number;
        partNumber?: string | null;
        weight?: any | null;
        material?: string | null;
        pricePerKg?: any | null;
        price?: any | null;
        type?: string | null;
        pricePerKgMarketArea?: any | null;
        priceMarketArea?: any | null;
        description?: string | null;
      }>;
    }>;
    grinding?: {
      __typename?: 'grinding';
      id: number;
      millOperatingHoursPerDay?: any | null;
      millOperatingDaysPerYear?: any | null;
      energyCost?: any | null;
      millLiningGrindingMediaCosts?: any | null;
      capacityOfMills?: any | null;
      bondWorkIndexOfOre?: any | null;
      p80ProductGradation?: any | null;
      grindingFactor?: any | null;
      millingCircuitFactor?: any | null;
      safetyFactor?: any | null;
      shareOfEnergySavings?: any | null;
    } | null;
    followUp?: { __typename?: 'followUp'; id: number } | null;
    settings?: {
      __typename?: 'settings';
      id: number;
      hideBackingConsumption: boolean;
      disabledFields?: any | null;
    } | null;
  } | null;
};

export type GetLightBasicValuesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetLightBasicValuesQuery = {
  __typename?: 'query_root';
  case?: {
    __typename?: 'case';
    id: number;
    name?: string | null;
    currency?: string | null;
    dueDate?: any | null;
    salesforceOpportunityNumber?: string | null;
    crusherType?: string | null;
    crusherModel?: string | null;
    numberOfCrushers?: number | null;
    operatingProfit?: any | null;
    operatingHoursPerDay?: any | null;
    operatingDaysPerYear?: any | null;
    customer?: {
      __typename?: 'customer';
      id: number;
      name?: string | null;
      siteName?: string | null;
      metsoId?: string | null;
      country?: string | null;
    } | null;
    miningProducts: Array<{
      __typename: 'miningProduct';
      id: number;
      name?: string | null;
      nameOther?: string | null;
      recoveryRatePercent?: any | null;
      price?: any | null;
      priceUpdatedAt?: any | null;
      grade?: any | null;
      grading?: any | null;
    }>;
    grinding?: {
      __typename?: 'grinding';
      id: number;
      millOperatingHoursPerDay?: any | null;
      millOperatingDaysPerYear?: any | null;
      energyCost?: any | null;
      millLiningGrindingMediaCosts?: any | null;
      capacityOfMills?: any | null;
      bondWorkIndexOfOre?: any | null;
      p80ProductGradation?: any | null;
      grindingFactor?: any | null;
      millingCircuitFactor?: any | null;
      safetyFactor?: any | null;
      shareOfEnergySavings?: any | null;
    } | null;
  } | null;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  __typename?: 'query_root';
  user: Array<{
    __typename?: 'user';
    id: number;
    firstName: string;
    lastName: string;
    country?: string | null;
    userId?: string | null;
    assignedCases_aggregate: {
      __typename?: 'case_aggregate';
      aggregate?: {
        __typename?: 'case_aggregate_fields';
        count: number;
      } | null;
    };
  }>;
};

export type OwnersQueryVariables = Exact<{ [key: string]: never }>;

export type OwnersQuery = {
  __typename?: 'query_root';
  user: Array<{
    __typename?: 'user';
    id: number;
    firstName: string;
    lastName: string;
    country?: string | null;
    userId?: string | null;
  }>;
};

export type GetFilterCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetFilterCountriesQuery = {
  __typename?: 'query_root';
  customer: Array<{ __typename?: 'customer'; country?: string | null }>;
};

export type GetFollowUpQueryVariables = Exact<{
  caseId: Scalars['Int'];
}>;

export type GetFollowUpQuery = {
  __typename?: 'query_root';
  followUp: Array<{
    __typename?: 'followUp';
    id: number;
    measuredCapacity?: any | null;
    installationDate?: any | null;
    measuredWearLifeHours?: any | null;
    removalDate?: any | null;
    measuredWearLifeTonnes?: any | null;
    mantleChangeDate?: any | null;
    target?: string | null;
    feedback?: string | null;
    attachments: Array<{
      __typename?: 'attachment';
      id: number;
      mimetype?: string | null;
      size?: any | null;
      url?: string | null;
      originalname?: string | null;
      container?: string | null;
      blob?: string | null;
    }>;
  }>;
};

export type GetPageSettingsQueryVariables = Exact<{
  caseId: Scalars['Int'];
}>;

export type GetPageSettingsQuery = {
  __typename?: 'query_root';
  settings: Array<{
    __typename?: 'settings';
    id: number;
    hideBackingConsumption: boolean;
    disabledFields?: any | null;
  }>;
  case_by_pk?: {
    __typename?: 'case';
    id: number;
    crusherType?: string | null;
  } | null;
};

export type Subscribe_To_CaseSubscriptionVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Subscribe_To_CaseSubscription = {
  __typename?: 'subscription_root';
  case_by_pk?: { __typename?: 'case'; status?: CaseStatus_Enum | null } | null;
};

export const CustomerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerFields on customer {
    id
    name
    siteName
    metsoId
    country
  }
`;
export const AttachmentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AttachmentFields on attachment {
    id
    mimetype
    size
    url
    originalname
    container
    blob
  }
`;
export const MiningProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment MiningProductFields on miningProduct {
    id
    name
    nameOther
    recoveryRatePercent
    price
    priceUpdatedAt
    grade
    grading
    __typename
  }
`;
export const ConcavePieceFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ConcavePieceFields on concavePiece {
    id
    partNumber
    material
    configuration
    fasteningMethod
    numberOfSegments
    segmentWeight
    pricePerKg
    price
    pricePerKgMarketArea
    priceMarketArea
  }
`;
export const MantlePieceFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment MantlePieceFields on mantlePiece {
    id
    partNumber
    weight
    material
    pricePerKg
    price
    type
    pricePerKgMarketArea
    priceMarketArea
    description
  }
`;
export const PartSetFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartSetFields on partSet {
    id
    solution
    supplierName
    numberOfConcaveTiers
    otherRelineCost
    relineCostDirect
    relineDowntime
    carouselInUse
    changeOutCostOfSegment
    otherCostsOfSegmentChange
    segmentChangeOutDowntime
    totalCostOfConcaveSegmentSet
    totalWeightOfConcaveSegmentSet
    additionalInfoForTiers
    crusherWearLifePerConcaveSetTons
    crusherWearLifePerConcaveSetHours
    totalCrushingCapacity
    concavePieces {
      ...ConcavePieceFields
    }
    numberOfMantlePieces
    upperMantlesPerSet
    middleMantlesPerSet
    lowerMantlesPerSet
    mantlePieces {
      ...MantlePieceFields
    }
    changeOutCostMantleToShaft
    changeOutCostShaftChange
    changeOutShaftChangeDowntime
    desiredEndProduct
    wearLifeOfPartSets
    p80Crusher
    p80Screen
    bowlLinerPartNumber
    bowlLinerMaterial
    bowlLinerWeight
    bowlLinerPricePerKg
    bowlLinerPricePerKgMarketArea
    bowlLinerPrice
    bowlLinerPriceMarketArea
    bowlLinerDescription
    changeOutCostMantleToShaftMarketArea
    changeOutCostShaftChangeMarketArea
    changeOutShaftChangeDowntimeMarketArea
    totalCostOfConcaveSegmentSetMarketArea
    changeOutCostOfSegmentMarketArea
    otherCostsOfSegmentChangeMarketArea
    segmentChangeOutDowntimeMarketArea
  }
  ${ConcavePieceFieldsFragmentDoc}
  ${MantlePieceFieldsFragmentDoc}
`;
export const GrindingFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment GrindingFields on grinding {
    id
    millOperatingHoursPerDay
    millOperatingDaysPerYear
    energyCost
    millLiningGrindingMediaCosts
    capacityOfMills
    bondWorkIndexOfOre
    p80ProductGradation
    grindingFactor
    millingCircuitFactor
    safetyFactor
    shareOfEnergySavings
  }
`;
export const Update_ExpertDocument = /*#__PURE__*/ gql`
  mutation update_expert($caseId: Int, $expertId: Int) {
    update_case(
      where: { id: { _eq: $caseId } }
      _set: { expertId: $expertId }
    ) {
      returning {
        id
        expertId
      }
    }
  }
`;
export type Update_ExpertMutationFn = ApolloReactCommon.MutationFunction<
  Update_ExpertMutation,
  Update_ExpertMutationVariables
>;

/**
 * __useUpdate_ExpertMutation__
 *
 * To run a mutation, you first call `useUpdate_ExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_ExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertMutation, { data, loading, error }] = useUpdate_ExpertMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function useUpdate_ExpertMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Update_ExpertMutation,
    Update_ExpertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    Update_ExpertMutation,
    Update_ExpertMutationVariables
  >(Update_ExpertDocument, options);
}
export type Update_ExpertMutationHookResult = ReturnType<
  typeof useUpdate_ExpertMutation
>;
export type Update_ExpertMutationResult =
  ApolloReactCommon.MutationResult<Update_ExpertMutation>;
export type Update_ExpertMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Update_ExpertMutation,
    Update_ExpertMutationVariables
  >;
export const Update_Case_StatusDocument = /*#__PURE__*/ gql`
  mutation update_case_status($caseStatus: caseStatus_enum, $caseId: Int) {
    update_case(
      where: { id: { _eq: $caseId } }
      _set: { status: $caseStatus }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
export type Update_Case_StatusMutationFn = ApolloReactCommon.MutationFunction<
  Update_Case_StatusMutation,
  Update_Case_StatusMutationVariables
>;

/**
 * __useUpdate_Case_StatusMutation__
 *
 * To run a mutation, you first call `useUpdate_Case_StatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Case_StatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseStatusMutation, { data, loading, error }] = useUpdate_Case_StatusMutation({
 *   variables: {
 *      caseStatus: // value for 'caseStatus'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useUpdate_Case_StatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Update_Case_StatusMutation,
    Update_Case_StatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    Update_Case_StatusMutation,
    Update_Case_StatusMutationVariables
  >(Update_Case_StatusDocument, options);
}
export type Update_Case_StatusMutationHookResult = ReturnType<
  typeof useUpdate_Case_StatusMutation
>;
export type Update_Case_StatusMutationResult =
  ApolloReactCommon.MutationResult<Update_Case_StatusMutation>;
export type Update_Case_StatusMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Update_Case_StatusMutation,
    Update_Case_StatusMutationVariables
  >;
export const Add_CaseDocument = /*#__PURE__*/ gql`
  mutation add_case(
    $objects: [case_insert_input!]!
    $updateColumns: [case_update_column!]!
    $removeConcavePiece: concavePiece_bool_exp!
    $noConcave: Boolean!
    $removeMantlePiece: mantlePiece_bool_exp!
    $noMantle: Boolean!
  ) {
    delete_concavePiece(where: $removeConcavePiece) @include(if: $noConcave) {
      returning {
        id
      }
    }
    delete_mantlePiece(where: $removeMantlePiece) @include(if: $noMantle) {
      returning {
        id
      }
    }
    insert_case(
      objects: $objects
      on_conflict: { constraint: case_pkey, update_columns: $updateColumns }
    ) {
      returning {
        id
        name
        partSets {
          id
          solution
          supplierName
          totalCrushingCapacity
          crusherWearLifePerConcaveSetTons
          crusherWearLifePerConcaveSetHours
        }
      }
    }
  }
`;
export type Add_CaseMutationFn = ApolloReactCommon.MutationFunction<
  Add_CaseMutation,
  Add_CaseMutationVariables
>;

/**
 * __useAdd_CaseMutation__
 *
 * To run a mutation, you first call `useAdd_CaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_CaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseMutation, { data, loading, error }] = useAdd_CaseMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      updateColumns: // value for 'updateColumns'
 *      removeConcavePiece: // value for 'removeConcavePiece'
 *      noConcave: // value for 'noConcave'
 *      removeMantlePiece: // value for 'removeMantlePiece'
 *      noMantle: // value for 'noMantle'
 *   },
 * });
 */
export function useAdd_CaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Add_CaseMutation,
    Add_CaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    Add_CaseMutation,
    Add_CaseMutationVariables
  >(Add_CaseDocument, options);
}
export type Add_CaseMutationHookResult = ReturnType<typeof useAdd_CaseMutation>;
export type Add_CaseMutationResult =
  ApolloReactCommon.MutationResult<Add_CaseMutation>;
export type Add_CaseMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Add_CaseMutation,
  Add_CaseMutationVariables
>;
export const UpsertLightCaseDocument = /*#__PURE__*/ gql`
  mutation upsertLightCase(
    $objects: [case_insert_input!]!
    $updateColumns: [case_update_column!]!
  ) {
    insert_case(
      objects: $objects
      on_conflict: { constraint: case_pkey, update_columns: $updateColumns }
    ) {
      returning {
        id
        name
      }
    }
  }
`;
export type UpsertLightCaseMutationFn = ApolloReactCommon.MutationFunction<
  UpsertLightCaseMutation,
  UpsertLightCaseMutationVariables
>;

/**
 * __useUpsertLightCaseMutation__
 *
 * To run a mutation, you first call `useUpsertLightCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLightCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLightCaseMutation, { data, loading, error }] = useUpsertLightCaseMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      updateColumns: // value for 'updateColumns'
 *   },
 * });
 */
export function useUpsertLightCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertLightCaseMutation,
    UpsertLightCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpsertLightCaseMutation,
    UpsertLightCaseMutationVariables
  >(UpsertLightCaseDocument, options);
}
export type UpsertLightCaseMutationHookResult = ReturnType<
  typeof useUpsertLightCaseMutation
>;
export type UpsertLightCaseMutationResult =
  ApolloReactCommon.MutationResult<UpsertLightCaseMutation>;
export type UpsertLightCaseMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpsertLightCaseMutation,
    UpsertLightCaseMutationVariables
  >;
export const Add_Or_Update_SolutionDocument = /*#__PURE__*/ gql`
  mutation add_or_update_solution(
    $objects: [case_insert_input!]!
    $updateColumns: [case_update_column!]!
    $removeConcavePiece: concavePiece_bool_exp!
    $noConcave: Boolean!
    $removeMantlePiece: mantlePiece_bool_exp!
    $noMantle: Boolean!
  ) {
    delete_concavePiece(where: $removeConcavePiece) @include(if: $noConcave) {
      returning {
        id
      }
    }
    delete_mantlePiece(where: $removeMantlePiece) @include(if: $noMantle) {
      returning {
        id
      }
    }
    insert_case(
      objects: $objects
      on_conflict: { constraint: case_pkey, update_columns: $updateColumns }
    ) {
      returning {
        id
      }
    }
  }
`;
export type Add_Or_Update_SolutionMutationFn =
  ApolloReactCommon.MutationFunction<
    Add_Or_Update_SolutionMutation,
    Add_Or_Update_SolutionMutationVariables
  >;

/**
 * __useAdd_Or_Update_SolutionMutation__
 *
 * To run a mutation, you first call `useAdd_Or_Update_SolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Or_Update_SolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateSolutionMutation, { data, loading, error }] = useAdd_Or_Update_SolutionMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      updateColumns: // value for 'updateColumns'
 *      removeConcavePiece: // value for 'removeConcavePiece'
 *      noConcave: // value for 'noConcave'
 *      removeMantlePiece: // value for 'removeMantlePiece'
 *      noMantle: // value for 'noMantle'
 *   },
 * });
 */
export function useAdd_Or_Update_SolutionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Add_Or_Update_SolutionMutation,
    Add_Or_Update_SolutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    Add_Or_Update_SolutionMutation,
    Add_Or_Update_SolutionMutationVariables
  >(Add_Or_Update_SolutionDocument, options);
}
export type Add_Or_Update_SolutionMutationHookResult = ReturnType<
  typeof useAdd_Or_Update_SolutionMutation
>;
export type Add_Or_Update_SolutionMutationResult =
  ApolloReactCommon.MutationResult<Add_Or_Update_SolutionMutation>;
export type Add_Or_Update_SolutionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    Add_Or_Update_SolutionMutation,
    Add_Or_Update_SolutionMutationVariables
  >;
export const RemoveAttachmentDocument = /*#__PURE__*/ gql`
  mutation removeAttachment($where: attachment_bool_exp!) {
    delete_attachment(where: $where) {
      affected_rows
    }
  }
`;
export type RemoveAttachmentMutationFn = ApolloReactCommon.MutationFunction<
  RemoveAttachmentMutation,
  RemoveAttachmentMutationVariables
>;

/**
 * __useRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentMutation, { data, loading, error }] = useRemoveAttachmentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemoveAttachmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveAttachmentMutation,
    RemoveAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    RemoveAttachmentMutation,
    RemoveAttachmentMutationVariables
  >(RemoveAttachmentDocument, options);
}
export type RemoveAttachmentMutationHookResult = ReturnType<
  typeof useRemoveAttachmentMutation
>;
export type RemoveAttachmentMutationResult =
  ApolloReactCommon.MutationResult<RemoveAttachmentMutation>;
export type RemoveAttachmentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveAttachmentMutation,
    RemoveAttachmentMutationVariables
  >;
export const DeleteCaseDocument = /*#__PURE__*/ gql`
  mutation deleteCase($caseIds: case_bool_exp!) {
    delete_case(where: $caseIds) {
      returning {
        id
      }
    }
  }
`;
export type DeleteCaseMutationFn = ApolloReactCommon.MutationFunction<
  DeleteCaseMutation,
  DeleteCaseMutationVariables
>;

/**
 * __useDeleteCaseMutation__
 *
 * To run a mutation, you first call `useDeleteCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseMutation, { data, loading, error }] = useDeleteCaseMutation({
 *   variables: {
 *      caseIds: // value for 'caseIds'
 *   },
 * });
 */
export function useDeleteCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCaseMutation,
    DeleteCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteCaseMutation,
    DeleteCaseMutationVariables
  >(DeleteCaseDocument, options);
}
export type DeleteCaseMutationHookResult = ReturnType<
  typeof useDeleteCaseMutation
>;
export type DeleteCaseMutationResult =
  ApolloReactCommon.MutationResult<DeleteCaseMutation>;
export type DeleteCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteCaseMutation,
  DeleteCaseMutationVariables
>;
export const Upsert_CaseDocument = /*#__PURE__*/ gql`
  mutation upsert_case(
    $objects: [case_insert_input!]!
    $updateColumns: [case_update_column!]!
  ) {
    insert_case(
      objects: $objects
      on_conflict: { constraint: case_pkey, update_columns: $updateColumns }
    ) {
      returning {
        id
      }
    }
  }
`;
export type Upsert_CaseMutationFn = ApolloReactCommon.MutationFunction<
  Upsert_CaseMutation,
  Upsert_CaseMutationVariables
>;

/**
 * __useUpsert_CaseMutation__
 *
 * To run a mutation, you first call `useUpsert_CaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_CaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCaseMutation, { data, loading, error }] = useUpsert_CaseMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      updateColumns: // value for 'updateColumns'
 *   },
 * });
 */
export function useUpsert_CaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Upsert_CaseMutation,
    Upsert_CaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    Upsert_CaseMutation,
    Upsert_CaseMutationVariables
  >(Upsert_CaseDocument, options);
}
export type Upsert_CaseMutationHookResult = ReturnType<
  typeof useUpsert_CaseMutation
>;
export type Upsert_CaseMutationResult =
  ApolloReactCommon.MutationResult<Upsert_CaseMutation>;
export type Upsert_CaseMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Upsert_CaseMutation,
  Upsert_CaseMutationVariables
>;
export const UpsertFollowUpDocument = /*#__PURE__*/ gql`
  mutation upsertFollowUp(
    $objects: [followUp_insert_input!]!
    $onConflict: followUp_on_conflict
  ) {
    insert_followUp(objects: $objects, on_conflict: $onConflict) {
      returning {
        id
        measuredCapacity
        installationDate
        measuredWearLifeHours
        removalDate
        measuredWearLifeTonnes
        mantleChangeDate
        target
        feedback
        attachments {
          url
          size
          originalname
          mimetype
          id
          container
          blob
        }
        cases {
          id
        }
      }
    }
  }
`;
export type UpsertFollowUpMutationFn = ApolloReactCommon.MutationFunction<
  UpsertFollowUpMutation,
  UpsertFollowUpMutationVariables
>;

/**
 * __useUpsertFollowUpMutation__
 *
 * To run a mutation, you first call `useUpsertFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFollowUpMutation, { data, loading, error }] = useUpsertFollowUpMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      onConflict: // value for 'onConflict'
 *   },
 * });
 */
export function useUpsertFollowUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertFollowUpMutation,
    UpsertFollowUpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpsertFollowUpMutation,
    UpsertFollowUpMutationVariables
  >(UpsertFollowUpDocument, options);
}
export type UpsertFollowUpMutationHookResult = ReturnType<
  typeof useUpsertFollowUpMutation
>;
export type UpsertFollowUpMutationResult =
  ApolloReactCommon.MutationResult<UpsertFollowUpMutation>;
export type UpsertFollowUpMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpsertFollowUpMutation,
    UpsertFollowUpMutationVariables
  >;
export const AssignFollowUpToCaseDocument = /*#__PURE__*/ gql`
  mutation assignFollowUpToCase($caseId: Int!, $followUpId: Int!) {
    update_case(
      where: { id: { _eq: $caseId } }
      _set: { followUpId: $followUpId }
    ) {
      returning {
        id
      }
    }
  }
`;
export type AssignFollowUpToCaseMutationFn = ApolloReactCommon.MutationFunction<
  AssignFollowUpToCaseMutation,
  AssignFollowUpToCaseMutationVariables
>;

/**
 * __useAssignFollowUpToCaseMutation__
 *
 * To run a mutation, you first call `useAssignFollowUpToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignFollowUpToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignFollowUpToCaseMutation, { data, loading, error }] = useAssignFollowUpToCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      followUpId: // value for 'followUpId'
 *   },
 * });
 */
export function useAssignFollowUpToCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignFollowUpToCaseMutation,
    AssignFollowUpToCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AssignFollowUpToCaseMutation,
    AssignFollowUpToCaseMutationVariables
  >(AssignFollowUpToCaseDocument, options);
}
export type AssignFollowUpToCaseMutationHookResult = ReturnType<
  typeof useAssignFollowUpToCaseMutation
>;
export type AssignFollowUpToCaseMutationResult =
  ApolloReactCommon.MutationResult<AssignFollowUpToCaseMutation>;
export type AssignFollowUpToCaseMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AssignFollowUpToCaseMutation,
    AssignFollowUpToCaseMutationVariables
  >;
export const DeleteMiningProductDocument = /*#__PURE__*/ gql`
  mutation deleteMiningProduct($id: Int!) {
    delete_miningProduct(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
export type DeleteMiningProductMutationFn = ApolloReactCommon.MutationFunction<
  DeleteMiningProductMutation,
  DeleteMiningProductMutationVariables
>;

/**
 * __useDeleteMiningProductMutation__
 *
 * To run a mutation, you first call `useDeleteMiningProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMiningProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMiningProductMutation, { data, loading, error }] = useDeleteMiningProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMiningProductMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMiningProductMutation,
    DeleteMiningProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteMiningProductMutation,
    DeleteMiningProductMutationVariables
  >(DeleteMiningProductDocument, options);
}
export type DeleteMiningProductMutationHookResult = ReturnType<
  typeof useDeleteMiningProductMutation
>;
export type DeleteMiningProductMutationResult =
  ApolloReactCommon.MutationResult<DeleteMiningProductMutation>;
export type DeleteMiningProductMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteMiningProductMutation,
    DeleteMiningProductMutationVariables
  >;
export const UpsertSettingsDocument = /*#__PURE__*/ gql`
  mutation upsertSettings(
    $object: settings_insert_input!
    $updateColumns: [settings_update_column!]!
  ) {
    insert_settings_one(
      object: $object
      on_conflict: { constraint: settings_pkey, update_columns: $updateColumns }
    ) {
      id
    }
  }
`;
export type UpsertSettingsMutationFn = ApolloReactCommon.MutationFunction<
  UpsertSettingsMutation,
  UpsertSettingsMutationVariables
>;

/**
 * __useUpsertSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSettingsMutation, { data, loading, error }] = useUpsertSettingsMutation({
 *   variables: {
 *      object: // value for 'object'
 *      updateColumns: // value for 'updateColumns'
 *   },
 * });
 */
export function useUpsertSettingsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertSettingsMutation,
    UpsertSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpsertSettingsMutation,
    UpsertSettingsMutationVariables
  >(UpsertSettingsDocument, options);
}
export type UpsertSettingsMutationHookResult = ReturnType<
  typeof useUpsertSettingsMutation
>;
export type UpsertSettingsMutationResult =
  ApolloReactCommon.MutationResult<UpsertSettingsMutation>;
export type UpsertSettingsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpsertSettingsMutation,
    UpsertSettingsMutationVariables
  >;
export const AddSettingsToCaseDocument = /*#__PURE__*/ gql`
  mutation addSettingsToCase($caseId: Int!, $settingsId: Int!) {
    update_case_by_pk(
      pk_columns: { id: $caseId }
      _set: { settingsId: $settingsId }
    ) {
      id
    }
  }
`;
export type AddSettingsToCaseMutationFn = ApolloReactCommon.MutationFunction<
  AddSettingsToCaseMutation,
  AddSettingsToCaseMutationVariables
>;

/**
 * __useAddSettingsToCaseMutation__
 *
 * To run a mutation, you first call `useAddSettingsToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSettingsToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSettingsToCaseMutation, { data, loading, error }] = useAddSettingsToCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      settingsId: // value for 'settingsId'
 *   },
 * });
 */
export function useAddSettingsToCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddSettingsToCaseMutation,
    AddSettingsToCaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AddSettingsToCaseMutation,
    AddSettingsToCaseMutationVariables
  >(AddSettingsToCaseDocument, options);
}
export type AddSettingsToCaseMutationHookResult = ReturnType<
  typeof useAddSettingsToCaseMutation
>;
export type AddSettingsToCaseMutationResult =
  ApolloReactCommon.MutationResult<AddSettingsToCaseMutation>;
export type AddSettingsToCaseMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddSettingsToCaseMutation,
    AddSettingsToCaseMutationVariables
  >;
export const GetCasesDocument = /*#__PURE__*/ gql`
  query getCases($where: case_bool_exp) {
    case(order_by: { id: desc }, where: $where) {
      id
      name
      createdAt
      customer {
        id
        name
        country
      }
      user {
        id
        userId
        firstName
        lastName
      }
      dueDate
      expert {
        id
        firstName
        lastName
      }
      status
      crusherType
      salesforceOpportunityNumber
      __typename
    }
  }
`;

/**
 * __useGetCasesQuery__
 *
 * To run a query within a React component, call `useGetCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCasesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCasesQuery,
    GetCasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetCasesQuery, GetCasesQueryVariables>(
    GetCasesDocument,
    options,
  );
}
export function useGetCasesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCasesQuery,
    GetCasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetCasesQuery, GetCasesQueryVariables>(
    GetCasesDocument,
    options,
  );
}
export type GetCasesQueryHookResult = ReturnType<typeof useGetCasesQuery>;
export type GetCasesLazyQueryHookResult = ReturnType<
  typeof useGetCasesLazyQuery
>;
export type GetCasesQueryResult = ApolloReactCommon.QueryResult<
  GetCasesQuery,
  GetCasesQueryVariables
>;
export const GetCaseDocument = /*#__PURE__*/ gql`
  query getCase($id: Int!, $partSetWhere: partSet_bool_exp) {
    case: case_by_pk(id: $id) {
      id
      name
      customerId
      customer {
        ...CustomerFields
      }
      expert {
        id
        firstName
        lastName
      }
      crusherType
      crusherModel
      crusherCavityType
      crusherSerialNumber
      crusherCavityMaterial
      crusherThroughput
      crusherGrading
      crusherLifetimeConcave
      crusherLifetimeMantle
      crusherAdditionalInfo
      annualWearConsumptionMachine
      annualWearConsumptionProcess
      crusherCss
      crusherOss
      crusherSpeed
      crusherCounterShaftSpeed
      feedRockTestId
      feedAbrasiveness
      feedCrushabilityPercent
      feedOn
      rockType
      feedGradingMinSize
      feedGradingMaxSize
      feedSolidDensity
      feedMoisturePercent
      crusherStroke
      ringbounce
      ringbounceAdditionalInfo
      chokeFeed
      feedMethod
      powerDrawAvg
      powerDrawPeak
      pistonPressureAvg
      pistonPressurePeak
      throughputAvg
      throughputPeak
      improvementTargets
      improvementTargetsCrusherDuty
      improvementTargetsAdditionalInfo
      improvementTargetsOtherInfo
      lastEditedBy {
        firstName
        lastName
      }
      salesforceOpportunityNumber
      product
      targetThroughput
      currency
      operatingProfit
      numberOfCrushers
      operatingHoursPerDay
      operatingDaysPerYear
      operatingHoursPerYear
      targetMax
      targetMin
      targetOther
      status
      crusherForceOverload
      annualCrushingLineCapacity
      crusherRatedPower
      feedOreType
      feedMaxSize
      feedMinSize
      updatedAt
      additionalBasicInformation
      additionalCrusherInformation
      additionalChamberInformation
      additionalFeedInformation
      additionalAttachmentInformation
      miningProducts(order_by: { id: asc }) {
        ...MiningProductFields
      }
      phase
      user {
        id
        firstName
        lastName
      }
      feedCurveAttachments {
        ...AttachmentFields
      }
      caseReportAttachments {
        ...AttachmentFields
      }
      powerDrawAttachments {
        ...AttachmentFields
      }
      pistonPressureAttachments {
        ...AttachmentFields
      }
      throughputAttachments {
        ...AttachmentFields
      }
      flowsheetAttachments {
        ...AttachmentFields
      }
      generalSolutionAttachments {
        ...AttachmentFields
      }
      mantleSolutionAttachments {
        ...AttachmentFields
      }
      concaveSolutionAttachments {
        ...AttachmentFields
      }
      generalNewSolutionAttachments {
        ...AttachmentFields
      }
      mantleNewSolutionAttachments {
        ...AttachmentFields
      }
      concaveNewSolutionAttachments {
        ...AttachmentFields
      }
      partSets(where: $partSetWhere) {
        ...PartSetFields
      }
      grindingId
      grinding {
        ...GrindingFields
      }
      followUp {
        id
      }
      createdAt
      dueDate
      settings {
        id
        hideBackingConsumption
        disabledFields
      }
      __typename
    }
  }
  ${CustomerFieldsFragmentDoc}
  ${MiningProductFieldsFragmentDoc}
  ${AttachmentFieldsFragmentDoc}
  ${PartSetFieldsFragmentDoc}
  ${GrindingFieldsFragmentDoc}
`;

/**
 * __useGetCaseQuery__
 *
 * To run a query within a React component, call `useGetCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      partSetWhere: // value for 'partSetWhere'
 *   },
 * });
 */
export function useGetCaseQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCaseQuery,
    GetCaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetCaseQuery, GetCaseQueryVariables>(
    GetCaseDocument,
    options,
  );
}
export function useGetCaseLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCaseQuery,
    GetCaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetCaseQuery, GetCaseQueryVariables>(
    GetCaseDocument,
    options,
  );
}
export type GetCaseQueryHookResult = ReturnType<typeof useGetCaseQuery>;
export type GetCaseLazyQueryHookResult = ReturnType<typeof useGetCaseLazyQuery>;
export type GetCaseQueryResult = ApolloReactCommon.QueryResult<
  GetCaseQuery,
  GetCaseQueryVariables
>;
export const GetLightBasicValuesDocument = /*#__PURE__*/ gql`
  query getLightBasicValues($id: Int!) {
    case: case_by_pk(id: $id) {
      id
      name
      customer {
        ...CustomerFields
      }
      currency
      dueDate
      salesforceOpportunityNumber
      crusherType
      crusherModel
      numberOfCrushers
      operatingProfit
      operatingHoursPerDay
      operatingDaysPerYear
      miningProducts(order_by: { id: asc }) {
        ...MiningProductFields
      }
      grinding {
        ...GrindingFields
      }
    }
  }
  ${CustomerFieldsFragmentDoc}
  ${MiningProductFieldsFragmentDoc}
  ${GrindingFieldsFragmentDoc}
`;

/**
 * __useGetLightBasicValuesQuery__
 *
 * To run a query within a React component, call `useGetLightBasicValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLightBasicValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLightBasicValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLightBasicValuesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLightBasicValuesQuery,
    GetLightBasicValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetLightBasicValuesQuery,
    GetLightBasicValuesQueryVariables
  >(GetLightBasicValuesDocument, options);
}
export function useGetLightBasicValuesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLightBasicValuesQuery,
    GetLightBasicValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetLightBasicValuesQuery,
    GetLightBasicValuesQueryVariables
  >(GetLightBasicValuesDocument, options);
}
export type GetLightBasicValuesQueryHookResult = ReturnType<
  typeof useGetLightBasicValuesQuery
>;
export type GetLightBasicValuesLazyQueryHookResult = ReturnType<
  typeof useGetLightBasicValuesLazyQuery
>;
export type GetLightBasicValuesQueryResult = ApolloReactCommon.QueryResult<
  GetLightBasicValuesQuery,
  GetLightBasicValuesQueryVariables
>;
export const UserDocument = /*#__PURE__*/ gql`
  query user {
    user(where: { role: { _eq: "productLine" } }) {
      id
      firstName
      lastName
      country
      userId
      assignedCases_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserQuery,
    UserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
export function useUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserQuery,
    UserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<
  UserQuery,
  UserQueryVariables
>;
export const OwnersDocument = /*#__PURE__*/ gql`
  query owners {
    user(where: { cases: { ownerUserId: { _is_null: false } } }) {
      id
      firstName
      lastName
      country
      userId
    }
  }
`;

/**
 * __useOwnersQuery__
 *
 * To run a query within a React component, call `useOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOwnersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OwnersQuery,
    OwnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<OwnersQuery, OwnersQueryVariables>(
    OwnersDocument,
    options,
  );
}
export function useOwnersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OwnersQuery,
    OwnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<OwnersQuery, OwnersQueryVariables>(
    OwnersDocument,
    options,
  );
}
export type OwnersQueryHookResult = ReturnType<typeof useOwnersQuery>;
export type OwnersLazyQueryHookResult = ReturnType<typeof useOwnersLazyQuery>;
export type OwnersQueryResult = ApolloReactCommon.QueryResult<
  OwnersQuery,
  OwnersQueryVariables
>;
export const GetFilterCountriesDocument = /*#__PURE__*/ gql`
  query getFilterCountries {
    customer(distinct_on: country) {
      country
    }
  }
`;

/**
 * __useGetFilterCountriesQuery__
 *
 * To run a query within a React component, call `useGetFilterCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterCountriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetFilterCountriesQuery,
    GetFilterCountriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetFilterCountriesQuery,
    GetFilterCountriesQueryVariables
  >(GetFilterCountriesDocument, options);
}
export function useGetFilterCountriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFilterCountriesQuery,
    GetFilterCountriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetFilterCountriesQuery,
    GetFilterCountriesQueryVariables
  >(GetFilterCountriesDocument, options);
}
export type GetFilterCountriesQueryHookResult = ReturnType<
  typeof useGetFilterCountriesQuery
>;
export type GetFilterCountriesLazyQueryHookResult = ReturnType<
  typeof useGetFilterCountriesLazyQuery
>;
export type GetFilterCountriesQueryResult = ApolloReactCommon.QueryResult<
  GetFilterCountriesQuery,
  GetFilterCountriesQueryVariables
>;
export const GetFollowUpDocument = /*#__PURE__*/ gql`
  query getFollowUp($caseId: Int!) {
    followUp(where: { cases: { id: { _eq: $caseId } } }) {
      id
      measuredCapacity
      installationDate
      measuredWearLifeHours
      removalDate
      measuredWearLifeTonnes
      mantleChangeDate
      target
      feedback
      attachments {
        ...AttachmentFields
      }
    }
  }
  ${AttachmentFieldsFragmentDoc}
`;

/**
 * __useGetFollowUpQuery__
 *
 * To run a query within a React component, call `useGetFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowUpQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetFollowUpQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetFollowUpQuery,
    GetFollowUpQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetFollowUpQuery, GetFollowUpQueryVariables>(
    GetFollowUpDocument,
    options,
  );
}
export function useGetFollowUpLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFollowUpQuery,
    GetFollowUpQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetFollowUpQuery,
    GetFollowUpQueryVariables
  >(GetFollowUpDocument, options);
}
export type GetFollowUpQueryHookResult = ReturnType<typeof useGetFollowUpQuery>;
export type GetFollowUpLazyQueryHookResult = ReturnType<
  typeof useGetFollowUpLazyQuery
>;
export type GetFollowUpQueryResult = ApolloReactCommon.QueryResult<
  GetFollowUpQuery,
  GetFollowUpQueryVariables
>;
export const GetPageSettingsDocument = /*#__PURE__*/ gql`
  query getPageSettings($caseId: Int!) {
    settings(where: { cases: { id: { _eq: $caseId } } }) {
      id
      hideBackingConsumption
      disabledFields
    }
    case_by_pk(id: $caseId) {
      id
      crusherType
    }
  }
`;

/**
 * __useGetPageSettingsQuery__
 *
 * To run a query within a React component, call `useGetPageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageSettingsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetPageSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPageSettingsQuery,
    GetPageSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetPageSettingsQuery,
    GetPageSettingsQueryVariables
  >(GetPageSettingsDocument, options);
}
export function useGetPageSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPageSettingsQuery,
    GetPageSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetPageSettingsQuery,
    GetPageSettingsQueryVariables
  >(GetPageSettingsDocument, options);
}
export type GetPageSettingsQueryHookResult = ReturnType<
  typeof useGetPageSettingsQuery
>;
export type GetPageSettingsLazyQueryHookResult = ReturnType<
  typeof useGetPageSettingsLazyQuery
>;
export type GetPageSettingsQueryResult = ApolloReactCommon.QueryResult<
  GetPageSettingsQuery,
  GetPageSettingsQueryVariables
>;
export const Subscribe_To_CaseDocument = /*#__PURE__*/ gql`
  subscription subscribe_to_case($id: Int!) {
    case_by_pk(id: $id) {
      status
    }
  }
`;

/**
 * __useSubscribe_To_CaseSubscription__
 *
 * To run a query within a React component, call `useSubscribe_To_CaseSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribe_To_CaseSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribe_To_CaseSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscribe_To_CaseSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Subscribe_To_CaseSubscription,
    Subscribe_To_CaseSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    Subscribe_To_CaseSubscription,
    Subscribe_To_CaseSubscriptionVariables
  >(Subscribe_To_CaseDocument, options);
}
export type Subscribe_To_CaseSubscriptionHookResult = ReturnType<
  typeof useSubscribe_To_CaseSubscription
>;
export type Subscribe_To_CaseSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<Subscribe_To_CaseSubscription>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
};
export default result;
